// import React, { useEffect, useRef, useState } from 'react'
// import "./pararesult.css"
// import html2pdf from 'html2pdf.js';
// import { useParams } from 'react-router-dom';
// import axios from 'axios';
// import { message } from 'antd';
// function Pararesults() {
//     const { id } = useParams();
//     // const  id  = "66977549a7be420015bff77e"
//     const yourGutMap = {
//         "logo":"/paralogo.jpg",
//     }
//     const feelGut = {
//         "logo":"/logofg.png",
//     }
//     const rootCause = {
//         "logo":"/logorc.png",
//     }
//     const [reportStyle,setReportStyle] = useState(yourGutMap)

//     const [isPdfMode, setIsPdfMode] = useState(false);
//     const [kit, setkit] = useState({
//         "kitid": "loading...",
//         "patientName": "loading...",
//         "receiveddate": "loading...",
//         "resultDate": "loading...",
//         "result": [
//             { "Helicobacter pylori": "loading..." },
//             { "Plesiomonas shigelloides": "loading..." },
//             { "Clostridium difficile": "loading..." },
//             { "Enteroinvasive E. coli (EIEC)": "loading..." },
//             { "Yersinia enterocolitica": "loading..." },
//             { "Adenovirus": "loading..." },
//             { "Salmonella": "loading..." },
//             { "Astrovirus": "loading..." },
//             { "Campylobacter jejuni/coli": "loading..." },
//             { "Norovirus GI/GII": "loading..." },
//             { "Vibrio cholerae": "loading..." },
//             { "Rotavirus A": "loading..." },
//             { "E. coli O157": "loading..." },
//             { "Sapovirus (I,II,IV and V)": "loading..." },
//             { "Enteroaggregative E. coli (EAEC)": "loading..." },
//             { "Cryptosporidium spp.": "loading..." },
//             { "Enteropathogenic E. coli (EPEC)": "loading..." },
//             { "Cyclospora cayetanensis": "loading..." },
//             { "Enterotoxigenic E. coli (ETEC)": "loading..." },
//             { "Entamoeba histolytica": "loading..." },
//             { "Shigatoxin-producing E. coli (STEC)": "loading..." },
//             { "Giardia lamblia": "loading..." }
//         ],
//     });

//     const contentRef = useRef();

//     const getdata = async () => {


//         let data = JSON.stringify({
//             "_id": id
//         });

//         let config = {
//             method: 'post',
//             maxBodyLength: Infinity,
//             url: 'https://yourgutmap-food-sensitivity-423a2af84621.herokuapp.com/viewreportdata',
//             headers: {
//                 'Content-Type': 'application/json'
//             },
//             data: data
//         };

//         axios.request(config)
//             .then(async (response) => {
//                 await setkit(response.data);
//                 if (response.data.result.find(item => item['Helicobacter pylori'])) {
//                     await setIsPdfMode(false)
//                 }
//                 else{
//                     await setIsPdfMode(true)
//                 }
//             })
//             .catch((error) => {
//                 console.log(error);
//             });


//     }



//     useEffect(() => {


//         getdata()


//     }, [])


//     useEffect( () => {
//         if (kit.kitid !== "loading..." && isPdfMode === false) {
//              kit.reportstyle === 'YourGutMap Report Style' ? setReportStyle(yourGutMap) : kit.reportstyle === 'Root Cause Report Style' ? setReportStyle(rootCause) : setReportStyle(feelGut) }
//             }, [kit])

//     useEffect(() => {
//         if(kit.kitid !== "loading..." && isPdfMode === false){

//             handleDownloadPDF();
//         }
//     }, [reportStyle])



//     const handleDownloadPDF = async () => {
//         const namekit = document.querySelector('.namekit')
//         if(namekit && reportStyle.logo===yourGutMap.logo){
//             namekit.classList.add('download-margin')
//         }
//         const hide = message.loading("Your report is downloading...", 0);
//         const content = await document.getElementById('ali'); // Replace with the ID of the content you want to export
//         console.log(content)

//         const opt = {
//             margin: 0,
//             filename: "YourGutMap - Parasitology result " + kit.kitid + ".pdf",
//             image: { type: 'jpeg', quality: 1 },
//             html2canvas: { scale: 2 },
//             jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
//         };

//         const seee = html2pdf().from(content).set(opt).outputPdf();



//         seee.save("YourGutMap - Parasitology result " + kit.kitid + ".pdf")


//         await setTimeout(() => {
//             hide(); // Call hide to stop the loading message
//             message.success("Report has been downloaded Successfully!");
//         }, 0);
//         if(namekit && reportStyle.logo===yourGutMap.logo){
//             namekit?.classList.remove('download-margin')
//         }

//     };






//     return (<>


//         <div
//             className="mainnnnnnnnn"
//             style={{
//                 display: !isPdfMode ? "flex" : "block",
//             }}
//         >
//             {!isPdfMode && <>


//                 <button style={{ top: "202mm",marginTop:"60px"}} className='downloadbuttonviewreport' onClick={handleDownloadPDF}>Download</button>

//             </>}
//             <div id='ali'>

//                 {isPdfMode ? (<>

//                     <iframe
//                         // src={kit.result[1].url}
//                         src={kit.result.find(item=>item['url']).url}
//                         style={{ width: "95%", height: "98vh" }}
//                     />
//                     {/* {alert(kit.result)} */}
//                     {/* {console.log(kit.result)} */}
//                 </>) : (<>


//                     <div className="firstdiv" >
//                         <div className="firstdivhead">

//                             {reportStyle.logo === yourGutMap.logo ? <img src="/logo2.png" alt="" style={{ marginTop: '10px' }} /> : null}


//                             {/* <img src="/uper.png" alt="" />  */}
//                             {reportStyle.logo === yourGutMap.logo ? <img src="/uper.png" alt="" /> : null}
//                         </div>
//                         <div className="firstdivcenter" style={{display:"flex",flexDirection:"column",marginTop:reportStyle.logo === feelGut.logo ?'290px' :"245px"}}>

//                             {/* <img src='/paralogo.jpg' alt='' /> */}
//                             <img src={reportStyle.logo} width={reportStyle.logo === feelGut.logo ?'400px' : null} style={{marginBottom:reportStyle.logo === yourGutMap.logo ? "120px" : null}} alt='' />
//                             {reportStyle.logo === feelGut.logo ? <h4 style={{color:"#003074",fontSize:"17",fontWeight:"bold",marginBottom:"80px"}}>Advanced Parasitology Test</h4> : null}
//                         </div>

//                         <h1 className='testreport_heading'>Test Report</h1>
//                         <div className='' style={{ color: '#6E4E9F', marginBottom:"190px" }}>
//                             <div className='namekit'>
//                             <h2>Name   : {kit.patientName}</h2>
//                             <h2>Kit ID : {kit.kitid}</h2>
//                             </div>
//                         <div className="firstdivend" style={{marginTop:"266px"}}>

//                             {/* <img src="/lower.png" alt="" /> */}
//                             {reportStyle.logo === yourGutMap.logo ? <img src="/lower.png" alt="" /> : null}
//                         </div>
//                         </div>




//                     </div>

//                     <div className="secenddiv">
//                         {reportStyle.logo===yourGutMap.logo ?  <div className="firstdivhead">
//                             {reportStyle.logo === yourGutMap.logo ? <img src="/logo2.png" alt="" style={{ marginTop: '10px' }} /> : null}
//                             {reportStyle.logo === yourGutMap.logo ? <img src="/uper.png" alt="" /> : null}
//                         </div> : null}



//                         <div className="secenddivcenter" style={{marginTop:reportStyle.logo===feelGut.logo?"40px" : "0px "}}>

//                             <div className="report">
//                                 <h2>Gastrointestinal Test Report</h2>
//                             </div>
//                             <div className="reporttext">
//                                 <div className="reportleft">
//                                     <span>
//                                         <h4>sample ID:</h4>
//                                         <h5>{kit.kitid}</h5>
//                                         <h4> Specimen:</h4>
//                                         <h5 style={{ borderTop: "1px solid #fff" }}>Fecal - Native</h5>
//                                     </span>
//                                     <span>

//                                         <h4>Received Date:</h4>
//                                         <h5>{kit.receiveddate}</h5>
//                                         <h4> Completed Date:</h4>
//                                         <h5>{kit.resultDate}</h5>
//                                     </span>

//                                     {/* <span>

//                                 <h4>Received Date:</h4>
//                                 <h5>2024-10-07 10:45:00</h5>
//                                 <h4> Completed Date:</h4>
//                             </span> */}

//                                 </div>
//                                 {/* <div className="reportright">
//                             <h4>Fecal - Native</h4>
//                             <h4>2024-10-10 13:09:39</h4>
//                         </div> */}


//                             </div>

//                             <div className="maindivvvv">


//                                 <div className="maindivvvvleft">
//                                     <div className="result"><h2>Test Result</h2></div>
//                                     <div className="boxhead">
//                                         <h4>Pathogenic Bacteria
//                                         </h4>

//                                     </div>
//                                     <div className="box">


//                                         <table>
//                                             <tbody>
//                                                 <tr className={kit.result.find(item => item['Helicobacter pylori'])?.["Helicobacter pylori"] === "detected" ? 'colorchange' : ""}>
//                                                     <td >Helicobacter pylori</td>
//                                                     <td  >{kit.result.find(item => item['Helicobacter pylori'])?.["Helicobacter pylori"]}</td>
//                                                 </tr>

//                                                 <tr className={kit.result.find(item => item['Clostridium difficile'])?.["Clostridium difficile"] === "detected" ? 'colorchange' : ""}>

//                                                     <td>Clostridium difficile</td>
//                                                     <td   >{kit.result.find(item => item['Clostridium difficile'])?.["Clostridium difficile"]}</td>
//                                                 </tr>

//                                                 <tr className={kit.result.find(item => item['Plesiomonas shigelloides'])?.["Plesiomonas shigelloides"] === "detected" ? 'colorchange' : ""}>
//                                                     <td>plesiomonas shigelloides</td>
//                                                     <td>{kit.result.find(item => item['Plesiomonas shigelloides'])?.["Plesiomonas shigelloides"]}</td>
//                                                 </tr>


//                                                 <tr className={kit.result.find(item => item['Salmonella'])?.["Salmonella"] === "detected" ? 'colorchange' : ""}>
//                                                     <td>Salmonella</td>
//                                                     <td>{kit.result.find(item => item['Salmonella'])?.["Salmonella"]}</td>
//                                                 </tr>


//                                             </tbody>


//                                             <tbody>



//                                                 <tr className={kit.result.find(item => item['Yersinia enterocolitica'])?.["Yersinia enterocolitica"] === "detected" ? 'colorchange' : ""}>

//                                                     <td>Yersinia enterocolitica</td>
//                                                     <td>{kit.result.find(item => item['Yersinia enterocolitica'])?.["Yersinia enterocolitica"]}</td>
//                                                 </tr>
//                                                 <tr className={kit.result.find(item => item['Campylobacter jejuni/coli'])?.["Campylobacter jejuni/coli"] === "detected" ? 'colorchange' : ""}>
//                                                     <td>Campylobacter jejuni/coli</td>
//                                                     <td>{kit.result.find(item => item['Campylobacter jejuni/coli'])?.["Campylobacter jejuni/coli"]}</td>
//                                                 </tr>

//                                                 <tr className={kit.result.find(item => item['Vibrio cholerae'])?.["Vibrio cholerae"] === "detected" ? 'colorchange' : ""}>

//                                                     <td>Vibrio cholerae</td>
//                                                     <td>{kit.result.find(item => item['Vibrio cholerae'])?.["Vibrio cholerae"]}</td>
//                                                 </tr>


//                                                 <tr className={kit.result.find(item => item['E. coli O157'])?.["E. coli O157"] === "detected" ? 'colorchange' : ""}>
//                                                     <td>E. coli O157</td>
//                                                     <td>{kit.result.find(item => item['E. coli O157'])?.["E. coli O157"]}</td>
//                                                 </tr>

//                                             </tbody>


//                                             <tbody>




//                                                 <tr className={kit.result.find(item => item['Enteroaggregative E. coli (EAEC)'])?.["Enteroaggregative E. coli (EAEC)"] === "detected" ? 'colorchange' : ""}>

//                                                     <td>Enteroaggregative E. coli (EAEC) </td>
//                                                     <td > {kit.result.find(item => item['Enteroaggregative E. coli (EAEC)'])?.["Enteroaggregative E. coli (EAEC)"]}</td>
//                                                 </tr>
//                                                 <tr className={kit.result.find(item => item['Enteropathogenic E. coli (EPEC)'])?.["Enteropathogenic E. coli (EPEC)"] === "detected" ? 'colorchange' : ""}>
//                                                     <td>Enteropathogenic E. coli (EPEC) </td>
//                                                     <td>{kit.result.find(item => item['Enteropathogenic E. coli (EPEC)'])?.["Enteropathogenic E. coli (EPEC)"]}</td>
//                                                 </tr>

//                                                 <tr className={kit.result.find(item => item['Enterotoxigenic E. coli (ETEC)'])?.["Enterotoxigenic E. coli (ETEC)"] === "detected" ? 'colorchange' : ""}>

//                                                     <td>Enterotoxigenic E. coli (ETEC) LT</td>
//                                                     <td>{kit.result.find(item => item['Enterotoxigenic E. coli (ETEC)'])?.["Enterotoxigenic E. coli (ETEC)"]}</td>
//                                                 </tr>

//                                                 <tr className={kit.result.find(item => item['Shigatoxin-producing E. coli (STEC)'])?.["Shigatoxin-producing E. coli (STEC)"] === "detected" ? 'colorchange' : ""}>
//                                                     <td>Shiga-Toxin-producing E. coli (STEC) </td>
//                                                     <td>{kit.result.find(item => item['Shigatoxin-producing E. coli (STEC)'])?.["Shigatoxin-producing E. coli (STEC)"]}</td>
//                                                 </tr>

//                                             </tbody>



//                                             <tbody>


//                                                 <tr className={kit.result.find(item => item['Enteroinvasive E. coli (EIEC)'])?.["Enteroinvasive E. coli (EIEC)"] === "detected" ? 'colorchange' : ""}>
//                                                     <td>Enteroinvasive E. coli (EIEC) </td>
//                                                     <td>{kit.result.find(item => item['Enteroinvasive E. coli (EIEC)'])?.["Enteroinvasive E. coli (EIEC)"]}</td>
//                                                 </tr>



//                                             </tbody>



//                                         </table>


//                                     </div>





//                                     <div className="boxhead">
//                                         <h4> Viruses                                    </h4>

//                                     </div>
//                                     <div className="box">


//                                         <table>



//                                             <tbody>





//                                                 <tr className={kit.result.find(item => item['Adenovirus'])?.["Adenovirus"] === "detected" ? 'colorchange' : ""}>
//                                                     <td>Adenovirus </td>
//                                                     <td>{kit.result.find(item => item['Adenovirus'])?.["Adenovirus"]}</td>
//                                                 </tr>

//                                                 <tr className={kit.result.find(item => item['Astrovirus'])?.["Astrovirus"] === "detected" ? 'colorchange' : ""}>
//                                                     <td>Astrovirus</td>
//                                                     <td >{kit.result.find(item => item['Astrovirus'])?.["Astrovirus"]}</td>
//                                                 </tr>
//                                                 <tr className={kit.result.find(item => item['Norovirus GI/GII'])?.["Norovirus GI/GII"] === "detected" ? 'colorchange' : ""}>
//                                                     <td>Norovirus GI/GII</td>
//                                                     <td>{kit.result.find(item => item['Norovirus GI/GII'])?.["Norovirus GI/GII"]}</td>
//                                                 </tr>
//                                                 <tr className={kit.result.find(item => item['Rotavirus A'])?.["Rotavirus A"] === "detected" ? 'colorchange' : ""}>
//                                                     <td>Rotavirus A</td>
//                                                     <td>{kit.result.find(item => item['Rotavirus A'])?.["Rotavirus A"]}</td>
//                                                 </tr>

//                                             </tbody>

//                                             <tbody>






//                                                 <tr className={kit.result.find(item => item['Sapovirus (I,II,IV and V)'])?.["Sapovirus (I,II,IV and V)"] === "detected" ? 'colorchange' : ""}>
//                                                     <td>Sapovirus (I, II, IV, and V)</td>
//                                                     <td>{kit.result.find(item => item['Sapovirus (I,II,IV and V)'])?.["Sapovirus (I,II,IV and V)"]}</td>
//                                                 </tr>

//                                             </tbody>



//                                         </table>


//                                     </div>



//                                     <div className="boxhead">
//                                         <h4>Parasites</h4>

//                                     </div>
//                                     <div className="box">


//                                         <table>



//                                             <tbody>







//                                                 <tr className={kit.result.find(item => item['Cryptosporidium spp.'])?.["Cryptosporidium spp."] === "detected" ? 'colorchange' : ""}>
//                                                     <td>Cryptosporidium spp.</td>
//                                                     <td>{kit.result.find(item => item['Cryptosporidium spp.'])?.["Cryptosporidium spp."]}</td>
//                                                 </tr>
//                                                 <tr className={kit.result.find(item => item['Cyclospora cayetanensis'])?.["Cyclospora cayetanensis"] === "detected" ? 'colorchange' : ""}>
//                                                     <td>Cyclospora cayetanensis</td>
//                                                     <td>{kit.result.find(item => item['Cyclospora cayetanensis'])?.["Cyclospora cayetanensis"]}</td>
//                                                 </tr>
//                                                 <tr className={kit.result.find(item => item['Entamoeba histolytica'])?.["Entamoeba histolytica"] === "detected" ? 'colorchange' : ""}>
//                                                     <td>Entamoeba histolytica</td>
//                                                     <td>{kit.result.find(item => item['Entamoeba histolytica'])?.["Entamoeba histolytica"]}</td>
//                                                 </tr>
//                                                 <tr className={kit.result.find(item => item['Giardia lamblia'])?.["Giardia lamblia"] === "detected" ? 'colorchange' : ""}>
//                                                     <td>Giardia lamblia</td>
//                                                     <td>{kit.result.find(item => item['Giardia lamblia'])?.["Giardia lamblia"]}</td>
//                                                 </tr>
//                                             </tbody>



//                                         </table>


//                                     </div>


//                                 </div>














//                             </div>

//                             <div className="information">
//                                 <div className="report">
//                                     <h3>Test Information</h3>

//                                 </div>
//                                 <div className="informationtext">
//                                     <p> <strong>Methodology: </strong>Laboratory specimens associated with this report were analyzed using molecular techniques. Total nucleic
//                                         acids were extracted from the submitted sample and analyzed by PCR amplification using real-time qPCR. Endogenous and
//                                         exogenous controls run simultaneously with patient samples ensure the correct operation of the extraction and PCR steps of
//                                         this assay</p>
//                                     <p><strong>Disclaimer: </strong> Results should be used in conjunction with clinical findings, and should not form the sole basis for a diagnosis or
//                                         treatment decision. Negative results do not preclude pathogenic infection and should not be used as the sole basis for
//                                         patient management decisions. Negative results must be combined with clinical observations, patient history, and
//                                         epidemiological information.</p>
//                                 </div>
//                             </div>

//                         </div>


//                         <div className="secenddivend">

//                             {/* <img src="/lower.png" alt="" /> */}
//                             {reportStyle.logo === yourGutMap.logo ? <img src="/lower.png" alt="" /> : null}
//                         </div>



//                     </div>






//                     {/* Helicobacter pylori * */}
//                     {kit.result.find(item => item['Helicobacter pylori'])?.["Helicobacter pylori"] === "detected" && <>
//                         <div className="lastdiv">
//                             <div className="firstdivhead">
//                                 {reportStyle.logo === yourGutMap.logo ? <img src="/logo2.png" alt="" style={{ marginTop: '10px' }} /> : null}
//                                 <img src="/uper.png" alt="" />



//                             </div>
//                             <div className="lastdivcenter">
//                                 <h1 style={{ color: "red" }}>Detected</h1>
//                                 <div className="texthead">

//                                     <h2>Helicobacter pylori</h2>


//                                 </div>

//                                 <div className="lastdivtext">

//                                     <p> <strong>About <br /></strong>
//                                         H. pylori is a tiny, spiral-shaped bacterium. It has flagella (bacterial tail), which allows it to move
//                                         about and attach itself to the stomach lining, where it's able to survive in the acidic environment
//                                         of the stomach. Whilst carrying this bacteria often causes no symptoms at all for many people, it
//                                         can play a large contribution to stomach pain, ulcers as well as a number of digestive issues (1).
//                                         That said, H.pylori is a bacterium that is normal in low numbers and it is when this bacterium
//                                         over colonises the stomach is where potential problems can occur.</p>

//                                     <p><strong>Advice<br /></strong>
//                                         There are also a number of dietary supplements shown to be helpful in the treatment of H.
//                                         pylori, including: Berberine, Goldenseal, Oregano oil, Mastic gum, DGL licorice, Zinc carnosine,
//                                         propolis, Green tea, Garlic and Probiotics. Using the below treatments has been shown to be
//                                         effective in up to 70% of cases (2,3,4,5). One particular study found efficacy with the following
//                                         protocol:</p>

//                                     <p>
//                                         <ul>
//                                             <li>Mastic gum 500mg, 3 times daily</li>
//                                             <li> ADP oregano 50mg, 3 times daily</li>
//                                             <li>  Pepto bismol 4-6 tabs between meals daily</li>
//                                             <li>  Broad Spectrum Probiotic 5 billion, twice daily</li>
//                                             <li>  Fibre Blend supplement 14g/day (Psyllium Husk, etc)</li>
//                                         </ul>
//                                     </p>

//                                     <p>Our treatment and advice suggestions have been devised by Nutritional Therapists and
//                                         Functional Medicine Practitioners. Any treatment protocol should only be undertaken under the
//                                         supervision of a Healthcare Practitioner.<br />
//                                         For persistent and/or serious symptoms, it is recommended to speak to your Doctor.
//                                     </p>


//                                 </div>
//                                 <div style={{ display: 'flex', justifyContent: 'center' }}>
//                                     <img style={{ marginTop: '5mm' }} src='/imgggg.pngg' alt="" />
//                                 </div>

//                             </div>




//                             <div className="secenddivend">

//                                 {/* <img src="/lower.png" alt="" /> */}
//                                 {reportStyle.logo === yourGutMap.logo ? <img src="/lower.png" alt="" /> : null}
//                             </div>

//                         </div>
//                     </>}





//                     {/* Clostridium difficile* */}
//                     {kit.result.find(item => item['Clostridium difficile'])?.["Clostridium difficile"] === "detected" && <>
//                         <div className="lastdiv">
//                             <div className="firstdivhead">
//                                 {reportStyle.logo === yourGutMap.logo ? <img src="/logo2.png" alt="" style={{ marginTop: '10px' }} /> : null}
//                                 {/* <img src="/uper.png" alt="" /> */}
//                                 {reportStyle.logo === yourGutMap.logo ? <img src="/uper.png" alt="" /> : null}



//                             </div>
//                             <div className="lastdivcenter">
//                                 <h1 style={{ color: "red" }}>Detected</h1>
//                                 <div className="texthead">

//                                     <h2>Clostridium difficile</h2>


//                                 </div>

//                                 <div className="lastdivtext">

//                                     <p> <strong>About <br /></strong>
//                                         Clostridium difficile is an anaerobic, spore-forming, Gram-positive bacterium, the most common
//                                         pathogen that can cause antibiotic-associated diarrhoea. Normal gut flora usually resists
//                                         colonisation and overgrowth of C. difficile. Subsequent inflammatory activation in addition to the
//                                         direct toxin-associated damage resulting in mild diarrheal disease up to extensive intestinal wall
//                                         damage. The incidences of C. difficile infection (CDI) in developed countries have become
//                                         increasingly high which may be attributed to the emergence of newer epidemic strains,
//                                         extensive use of antibiotics, and limited alternative therapies.</p>

//                                     <p><strong>Advice<br /></strong>
//                                         Virgin coconut oil is found to have an antimicrobial activity. The active fatty acids have been
//                                         tested for their antimicrobial potential against C. difficile in vitro trail. The results have shown the
//                                         inhibitory effects on growth.</p>

//                                     <p>
//                                         In a recently published study, researchers have investigated both herbal extracts of Black seed
//                                         soil and Myrrh for their antibacterial activity against two strains of C. difficile. The study found
//                                         that Black Seed Seed oil (2%) and Myrrh water extract are effective natural antibacterial agents
//                                         to inhibit C. difficile (1). One particular case study used black seed oil, bentonite clay, and
//                                         Lactobacillus probiotics to eradicate the infection in a 2 year old (2)
//                                     </p>

//                                     <p>Our treatment and advice suggestions have been devised by Nutritional Therapists and
//                                         Functional Medicine Practitioners. Any treatment protocol should only be undertaken under the
//                                         supervision of a Healthcare Practitioner.<br />
//                                         For persistent and/or serious symptoms, it is recommended to speak to your Doctor.
//                                     </p>


//                                 </div>
//                                 <div style={{ display: 'flex', justifyContent: 'center' }}>
//                                     <img style={{ marginTop: '5mm' }} src='/imgggg.pngg' alt="" />
//                                 </div>

//                             </div>




//                             <div className="secenddivend">

//                                 {/* <img src="/lower.png" alt="" /> */}
//                                 {reportStyle.logo === yourGutMap.logo ? <img src="/lower.png" alt="" /> : null}
//                             </div>

//                         </div>
//                     </>}




//                     {/* plesiomonas shigelloides* */}
//                     {kit.result.find(item => item['Plesiomonas shigelloides'])?.["Plesiomonas shigelloides"] === "detected" && <>
//                         <div className="lastdiv">
//                             <div className="firstdivhead">
//                                 {reportStyle.logo === yourGutMap.logo ? <img src="/logo2.png" alt="" style={{ marginTop: '10px' }} /> : null}
//                                 <img src="/uper.png" alt="" />



//                             </div>
//                             <div className="lastdivcenter">
//                                 <h1 style={{ color: "red" }}>Detected</h1>
//                                 <div className="texthead">

//                                     <h2>Plesiomonas shigelloides</h2>


//                                 </div>

//                                 <div className="lastdivtext">

//                                     <p> <strong>About <br /></strong>
//                                         Recent studies have suggested that Plesiomonas shigelloides is a cause of diarrhea and
//                                         abdominal pain. Plesiomonas shigelloides is an anaerobic gram-negative bacillus commonly
//                                         found in aquatic environments. It is an important pathogen of fish and has been implicated as a
//                                         cause of enteric disease in humans, especially following the consumption of raw seafood. Most
//                                         cases are usually obtained through tropical travel but can also be obtained locally from
//                                         untreated water and/or seafood consumption. </p>

//                                     <p><strong>Advice<br /></strong>
//                                         Infection of Plesiomonas shigelloides are often mild and may not always need treatments, apart
//                                         from natural fluid & electrolyte support. For more chronic or severe cases, then some
//                                         practitioners may recommend antibiotic therapy </p>


//                                     <p>Our treatment and advice suggestions have been devised by Nutritional Therapists and
//                                         Functional Medicine Practitioners. Any treatment protocol should only be undertaken under the
//                                         supervision of a Healthcare Practitioner.<br />
//                                         For persistent and/or serious symptoms, it is recommended to speak to your Doctor.
//                                     </p>


//                                 </div>
//                                 <div style={{ display: 'flex', justifyContent: 'center' }}>
//                                     <img style={{ marginTop: '5mm' }} src='/imgggg.pngg' alt="" />
//                                 </div>

//                             </div>




//                             <div className="secenddivend">

//                             {reportStyle.logo === yourGutMap.logo ? <img src="/lower.png" alt="" /> : null}
//                                 {/* <img src="/lower.png" alt="" /> */}
//                             </div>

//                         </div>
//                     </>}




//                     {/*Salmonella **/}
//                     {kit.result.find(item => item['Salmonella'])?.["Salmonella"] === "detected" && <>
//                         <div className="lastdiv">
//                             <div className="firstdivhead">
//                                 {reportStyle.logo === yourGutMap.logo ? <img src="/logo2.png" alt="" style={{ marginTop: '10px' }} /> : null}
//                                 {/* <img src="/uper.png" alt="" /> */}
//                                 {reportStyle.logo === yourGutMap.logo ? <img src="/uper.png" alt="" /> : null}



//                             </div>
//                             <div className="lastdivcenter">
//                                 <h1 style={{ color: "red" }}>Detected</h1>
//                                 <div className="texthead">

//                                     <h2>Salmonella (Genus Group)</h2>


//                                 </div>

//                                 <div className="lastdivtext">

//                                     <p> <strong>About <br /></strong>
//                                         Salmonella is a type of bacteria commonly found in the intestines of animals and humans,
//                                         where it can sometimes cause infections. When introduced into the human digestive tract, often
//                                         through contaminated food or water, it can lead to an illness known as salmonellosis. This
//                                         infection causes symptoms like diarrhoea, fever, and abdominal cramps as the bacteria invade
//                                         and inflame the gut lining. While most cases resolve on their own, severe infections may require
//                                         medical treatment, particularly in young children, the elderly, or those with weakened immune
//                                         systems. </p>

//                                     <p><strong>Advice<br /></strong>
//                                         <strong>Hydration:</strong> The primary treatment is rehydration. Since diarrhoea can lead to fluid loss, drinking
//                                         plenty of water or oral rehydration solutions is essential to prevent dehydration.
//                                         <br />  <strong> Rest:</strong> Resting allows the body to focus its energy on fighting the infection.
//                                         <br />   <strong> Diet:</strong> Eating light, bland foods (like bananas, rice, applesauce, and toast) can help ease
//                                         symptoms and prevent irritation of the gut.
//                                         <br />  <strong>Medication:</strong>  In severe cases, especially when the infection spreads beyond the intestines or in
//                                         vulnerable groups (infants, elderly, or immunocompromised), antibiotics may be prescribed.
//                                         However, antibiotics are typically avoided in mild cases, as they can prolong the time
//                                         Salmonella bacteria stay in the body. </p>

//                                     <p>
//                                         If symptoms persist for more than a week, are severe, or if there are signs of dehydration (such
//                                         as dry mouth, reduced urination, or dizziness), seeking medical attention is advised.
//                                     </p>



//                                     <p>Our treatment and advice suggestions have been devised by Nutritional Therapists and
//                                         Functional Medicine Practitioners. Any treatment protocol should only be undertaken under the
//                                         supervision of a Healthcare Practitioner.<br />
//                                         For persistent and/or serious symptoms, it is recommended to speak to your Doctor.
//                                     </p>


//                                 </div>
//                                 <div style={{ display: 'flex', justifyContent: 'center' }}>
//                                     <img style={{ marginTop: '5mm' }} src='/imgggg.pngg' alt="" />
//                                 </div>

//                             </div>




//                             <div className="secenddivend">

//                                 {/* <img src="/lower.png" alt="" /> */}
//                                 {reportStyle.logo === yourGutMap.logo ? <img src="/lower.png" alt="" /> : null}
//                             </div>

//                         </div>
//                     </>}





//                     {/* Yersinia enterocolitica* */}
//                     {kit.result.find(item => item['Yersinia enterocolitica'])?.["Yersinia enterocolitica"] === "detected" && <>
//                         <div className="lastdiv">
//                             <div className="firstdivhead">
//                                 {reportStyle.logo === yourGutMap.logo ? <img src="/logo2.png" alt="" style={{ marginTop: '10px' }} /> : null}
//                                 {/* <img src="/uper.png" alt="" /> */}
//                                 {reportStyle.logo === yourGutMap.logo ? <img src="/uper.png" alt="" /> : null}



//                             </div>
//                             <div className="lastdivcenter">
//                                 <h1 style={{ color: "red" }}>Detected</h1>
//                                 <div className="texthead">

//                                     <h2>Yersinia Enterocolitica</h2>


//                                 </div>

//                                 <div className="lastdivtext">

//                                     <p> <strong>About <br /></strong>
//                                         Yersinia enterocolitica is a gram-negative bacteria that causes yersiniosis usually caused by
//                                         drinking contaminated milk or water or eating raw or undercooked meat, usually pork (chitlins).
//                                         Human-to-human infection is possible or from a blood transfusion.Yersinia enterocolitica is
//                                         primarily known to cause acute inflammation in the gut. This bacteria infects the intestines
//                                         causing diarrhoea (usually watery or bloody), vomiting, abdominal pain, and fever which lasts
//                                         about 4-7 days but can last up to three weeks. Many infected individuals will suspect having
//                                         food poisoning and usually symptoms disappear within a few days and if not, medical attention
//                                         may be required. </p>

//                                     <p><strong>Advice<br /></strong>
//                                         <strong>Hydration:</strong> The primary treatment is rehydration. Since  The microbiome rebalancing foods will help to rebalance the microbiome, making it more
//                                         resilient against pathogenic parasites. If symptoms last longer than 1 week then an antimicrobial
//                                         such as berberine or herbs high in chlorogenic acid (Green tea, elderflower,
//                                         rosemary).<a href='https://www.ncbi.nlm.nih.gov/pmc/articles/PMC9117966/'>https://www.ncbi.nlm.nih.gov/pmc/articles/PMC9117966/</a>
//                                         If symptoms are severe and persist after 8 weeks, then referral to a Doctor may be necessary. </p>

//                                     <p>
//                                         If symptoms persist for more than a week, are severe, or if there are signs of dehydration (such
//                                         as dry mouth, reduced urination, or dizziness), seeking medical attention is advised.
//                                     </p>



//                                     <p>Our treatment and advice suggestions have been devised by Nutritional Therapists and
//                                         Functional Medicine Practitioners. Any treatment protocol should only be undertaken under the
//                                         supervision of a Healthcare Practitioner.<br />
//                                         For persistent and/or serious symptoms, it is recommended to speak to your Doctor.
//                                     </p>


//                                 </div>
//                                 <div style={{ display: 'flex', justifyContent: 'center' }}>
//                                     <img style={{ marginTop: '5mm' }} src='/imgggg.pngg' alt="" />
//                                 </div>

//                             </div>




//                             <div className="secenddivend">

//                                 {/* <img src="/lower.png" alt="" /> */}
//                                 {reportStyle.logo === yourGutMap.logo ? <img src="/lower.png" alt="" /> : null}
//                             </div>

//                         </div>
//                     </>}





//                     {/* Campylobacter jejuni/coli* */}
//                     {kit.result.find(item => item['Campylobacter jejuni/coli'])?.["Campylobacter jejuni/coli"] === "detected" && <>
//                         <div className="lastdiv">
//                             <div className="firstdivhead">
//                                 {reportStyle.logo === yourGutMap.logo ? <img src="/logo2.png" alt="" style={{ marginTop: '10px' }} /> : null}
//                                 {/* <img src="/uper.png" alt="" /> */}
//                                 {reportStyle.logo === yourGutMap.logo ? <img src="/uper.png" alt="" /> : null}



//                             </div>
//                             <div className="lastdivcenter">
//                                 <h1 style={{ color: "red" }}>Detected</h1>
//                                 <div className="texthead">

//                                     <h2>Campylobacter jejuni/coli</h2>


//                                 </div>

//                                 <div className="lastdivtext">

//                                     <p> <strong>About <br /></strong>
//                                         <strong> Campylobacter jejuni</strong> and <strong>Campylobacter coli</strong> are bacterial species that are among the most
//                                         common causes of foodborne illnesses in humans worldwide. Both belong to the genus
//                                         <strong> Campylobacter,</strong> which includes several species known to cause <strong>gastroenteritis</strong>, or
//                                         inflammation of the stomach and intestines, leading to symptoms like diarrhoea, abdominal
//                                         pain, and fever. </p>

//                                     <p><strong>Advice<br /></strong>
//                                         <strong>  Consume Anti-inflammatory Foods</strong>
//                                         <ul style={{ margin: "0" }}>
//                                             <li> <strong> Ginger:</strong>  Known for its anti-inflammatory and antimicrobial properties, ginger tea can help
//                                                 soothe an irritated gut and alleviate nausea.</li>
//                                             <li>  <strong> Turmeric:</strong>  This spice has anti-inflammatory and antioxidant properties. Adding a small
//                                                 amount to food or taking it as a supplement may help reduce inflammation.</li>
//                                             <li>  <strong> Garlic:</strong>  With natural antibacterial properties, garlic can support the immune system;
//                                                 however, it should be eaten in small amounts as it can be irritating to some people’s
//                                                 stomachs.</li>

//                                         </ul>




//                                         <strong>   Eat Easily Digestible Foods</strong>
//                                         <ul style={{ margin: "0" }}>
//                                             <li> Stick to a<strong>  BRAT diet</strong>   (bananas, rice, applesauce, and toast) to avoid irritating the
//                                                 digestive tract.</li>
//                                             <li>  Include  <strong>  plain boiled potatoes, bone broth, and oatmeal, </strong>  which are gentle on the
//                                                 stomach and provide essential nutrients.</li>


//                                         </ul>

//                                         <strong>    Rest</strong>
//                                         <ul style={{ margin: "0" }}>
//                                             <li>  Rest is crucial because the body needs energy to fight the infection. Avoid strenuous
//                                                 activities, and prioritise sleep.</li>


//                                         </ul>


//                                     </p>

//                                     <p>
//                                         Most Campylobacter infections resolve within a week without antibiotics, but in severe cases,
//                                         medical treatment may be necessary. If symptoms are severe (high fever, blood in stool, or
//                                         prolonged dehydration), it’s best to consult a Doctor.
//                                     </p>



//                                     <p>Our treatment and advice suggestions have been devised by Nutritional Therapists and
//                                         Functional Medicine Practitioners. Any treatment protocol should only be undertaken under the
//                                         supervision of a Healthcare Practitioner.<br />
//                                         For persistent and/or serious symptoms, it is recommended to speak to your Doctor.
//                                     </p>


//                                 </div>
//                                 <div style={{ display: 'flex', justifyContent: 'center' }}>
//                                     <img style={{ marginTop: '5mm' }} src='/imgggg.pngg' alt="" />
//                                 </div>

//                             </div>




//                             <div className="secenddivend">

//                                 {/* <img src="/lower.png" alt="" /> */}
//                                 {reportStyle.logo === yourGutMap.logo ? <img src="/lower.png" alt="" /> : null}
//                             </div>

//                         </div>
//                     </>}




//                     {/* Vibrio cholerae* */}
//                     {kit.result.find(item => item['Vibrio cholerae'])?.["Vibrio cholerae"] === "detected" && <>
//                         <div className="lastdiv">
//                             <div className="firstdivhead">
//                                 {reportStyle.logo === yourGutMap.logo ? <img src="/logo2.png" alt="" style={{ marginTop: '10px' }} /> : null}
//                                 <img src="/uper.png" alt="" />



//                             </div>
//                             <div className="lastdivcenter">
//                                 <h1 style={{ color: "red" }}>Detected</h1>
//                                 <div className="texthead">

//                                     <h2>Vibrio cholerae</h2>


//                                 </div>

//                                 <div className="lastdivtext">

//                                     <p> <strong>About <br /></strong>
//                                         Vibrio cholerae is a gram-negative bacterium that causes cholera, an acute gastrointestinal
//                                         infection characterised by severe diarrhoea and dehydration. It is primarily transmitted through
//                                         contaminated water or food, particularly in areas with inadequate sanitation and hygiene
//                                         practices. Symptoms of cholera can develop suddenly and may include profuse watery
//                                         diarrhoea (often described as "rice-water" stools), vomiting, abdominal cramps, and leg cramps.
//                                         If left untreated, cholera can lead to rapid dehydration, electrolyte imbalances, and can be
//                                         life-threatening. </p>

//                                     <p><strong>Advice<br /></strong>
//                                         <ol>
//                                             <li><strong>   Seek Immediate Medical Attention:</strong> Cholera can lead to severe dehydration very quickly, so
//                                                 it's crucial to seek medical help right away if you suspect you have cholera. Medical
//                                                 professionals can provide rehydration therapy and necessary medications.</li>
//                                             <li> <strong>  Stay Hydrated</strong>   If you are unable to reach medical care immediately, begin rehydrating as soon
//                                                 as possible. Drink oral rehydration solutions (ORS) that contain electrolytes and sugars to help
//                                                 replace lost fluids and salts. You can also make a homemade ORS with clean water, salt, and
//                                                 sugar.</li>


//                                             <li> <strong>   Avoid Solid Foods Initially: </strong> When you first start to recover, focus on rehydrating before
//                                                 gradually reintroducing bland foods like rice, bananas, and toast. Avoid spicy, fatty, or high-fiber
//                                                 foods until you are feeling better.</li>




//                                             <li> <strong>    Good Hygiene:  </strong>  To prevent the spread of cholera, wash your hands thoroughly with soap and
//                                                 water after using the bathroom and before preparing or eating food. Ensure that food is cooked
//                                                 properly and water is treated (boiled or purified) if its source is questionable.
//                                             </li>

//                                             <li> <strong>   Follow Up with Healthcare Providers:</strong>   After initial treatment, follow up with your healthcare
//                                                 provider to ensure recovery and to address any lingering symptoms or concerns. Antibiotics
//                                                 may be prescribed in some cases to reduce the duration of the illness.</li>
//                                         </ol>

//                                     </p>

//                                     <p>
//                                         Taking these precautions and acting quickly is crucial for managing cholera and preventing
//                                         serious complications.
//                                     </p>



//                                     <p>Our treatment and advice suggestions have been devised by Nutritional Therapists and
//                                         Functional Medicine Practitioners. Any treatment protocol should only be undertaken under the
//                                         supervision of a Healthcare Practitioner.<br />
//                                         For persistent and/or serious symptoms, it is recommended to speak to your Doctor.
//                                     </p>


//                                 </div>
//                                 <div style={{ display: 'flex', justifyContent: 'center' }}>
//                                     <img style={{ marginTop: '5mm' }} src='/imgggg.pngg' alt="" />
//                                 </div>

//                             </div>




//                             <div className="secenddivend">

//                                 {/* <img src="/lower.png" alt="" /> */}
//                                 {reportStyle.logo === yourGutMap.logo ? <img src="/lower.png" alt="" /> : null}
//                             </div>

//                         </div>
//                     </>}




//                     {/* E. coli O157* */}
//                     {kit.result.find(item => item['E. coli O157'])?.["E. coli O157"] === "detected" && <>
//                         <div className="lastdiv">
//                             <div className="firstdivhead">
//                                 {reportStyle.logo === yourGutMap.logo ? <img src="/logo2.png" alt="" style={{ marginTop: '10px' }} /> : null}
//                                 {/* <img src="/uper.png" alt="" /> */}
//                                 {reportStyle.logo === yourGutMap.logo ? <img src="/uper.png" alt="" /> : null}



//                             </div>
//                             <div className="lastdivcenter">
//                                 <h1 style={{ color: "red" }}>Detected</h1>
//                                 <div className="texthead">

//                                     <h2>E. coli O157</h2>


//                                 </div>

//                                 <div className="lastdivtext">

//                                     <p style={{ color: 'red' }}>
//                                         Caution- in a small percentage of cases, E. coli O157 can cause severe symptoms and
//                                         lead to serious complications. If this has been identified in your stool test you should seek the
//                                         advice of your Doctor or Healthcare Practitioner.
//                                     </p>
//                                     <p> <strong>About <br /></strong>
//                                         <strong> E. coli O157</strong> is a strain of the bacterium Escherichia coli that can cause severe gastrointestinal
//                                         illness. It is classified as a shiga-toxin-producing E. coli (STEC) and is primarily transmitted
//                                         through contaminated food or water, particularly undercooked ground beef, unpasteurized milk,
//                                         and contaminated fruits and vegetables. Symptoms of infection typically begin 3 to 10 days after
//                                         exposure and can include severe abdominal cramps, diarrhea (which may be bloody), nausea,
//                                         and vomiting. In some cases, it can lead to serious complications such as hemolytic uremic
//                                         syndrome (HUS), which can cause kidney failure. </p>

//                                     <p><strong>Advice<br /></strong>
//                                         <strong>  Stay Hydrated:</strong> It is essential to maintain hydration, especially if you are experiencing
//                                         diarrhoea. Drink plenty of fluids such as water, clear broths, and oral rehydration solutions to
//                                         prevent dehydration. </p>

//                                     <p>
//                                         <strong>  Avoid Certain Medications:  </strong>  Do not take over-the-counter anti-diarrheal medications, as they
//                                         can prolong the illness and increase the risk of complications.
//                                     </p>

//                                     <p>
//                                         <strong>   Rest:  </strong>  Ensure you get sufficient rest to allow your body to recover. Avoid strenuous activities until
//                                         you feel better.
//                                     </p>

//                                     <p>
//                                         <strong>   Seek Medical Attention:   </strong>   If you experience severe symptoms, such as bloody diarrhoea, high
//                                         fever, or signs of dehydration (such as extreme thirst, dry mouth, or reduced urination), seek
//                                         medical help immediately. HUS is a serious complication that requires prompt treatment.
//                                     </p>

//                                     <p>
//                                         <strong>   Follow Up:  </strong>  After your initial recovery, follow up with your healthcare provider if you continue to
//                                         have symptoms or if new symptoms develop. They may recommend further testing or
//                                         monitoring.
//                                     </p>

//                                     <p>
//                                         <strong>   Good Hygiene:  </strong> To prevent the spread of E. coli O157, wash your hands thoroughly with soap
//                                         and water after using the bathroom and before preparing or eating food. Ensure that meat is
//                                         cooked to a safe temperature, and wash fruits and vegetables thoroughly before consumption.
//                                     </p>

//                                     <p>
//                                         Taking these measures can help manage symptoms and reduce the risk of complications from
//                                         an E. coli O157 infection.
//                                     </p>



//                                     <p>Our treatment and advice suggestions have been devised by Nutritional Therapists and
//                                         Functional Medicine Practitioners. Any treatment protocol should only be undertaken under the
//                                         supervision of a Healthcare Practitioner.<br />
//                                         For persistent and/or serious symptoms, it is recommended to speak to your Doctor.
//                                     </p>


//                                 </div>
//                                 <div style={{ display: 'flex', justifyContent: 'center' }}>
//                                     <img style={{ marginTop: '5mm' }} src='/imgggg.pngg' alt="" />
//                                 </div>

//                             </div>




//                             <div className="secenddivend">

//                                 {/* <img src="/lower.png" alt="" /> */}
//                                 {reportStyle.logo === yourGutMap.logo ? <img src="/lower.png" alt="" /> : null}
//                             </div>

//                         </div>
//                     </>}




//                     {/* Enteroaggregative E. coli (EAEC) */}
//                     {kit.result.find(item => item['Enteroaggregative E. coli (EAEC)'])?.["Enteroaggregative E. coli (EAEC)"] === "detected" && <>
//                         <div className="lastdiv">
//                             <div className="firstdivhead">
//                                 {reportStyle.logo === yourGutMap.logo ? <img src="/logo2.png" alt="" style={{ marginTop: '10px' }} /> : null}
//                                 {/* <img src="/uper.png" alt="" /> */}
//                                 {reportStyle.logo === yourGutMap.logo ? <img src="/uper.png" alt="" /> : null}



//                             </div>
//                             <div className="lastdivcenter">
//                                 <h1 style={{ color: "red" }}>Detected</h1>
//                                 <div className="texthead">

//                                     <h2>Enteroaggregative E. coli (EAEC)</h2>


//                                 </div>

//                                 <div className="lastdivtext">


//                                     <p> <strong>About <br /></strong>
//                                         <strong> Enteroaggregative E. coli (EAEC) </strong>  is a pathotype of Escherichia coli known to cause
//                                         gastrointestinal infections, particularly in young children and individuals in developing countries.
//                                         It is characterised by its ability to adhere to the intestinal mucosa in a stacked-brick
//                                         arrangement, which disrupts normal intestinal function. EAEC is often transmitted through
//                                         contaminated food and water. Symptoms of EAEC infection can include persistent watery
//                                         diarrhea, abdominal cramps, nausea, vomiting, and sometimes low-grade fever. The diarrhea
//                                         can last for several days to weeks, leading to dehydration and malnutrition, particularly in
//                                         vulnerable populations. </p>

//                                     <p><strong>Advice<br /></strong>
//                                         <strong>  Stay Hydrated:</strong>: Hydration is crucial when dealing with diarrhea. Drink plenty of fluids, such as
//                                         water, clear broths, and oral rehydration solutions (ORS) that contain electrolytes to prevent
//                                         dehydration. </p>



//                                     <p>
//                                         <strong>   Rest:  </strong>   Ensure you get adequate rest to help your body recover. Avoid strenuous activities and
//                                         give your body time to heal.
//                                     </p>

//                                     <p>
//                                         <strong>   Follow a Bland Diet:   </strong>    When you feel ready to eat, start with bland, easily digestible foods like
//                                         bananas, rice, applesauce, and toast (the BRAT diet). Avoid fatty, spicy, or high-fiber foods, as
//                                         these can irritate the digestive system.
//                                     </p>

//                                     <p>
//                                         <strong>    Seek Medical Attention:   </strong>   If symptoms persist for more than a few days, worsen, or if you
//                                         experience severe symptoms such as prolonged diarrhea or signs of dehydration (like extreme
//                                         thirst, dry mouth, dizziness, or significantly reduced urination), consult a healthcare provider.
//                                         Diagnosis may require stool tests, and in some cases, antibiotics may be necessary.
//                                     </p>

//                                     <p>
//                                         <strong>   Good Hygiene:  </strong> To prevent spreading the infection, wash your hands thoroughly with soap and
//                                         water after using the bathroom and before preparing or eating food. Ensure that food is cooked
//                                         properly and avoid drinking untreated water.
//                                     </p>

//                                     <p>
//                                         By taking these precautions and seeking appropriate care, you can help manage symptoms and
//                                         prevent complications associated with an EAEC infection.

//                                     </p>



//                                     <p>Our treatment and advice suggestions have been devised by Nutritional Therapists and
//                                         Functional Medicine Practitioners. Any treatment protocol should only be undertaken under the
//                                         supervision of a Healthcare Practitioner.<br />
//                                         For persistent and/or serious symptoms, it is recommended to speak to your Doctor.
//                                     </p>


//                                 </div>
//                                 <div style={{ display: 'flex', justifyContent: 'center' }}>
//                                     <img style={{ marginTop: '5mm' }} src='/imgggg.pngg' alt="" />
//                                 </div>

//                             </div>




//                             <div className="secenddivend">

//                                 {/* <img src="/lower.png" alt="" /> */}
//                                 {reportStyle.logo === yourGutMap.logo ? <img src="/lower.png" alt="" /> : null}
//                             </div>

//                         </div>
//                     </>}




//                     {/* Enteropathogenic E. coli (EPEC)* */}
//                     {kit.result.find(item => item['Enteropathogenic E. coli (EPEC)'])?.["Enteropathogenic E. coli (EPEC)"] === "detected" && <>
//                         <div className="lastdiv">
//                             <div className="firstdivhead">
//                                 {reportStyle.logo === yourGutMap.logo ? <img src="/logo2.png" alt="" style={{ marginTop: '10px' }} /> : null}
//                                 {/* <img src="/uper.png" alt="" /> */}
//                                 {reportStyle.logo === yourGutMap.logo ? <img src="/uper.png" alt="" /> : null}



//                             </div>
//                             <div className="lastdivcenter">
//                                 <h1 style={{ color: "red" }}>Detected</h1>
//                                 <div className="texthead">

//                                     <h2>Enteropathogenic E. coli (EPEC)</h2>


//                                 </div>

//                                 <div className="lastdivtext">


//                                     <p> <strong>About <br /></strong>
//                                         Enteropathogenic Escherichia coli (EPEC) is a leading cause of infantile diarrhoea in developing
//                                         countries. In industrialised countries, the frequency of these organisms has decreased, but they
//                                         continue to be an important cause of diarrhoea. The presence of beneficial E. coli strains helps
//                                         to prevent intestinal infections by competitively excluding pathogenic agents from binding to
//                                         epithelial binding sites. </p>

//                                     <p><strong>Advice<br /></strong>
//                                         The intake of prebiotics (FOS, GOS, inulin, and lactulose) and probiotics (fermented foods and
//                                         dietary supplements) has been shown to beneficially modulate the gut microbiome composition
//                                         so that it favours beneficial Lactobacillus and Bifidobacteria and reduces E. coli. We recommend
//                                         following the microbiome rebalancing foods to help rebalance the microbiome which will make
//                                         the gut environment unfavourable to this parasite. Antimicrobials may be something to consider
//                                         later down the line as it could also disrupt beneficial bacteria. Berberine 400mg seems to be a
//                                         promising antimicrobial for this particular parasite<a href='https://pubmed.ncbi.nlm.nih.gov/3549923/'>(https://pubmed.ncbi.nlm.nih.gov/3549923/).</a>
//                                         In the meantime, you could suggest activated charcoal to minimise any toxins produced from
//                                         the parasite <a href='(https://pubmed.ncbi.nlm.nih.gov/11307928/)'>(https://pubmed.ncbi.nlm.nih.gov/11307928/). </a></p>






//                                     <p>Our treatment and advice suggestions have been devised by Nutritional Therapists and
//                                         Functional Medicine Practitioners. Any treatment protocol should only be undertaken under the
//                                         supervision of a Healthcare Practitioner.<br />
//                                         For persistent and/or serious symptoms, it is recommended to speak to your Doctor.
//                                     </p>


//                                 </div>
//                                 <div style={{ display: 'flex', justifyContent: 'center' }}>
//                                     <img style={{ marginTop: '5mm' }} src='/imgggg.pngg' alt="" />
//                                 </div>

//                             </div>




//                             <div className="secenddivend">

//                                 {/* <img src="/lower.png" alt="" /> */}
//                                 {reportStyle.logo === yourGutMap.logo ? <img src="/lower.png" alt="" /> : null}
//                             </div>

//                         </div>
//                     </>}




//                     {/* Enterotoxigenic E. coli (ETEC) LT* */}
//                     {kit.result.find(item => item['Enterotoxigenic E. coli (ETEC)'])?.["Enterotoxigenic E. coli (ETEC)"] === "detected" && <>
//                         <div className="lastdiv">
//                             <div className="firstdivhead">
//                                 {reportStyle.logo === yourGutMap.logo ? <img src="/logo2.png" alt="" style={{ marginTop: '10px' }} /> : null}
//                                 {/* <img src="/uper.png" alt="" /> */}
//                                 {reportStyle.logo === yourGutMap.logo ? <img src="/uper.png" alt="" /> : null}



//                             </div>
//                             <div className="lastdivcenter">
//                                 <h1 style={{ color: "red" }}>Detected</h1>
//                                 <div className="texthead">

//                                     <h2>Enterotoxigenic E. coli (ETEC) LT</h2>


//                                 </div>

//                                 <div className="lastdivtext">


//                                     <p> <strong>About <br /></strong>
//                                         Enterotoxigenic Escherichia coli (ETEC) is a type of E. coli bacteria known to cause traveler's
//                                         diarrhoea, especially in areas with limited access to clean water and sanitation. ETEC produces
//                                         two types of toxins: heat-labile toxin (LT) and heat-stable toxin (ST), both of which lead to
//                                         excessive water and electrolyte loss in the intestines. The LT toxin works similarly to cholera
//                                         toxin, disrupting the gut lining and leading to symptoms such as watery diarrhea, stomach
//                                         cramps, nausea, and sometimes low-grade fever. ETEC infections are generally self-limiting but
//                                         can cause severe dehydration, particularly in young children and travelers. </p>

//                                     <p><strong>Advice<br /></strong>
//                                         <strong> Hydration</strong>  Staying hydrated is essential since ETEC causes watery diarrhea, which can lead to
//                                         dehydration. Drink plenty of fluids, and consider oral rehydration solutions to replace lost
//                                         electrolytes. These can be found in pharmacies or made at home by mixing clean water, salt,
//                                         and sugar.</p>

//                                     <p>
//                                         <strong>  Rest:</strong> Give your body time to fight the infection by resting as much as possible, as activity can
//                                         worsen dehydration and fatigue.
//                                     </p>

//                                     <p>
//                                         <strong>   Eat a Bland Diet:</strong> Stick to easily digestible foods like bananas, rice, applesauce, and toast
//                                         (BRAT diet), which can help ease digestive symptoms. Avoid fatty, spicy, and high-fibre foods
//                                         that can irritate the gut.
//                                     </p>

//                                     <p>
//                                         If symptoms persist beyond a few days, become severe, or include high fever or blood in stools,
//                                         seek medical attention. In some cases, antibiotics may be prescribed to help shorten the illness,
//                                         particularly for vulnerable groups like young children, the elderly, or immunocompromised
//                                         individuals.

//                                     </p>






//                                     <p>Our treatment and advice suggestions have been devised by Nutritional Therapists and
//                                         Functional Medicine Practitioners. Any treatment protocol should only be undertaken under the
//                                         supervision of a Healthcare Practitioner.<br />
//                                         For persistent and/or serious symptoms, it is recommended to speak to your Doctor.
//                                     </p>


//                                 </div>
//                                 <div style={{ display: 'flex', justifyContent: 'center' }}>
//                                     <img style={{ marginTop: '5mm' }} src='/imgggg.pngg' alt="" />
//                                 </div>

//                             </div>




//                             <div className="secenddivend">

//                                 {/* <img src="/lower.png" alt="" /> */}
//                                 {reportStyle.logo === yourGutMap.logo ? <img src="/lower.png" alt="" /> : null}
//                             </div>

//                         </div>
//                     </>}




//                     {/* Shiga-Toxin-producing E. coli (STEC)* */}
//                     {kit.result.find(item => item['Shigatoxin-producing E. coli (STEC)'])?.["Shigatoxin-producing E. coli (STEC)"] === "detected" && <>
//                         <div className="lastdiv">
//                             <div className="firstdivhead">
//                                 {reportStyle.logo === yourGutMap.logo ? <img src="/logo2.png" alt="" style={{ marginTop: '10px' }} /> : null}
//                                 {/* <img src="/uper.png" alt="" /> */}
//                                 {reportStyle.logo === yourGutMap.logo ? <img src="/uper.png" alt="" /> : null}



//                             </div>
//                             <div className="lastdivcenter">
//                                 <h1 style={{ color: "red" }}>Detected</h1>
//                                 <div className="texthead">

//                                     <h2>Shiga-Toxin-producing E. coli (STEC)</h2>


//                                 </div>

//                                 <div className="lastdivtext">

//                                     <p style={{ color: 'red' }}>
//                                         Caution- in a small percentage of cases, Shiga-toxin-producing Escherichia coli can cause
//                                         severe symptoms and lead to serious complications. If this has been identified in your stool test
//                                         you should seek the advice of your Doctor or Healthcare Practitioner.
//                                     </p>
//                                     <p> <strong>About <br /></strong>
//                                         Shiga-toxin-producing Escherichia coli (STEC) is a type of E. coli bacteria that produces Shiga
//                                         toxin, a potent toxin that can damage the lining of the intestines and other organs. This strain is
//                                         commonly associated with foodborne illnesses, often contracted by consuming undercooked
//                                         meats, unpasteurized dairy, or contaminated produce. The symptoms of STEC infection typically
//                                         include severe abdominal cramps, diarrhoea (often bloody), vomiting, and sometimes fever. In
//                                         some cases, particularly in young children and the elderly, STEC can lead to a serious
//                                         complication known as hemolytic uremic syndrome (HUS), which can cause kidney failure and
//                                         requires immediate medical attention. </p>

//                                     <p><strong>Advice<br /></strong>
//                                         Consult with your Doctor or Healthcare Practitioner</p>


//                                     <p>Our treatment and advice suggestions have been devised by Nutritional Therapists and
//                                         Functional Medicine Practitioners. Any treatment protocol should only be undertaken under the
//                                         supervision of a Healthcare Practitioner.<br />
//                                         For persistent and/or serious symptoms, it is recommended to speak to your Doctor.
//                                     </p>


//                                 </div>
//                                 <div style={{ display: 'flex', justifyContent: 'center' }}>
//                                     <img style={{ marginTop: '5mm' }} src='/imgggg.pngg' alt="" />
//                                 </div>

//                             </div>




//                             <div className="secenddivend">

//                                 {/* <img src="/lower.png" alt="" /> */}
//                                 {reportStyle.logo === yourGutMap.logo ? <img src="/lower.png" alt="" /> : null}
//                             </div>

//                         </div>
//                     </>}



//                     {/* Enteroinvasive E. coli (EIEC)* */}
//                     {kit.result.find(item => item['Enteroinvasive E. coli (EIEC)'])?.["Enteroinvasive E. coli (EIEC)"] === "detected" && <>
//                         <div className="lastdiv">
//                             <div className="firstdivhead">
//                                 {reportStyle.logo === yourGutMap.logo ? <img src="/logo2.png" alt="" style={{ marginTop: '10px' }} /> : null}
//                                 {/* <img src="/uper.png" alt="" /> */}
//                                 {reportStyle.logo === yourGutMap.logo ? <img src="/uper.png" alt="" /> : null}


//                             </div>
//                             <div className="lastdivcenter">
//                                 <h1 style={{ color: "red" }}>Detected</h1>
//                                 <div className="texthead">

//                                     <h2>Enteroinvasive E. coli (EIEC)</h2>


//                                 </div>

//                                 <div className="lastdivtext">


//                                     <p> <strong>About <br /></strong>
//                                         Enteroinvasive Escherichia coli (EIEC) is a type of E. coli bacteria that invades and multiplies
//                                         within the cells lining the intestines, causing an illness similar to dysentery. EIEC infections are
//                                         typically acquired through contaminated food or water, and they closely mimic the symptoms
//                                         caused by Shigella bacteria. Symptoms often include watery diarrhoea that can become bloody
//                                         or mucus-filled, abdominal pain, fever, and cramping. The infection disrupts the intestinal wall,
//                                         leading to inflammation and discomfort. While most cases resolve on their own, severe
//                                         symptoms may require medical attention to prevent dehydration and manage discomfort.</p>

//                                     <p><strong>Advice<br /></strong>
//                                         Due to disruption in the intestinal wall, it is recommended to speak with your Health Practitioner
//                                         about rebalancing the gut microbiome after a EIEC infection. Taking a gut microbiome test and
//                                         following the food scores will help this process

//                                         <ol>
//                                             <li><strong>   Hydrate Well:</strong>   Since diarrhea is a common symptom of EIEC, staying hydrated is crucial. Drink
//                                                 plenty of water and consider oral rehydration solutions (available at pharmacies or homemade
//                                                 with water, salt, and sugar) to restore lost fluids and electrolytes.</li>
//                                             <li> <strong> Rest:</strong>   Give your body time to recover by resting. Physical exertion can worsen dehydration and
//                                                 delay recovery.</li>


//                                             <li> <strong>   Stick to a Bland Diet:  </strong> Eat simple, easily digestible foods like bananas, rice, applesauce, and
//                                                 toast (BRAT diet) to avoid irritating the digestive system. Avoid spicy, fatty, and high-fiber foods,
//                                                 as they can make symptoms worse.</li>




//                                             <li> <strong>   Avoid Anti-diarrheal Medications: </strong>  Over-the-counter anti-diarrheal medications are generally
//                                                 not recommended for EIEC, as they can slow down the body’s ability to expel the bacteria.
//                                             </li>


//                                         </ol>

//                                     </p>


//                                     <p>Our treatment and advice suggestions have been devised by Nutritional Therapists and
//                                         Functional Medicine Practitioners. Any treatment protocol should only be undertaken under the
//                                         supervision of a Healthcare Practitioner.<br />
//                                         For persistent and/or serious symptoms, it is recommended to speak to your Doctor.
//                                     </p>


//                                 </div>
//                                 <div style={{ display: 'flex', justifyContent: 'center' }}>
//                                     <img style={{ marginTop: '5mm' }} src='/imgggg.pngg' alt="" />
//                                 </div>

//                             </div>




//                             <div className="secenddivend">

//                                 {/* <img src="/lower.png" alt="" /> */}
//                                 {reportStyle.logo === yourGutMap.logo ? <img src="/lower.png" alt="" /> : null}
//                             </div>

//                         </div>
//                     </>}




//                     {/* Adenovirus* */}
//                     {kit.result.find(item => item['Adenovirus'])?.["Adenovirus"] === "detected" && <>
//                         <div className="lastdiv">
//                             <div className="firstdivhead">
//                                 {reportStyle.logo === yourGutMap.logo ? <img src="/logo2.png" alt="" style={{ marginTop: '10px' }} /> : null}
//                                 {/* <img src="/uper.png" alt="" /> */}
//                                 {reportStyle.logo === yourGutMap.logo ? <img src="/uper.png" alt="" /> : null}


//                             </div>
//                             <div className="lastdivcenter">
//                                 <h1 style={{ color: "red" }}>Detected</h1>
//                                 <div className="texthead">

//                                     <h2>Adenovirus</h2>


//                                 </div>

//                                 <div className="lastdivtext">


//                                     <p> <strong>About <br /></strong>
//                                         Adenovirus is a type of virus that can cause gastrointestinal infections, particularly in children. It
//                                         is easily spread through contaminated food or water, and person-to-person contact. When it
//                                         affects the gastrointestinal tract, symptoms can include diarrhoea, vomiting, abdominal pain,
//                                         and fever. Adenovirus gastroenteritis is usually mild and self-limiting, often resolving within a few
//                                         days. However, it can lead to dehydration, especially in young children and those with
//                                         weakened immune systems, necessitating prompt attention to hydration and electrolyte
//                                         balance. </p>

//                                     <p><strong>Advice<br /></strong>
//                                         <ol>
//                                             <li><strong>  Stay Hydrated:</strong> Hydration is crucial, especially if you are experiencing diarrhea and
//                                                 vomiting. Drink plenty of fluids, including water, clear broths, and oral rehydration
//                                                 solutions to replace lost electrolytes.</li>
//                                             <li> <strong> Rest:</strong> Allow your body to recover by getting plenty of rest. Avoid strenuous activities that
//                                                 could worsen your condition.</li>
//                                             <li> <strong> Eat Bland Foods: </strong>When you feel ready to eat, start with bland, easy-to-digest foods
//                                                 such as bananas, rice, applesauce, and toast (BRAT diet). Avoid spicy, fatty, or high-fiber
//                                                 foods that may irritate your digestive system.</li>
//                                             <li> <strong>   Monitor Symptoms:</strong> Keep track of your symptoms. If they worsen, or if you experience
//                                                 severe dehydration (indicated by symptoms like extreme thirst, dry mouth, decreased
//                                                 urination, or dizziness), seek medical attention.</li>
//                                             <li> <strong>  Avoid Anti-diarrheal Medications: </strong>Over-the-counter medications that slow down
//                                                 diarrhea are generally not recommended for viral infections like adenovirus, as they can
//                                                 prolong the illness.</li>
//                                         </ol>

//                                     </p>

//                                     <p>
//                                         If symptoms persist for more than a few days, worsen, or if you have underlying health
//                                         conditions, it’s advisable to consult a healthcare provider for further evaluation and
//                                         management.

//                                     </p>


//                                     <p>Our treatment and advice suggestions have been devised by Nutritional Therapists and
//                                         Functional Medicine Practitioners. Any treatment protocol should only be undertaken under the
//                                         supervision of a Healthcare Practitioner.<br />
//                                         For persistent and/or serious symptoms, it is recommended to speak to your Doctor.
//                                     </p>


//                                 </div>
//                                 <div style={{ display: 'flex', justifyContent: 'center' }}>
//                                     <img style={{ marginTop: '5mm' }} src='/imgggg.pngg' alt="" />
//                                 </div>

//                             </div>




//                             <div className="secenddivend">

//                                 {/* <img src="/lower.png" alt="" /> */}
//                                 {reportStyle.logo === yourGutMap.logo ? <img src="/lower.png" alt="" /> : null}
//                             </div>

//                         </div>
//                     </>}




//                     {/* Astrovirus* */}
//                     {kit.result.find(item => item['Astrovirus'])?.["Astrovirus"] === "detected" && <>
//                         <div className="lastdiv">
//                             <div className="firstdivhead">
//                                 {reportStyle.logo === yourGutMap.logo ? <img src="/logo2.png" alt="" style={{ marginTop: '10px' }} /> : null}
//                                 {/* <img src="/uper.png" alt="" /> */}
//                                 {reportStyle.logo === yourGutMap.logo ? <img src="/uper.png" alt="" /> : null}


//                             </div>
//                             <div className="lastdivcenter">
//                                 <h1 style={{ color: "red" }}>Detected</h1>
//                                 <div className="texthead">

//                                     <h2>Astrovirus</h2>


//                                 </div>

//                                 <div className="lastdivtext">


//                                     <p> <strong>About <br /></strong>
//                                         Astrovirus is a viral pathogen that primarily affects the gastrointestinal tract, leading to
//                                         gastroenteritis, especially in young children, the elderly, and immunocompromised individuals. It
//                                         is transmitted through contaminated food or water and is highly contagious. Symptoms of an
//                                         astrovirus infection typically include diarrhoea, vomiting, abdominal pain, and mild fever. While
//                                         the illness is generally mild and self-limiting, it can lead to dehydration, particularly in vulnerable
//                                         populations. </p>

//                                     <p><strong>Advice<br /></strong>
//                                         <ol>
//                                             <li><strong>  Stay Hydrated:</strong>  Drink plenty of fluids, such as water, clear broths, and oral rehydration
//                                                 solutions to replenish lost electrolytes. This is crucial to prevent dehydration from
//                                                 diarrhea and vomiting.</li>
//                                             <li> <strong> Rest:</strong>  Allow your body to recover by getting sufficient rest. Avoid strenuous activities to
//                                                 conserve energy.</li>


//                                             <li> <strong>  Follow a Bland Diet: </strong>When you feel ready to eat, stick to bland foods that are easy on
//                                                 the stomach, such as bananas, rice, applesauce, and toast (the BRAT diet). Avoid spicy,
//                                                 fatty, and dairy-rich foods until you recover.</li>

//                                             <li> <strong>   Monitor Symptoms:</strong> Keep an eye on your symptoms. If you experience severe
//                                                 dehydration (indicated by extreme thirst, dry mouth, dizziness, or significantly reduced
//                                                 urination), seek medical attention promptly.</li>


//                                             <li> <strong>  Avoid Anti-diarrheal Medications: </strong> Over-the-counter medications that slow down
//                                                 diarrhea are typically not recommended for viral infections like astrovirus, as they can
//                                                 prolong the illness.</li>
//                                         </ol>

//                                     </p>

//                                     <p>
//                                         If symptoms persist for more than a few days or worsen, it's important to consult a healthcare
//                                         provider for further evaluation and management.


//                                     </p>


//                                     <p>Our treatment and advice suggestions have been devised by Nutritional Therapists and
//                                         Functional Medicine Practitioners. Any treatment protocol should only be undertaken under the
//                                         supervision of a Healthcare Practitioner.<br />
//                                         For persistent and/or serious symptoms, it is recommended to speak to your Doctor.
//                                     </p>


//                                 </div>
//                                 <div style={{ display: 'flex', justifyContent: 'center' }}>
//                                     <img style={{ marginTop: '5mm' }} src='/imgggg.pngg' alt="" />
//                                 </div>

//                             </div>




//                             <div className="secenddivend">

//                                 {/* <img src="/lower.png" alt="" /> */}
//                                 {reportStyle.logo === yourGutMap.logo ? <img src="/lower.png" alt="" /> : null}
//                             </div>

//                         </div>
//                     </>}




//                     {/* Norovirus GI/GII* */}
//                     {kit.result.find(item => item['Norovirus GI/GII'])?.["Norovirus GI/GII"] === "detected" && <>
//                         <div className="lastdiv">
//                             <div className="firstdivhead">
//                                 {reportStyle.logo === yourGutMap.logo ? <img src="/logo2.png" alt="" style={{ marginTop: '10px' }} /> : null}
//                                 {/* <img src="/uper.png" alt="" /> */}
//                                 {reportStyle.logo === yourGutMap.logo ? <img src="/uper.png" alt="" /> : null}


//                             </div>
//                             <div className="lastdivcenter">
//                                 <h1 style={{ color: "red" }}>Detected</h1>
//                                 <div className="texthead">

//                                     <h2>Norovirus GI/GII</h2>


//                                 </div>

//                                 <div className="lastdivtext">


//                                     <p> <strong>About <br /></strong>
//                                         Norovirus, particularly the GII strain, is a highly contagious virus that causes acute
//                                         gastroenteritis, leading to inflammation of the stomach and intestines. It is commonly spread
//                                         through contaminated food or water, as well as from person to person, often in crowded
//                                         environments such as cruise ships, schools, and nursing homes. Symptoms of norovirus
//                                         infection typically include sudden onset of diarrhea, vomiting, abdominal cramps, nausea, and
//                                         sometimes low-grade fever. The illness is usually self-limiting but can lead to dehydration,
//                                         especially in vulnerable populations like young children and the elderly. </p>

//                                     <p><strong>Advice<br /></strong>
//                                         <ol>
//                                             <li><strong>  Stay Hydrated:</strong>  It’s crucial to maintain hydration since diarrhea and vomiting can lead to
//                                                 significant fluid loss. Drink plenty of fluids such as water, clear broth, or oral rehydration
//                                                 solutions to replenish lost electrolytes.</li>
//                                             <li> <strong> Rest:</strong>   Resting helps your body recover from the infection. Avoid strenuous activities and give
//                                                 yourself time to heal.</li>


//                                             <li> <strong>  Follow a Bland Diet: </strong> Once you feel able to eat, start with bland, easy-to-digest foods such as
//                                                 bananas, rice, applesauce, and toast (the BRAT diet). Avoid spicy, fatty, or rich foods until you
//                                                 recover.</li>

//                                             <li> <strong>   Good Hygiene:</strong> Since norovirus is highly contagious, wash your hands thoroughly with soap
//                                                 and water, especially after using the bathroom and before eating or preparing food. Disinfect
//                                                 surfaces that may be contaminated.</li>


//                                             <li> <strong>  Avoid Anti-diarrheal Medications: </strong> Over-the-counter medications that slow down diarrhea are
//                                                 generally not recommended for norovirus infections, as they may prolong the illness.</li>
//                                         </ol>

//                                     </p>

//                                     <p>
//                                         If symptoms persist for more than a few days, worsen, or if you experience severe dehydration
//                                         (indicated by symptoms like extreme thirst, dry mouth, or decreased urination), seek medical
//                                         attention promptly


//                                     </p>


//                                     <p>Our treatment and advice suggestions have been devised by Nutritional Therapists and
//                                         Functional Medicine Practitioners. Any treatment protocol should only be undertaken under the
//                                         supervision of a Healthcare Practitioner.<br />
//                                         For persistent and/or serious symptoms, it is recommended to speak to your Doctor.
//                                     </p>


//                                 </div>
//                                 <div style={{ display: 'flex', justifyContent: 'center' }}>
//                                     <img style={{ marginTop: '5mm' }} src='/imgggg.pngg' alt="" />
//                                 </div>

//                             </div>




//                             <div className="secenddivend">

//                                 {/* <img src="/lower.png" alt="" /> */}
//                                 {reportStyle.logo === yourGutMap.logo ? <img src="/lower.png" alt="" /> : null}
//                             </div>

//                         </div>
//                     </>}




//                     {/* Rotavirus A* */}
//                     {kit.result.find(item => item['Rotavirus A'])?.["Rotavirus A"] === "detected" && <>
//                         <div className="lastdiv">
//                             <div className="firstdivhead">
//                                 {reportStyle.logo === yourGutMap.logo ? <img src="/logo2.png" alt="" style={{ marginTop: '10px' }} /> : null}
//                                 {/* <img src="/uper.png" alt="" /> */}
//                                 {reportStyle.logo === yourGutMap.logo ? <img src="/uper.png" alt="" /> : null}


//                             </div>
//                             <div className="lastdivcenter">
//                                 <h1 style={{ color: "red" }}>Detected</h1>
//                                 <div className="texthead">

//                                     <h2>Norovirus GI/GII</h2>


//                                 </div>

//                                 <div className="lastdivtext">


//                                     <p> <strong>About <br /></strong>
//                                         Rotavirus A is a highly contagious virus that primarily affects the gastrointestinal tract, leading to
//                                         acute gastroenteritis, particularly in infants and young children. It is transmitted through the
//                                         fecal-oral route, often through contaminated hands, surfaces, or food and water. Symptoms of
//                                         rotavirus infection typically include severe diarrhea, vomiting, abdominal cramps, fever, and
//                                         dehydration. The diarrhea can be particularly profuse, leading to rapid fluid loss, which can be
//                                         dangerous, especially in young children and infants. </p>

//                                     <p><strong>Advice<br /></strong>
//                                         <ol>
//                                             <li><strong>  Stay Hydrated:</strong>  Maintaining hydration is crucial. Drink plenty of fluids such as water, clear
//                                                 broths, or oral rehydration solutions that contain electrolytes. This helps replenish lost fluids and
//                                                 prevents dehydration.</li>
//                                             <li> <strong> Rest:</strong>  Ensure you get enough rest to help your body recover. Limit physical activity until you feel
//                                                 better.</li>


//                                             <li> <strong>  Follow a Bland Diet: </strong> When you feel ready to eat, opt for bland, easily digestible foods such as
//                                                 bananas, rice, applesauce, and toast (the BRAT diet). Avoid dairy products, fatty foods, and
//                                                 sugary drinks, as they can worsen diarrhoea.</li>

//                                             <li> <strong>   Good Hygiene:</strong>  To prevent spreading the virus, wash your hands thoroughly with soap and
//                                                 water after using the bathroom and before eating or preparing food. Disinfect surfaces that may
//                                                 be contaminated.</li>


//                                             <li> <strong> Seek Medical Attention if Needed: </strong> If symptoms persist for more than a couple of days,
//                                                 worsen, or if you or your child show signs of severe dehydration (such as dry mouth, reduced
//                                                 urination, extreme thirst, or lethargy), seek medical help promptly.
//                                             </li>
//                                         </ol>

//                                     </p>




//                                     <p>Our treatment and advice suggestions have been devised by Nutritional Therapists and
//                                         Functional Medicine Practitioners. Any treatment protocol should only be undertaken under the
//                                         supervision of a Healthcare Practitioner.<br />
//                                         For persistent and/or serious symptoms, it is recommended to speak to your Doctor.
//                                     </p>


//                                 </div>
//                                 <div style={{ display: 'flex', justifyContent: 'center' }}>
//                                     <img style={{ marginTop: '5mm' }} src='/imgggg.pngg' alt="" />
//                                 </div>

//                             </div>




//                             <div className="secenddivend">

//                                 {/* <img src="/lower.png" alt="" /> */}
//                                 {reportStyle.logo === yourGutMap.logo ? <img src="/lower.png" alt="" /> : null}
//                             </div>

//                         </div>
//                     </>}


//                     {/* Sapovirus (I, II, IV, and V)* */}
//                     {kit.result.find(item => item['Sapovirus (I,II,IV and V)'])?.["Sapovirus (I,II,IV and V)"] === "detected" && <>
//                         <div className="lastdiv">
//                             <div className="firstdivhead">
//                                 {reportStyle.logo === yourGutMap.logo ? <img src="/logo2.png" alt="" style={{ marginTop: '10px' }} /> : null}
//                                 {/* <img src="/uper.png" alt="" /> */}
//                                 {reportStyle.logo === yourGutMap.logo ? <img src="/uper.png" alt="" /> : null}


//                             </div>
//                             <div className="lastdivcenter">
//                                 <h1 style={{ color: "red" }}>Detected</h1>
//                                 <div className="texthead">

//                                     <h2>Sapovirus (I,II, IV, and V)</h2>


//                                 </div>

//                                 <div className="lastdivtext">


//                                     <p> <strong>About <br /></strong>
//                                         Sapovirus, which includes several genotypes (I, II, IV, and V), is a type of virus that primarily
//                                         causes gastroenteritis, particularly in children and occasionally in adults. It is transmitted via the
//                                         fecal-oral route, often through contaminated food, water, or surfaces, and is known to cause
//                                         outbreaks in settings such as schools, nursing homes, and cruise ships. Symptoms of sapovirus
//                                         infection typically include diarrhea, vomiting, abdominal cramps, nausea, and low-grade fever.
//                                         While the illness is usually mild and self-limiting, it can lead to dehydration, especially in young
//                                         children and vulnerable populations. </p>

//                                     <p><strong>Advice<br /></strong>
//                                         <ol>
//                                             <li><strong>  Stay Hydrated:</strong>  Hydration is crucial, especially if you are experiencing diarrhea and vomiting.
//                                                 Drink plenty of fluids, such as water, clear broths, and oral rehydration solutions that contain
//                                                 electrolytes to replenish lost fluids.</li>
//                                             <li> <strong> Rest:</strong>   Ensure you get enough rest to support your body’s recovery. Avoid strenuous activities
//                                                 and prioritize sleep.</li>


//                                             <li> <strong>  Follow a Bland Diet: </strong>  When you feel ready to eat, stick to bland foods that are easy on the
//                                                 stomach, such as bananas, rice, applesauce, and toast (the BRAT diet). Avoid dairy products,
//                                                 greasy foods, and sugary drinks, which can aggravate symptoms.</li>

//                                             <li> <strong>   Good Hygiene:</strong>   Since sapovirus is highly contagious, wash your hands thoroughly with soap
//                                                 and water after using the bathroom and before eating or preparing food. Disinfect surfaces that
//                                                 may be contaminated to prevent further spread.</li>


//                                             <li> <strong>  Avoid Anti-diarrheal Medications: </strong> Over-the-counter medications that slow down diarrhea are
//                                                 generally not recommended for viral gastroenteritis, as they can prolong the illness.
//                                             </li>
//                                         </ol>

//                                     </p>
//                                     <p>
//                                         If symptoms persist for more than a few days, worsen, or if you experience signs of severe
//                                         dehydration (such as extreme thirst, dry mouth, decreased urination, or dizziness), seek medical
//                                         attention promptly
//                                     </p>




//                                     <p>Our treatment and advice suggestions have been devised by Nutritional Therapists and
//                                         Functional Medicine Practitioners. Any treatment protocol should only be undertaken under the
//                                         supervision of a Healthcare Practitioner.<br />
//                                         For persistent and/or serious symptoms, it is recommended to speak to your Doctor.
//                                     </p>


//                                 </div>
//                                 <div style={{ display: 'flex', justifyContent: 'center' }}>
//                                     <img style={{ marginTop: '5mm' }} src='/imgggg.pngg' alt="" />
//                                 </div>

//                             </div>




//                             <div className="secenddivend">

//                                 {/* <img src="/lower.png" alt="" /> */}
//                                 {reportStyle.logo === yourGutMap.logo ? <img src="/lower.png" alt="" /> : null}
//                             </div>

//                         </div>
//                     </>}


//                     {/* Cryptosporidium spp.* */}
//                     {kit.result.find(item => item['Cryptosporidium spp.'])?.["Cryptosporidium spp."] === "detected" && <>
//                         <div className="lastdiv">
//                             <div className="firstdivhead">
//                                 {reportStyle.logo === yourGutMap.logo ? <img src="/logo2.png" alt="" style={{ marginTop: '10px' }} /> : null}
//                                 {/* <img src="/uper.png" alt="" /> */}
//                                 {reportStyle.logo === yourGutMap.logo ? <img src="/uper.png" alt="" /> : null}


//                             </div>
//                             <div className="lastdivcenter">
//                                 <h1 style={{ color: "red" }}>Detected</h1>
//                                 <div className="texthead">

//                                     <h2>Cryptosporidium spp.</h2>


//                                 </div>

//                                 <div className="lastdivtext">


//                                     <p> <strong>About <br /></strong>
//                                         Cryptosporidium spp.. are microscopic parasites that cause a gastrointestinal infection known as
//                                         cryptosporidiosis. These parasites are typically transmitted through contaminated water, food, or
//                                         surfaces, and they can be found in both recreational and drinking water. Infection with
//                                         Cryptosporidium can lead to symptoms such as watery diarrhea, abdominal cramps, nausea,
//                                         vomiting, and sometimes fever. Symptoms can vary in severity and may last from a few days to
//                                         several weeks, particularly in immunocompromised individuals, where the infection can be more
//                                         severe and prolonged. </p>

//                                     <p><strong>Advice<br /></strong>
//                                         <ol>
//                                             <li><strong>  Stay Hydrated:</strong>  Hydration is essential, especially since diarrhea can lead to significant fluid
//                                                 loss. Drink plenty of fluids such as water, clear broths, and oral rehydration solutions containing
//                                                 electrolytes to prevent dehydration.</li>
//                                             <li> <strong> Rest:</strong>  Give your body time to recover by getting sufficient rest. Avoid strenuous activities and
//                                                 take care of yourself.</li>


//                                             <li> <strong>  Follow a Bland Diet: </strong> : When you feel able to eat, start with bland, easily digestible foods such as
//                                                 bananas, rice, applesauce, and toast (the BRAT diet). Avoid dairy products, greasy or spicy
//                                                 foods, and high-fiber foods, as they may irritate the digestive system.</li>

//                                             <li> <strong>   Good Hygiene:</strong>   To prevent spreading the infection, wash your hands thoroughly with soap and
//                                                 water after using the bathroom and before preparing or eating food. Ensure that any surfaces
//                                                 that may be contaminated are properly disinfected</li>


//                                             <li> <strong>   Seek Medical Attention if Needed: </strong> If symptoms persist for more than a few days, worsen, or if
//                                                 you experience signs of severe dehydration (such as extreme thirst, dry mouth, or significantly
//                                                 reduced urination), consult a healthcare provider. In some cases, especially in
//                                                 immunocompromised individuals, medication may be required to manage the infection
//                                                 effectively.
//                                             </li>
//                                         </ol>

//                                     </p>
//                                     <p>
//                                         Taking preventive measures, such as ensuring good hygiene and avoiding drinking untreated
//                                         water, can help reduce the risk of contracting Cryptosporidium spp.. infections.

//                                     </p>




//                                     <p>Our treatment and advice suggestions have been devised by Nutritional Therapists and
//                                         Functional Medicine Practitioners. Any treatment protocol should only be undertaken under the
//                                         supervision of a Healthcare Practitioner.<br />
//                                         For persistent and/or serious symptoms, it is recommended to speak to your Doctor.
//                                     </p>


//                                 </div>
//                                 <div style={{ display: 'flex', justifyContent: 'center' }}>
//                                     <img style={{ marginTop: '5mm' }} src='/imgggg.pngg' alt="" />
//                                 </div>

//                             </div>




//                             <div className="secenddivend">

//                                 {/* <img src="/lower.png" alt="" /> */}
//                                 {reportStyle.logo === yourGutMap.logo ? <img src="/lower.png" alt="" /> : null}
//                             </div>

//                         </div>
//                     </>}




//                     {/* Cyclospora cayetanensis* */}
//                     {kit.result.find(item => item['Cyclospora cayetanensis'])?.["Cyclospora cayetanensis"] === "detected" && <>
//                         <div className="lastdiv">
//                             <div className="firstdivhead">
//                                 {reportStyle.logo === yourGutMap.logo ? <img src="/logo2.png" alt="" style={{ marginTop: '10px' }} /> : null}
//                                 <img src="/uper.png" alt="" />



//                             </div>
//                             <div className="lastdivcenter">
//                                 <h1 style={{ color: "red" }}>Detected</h1>
//                                 <div className="texthead">

//                                     <h2>Cryptosporidium spp.</h2>


//                                 </div>

//                                 <div className="lastdivtext">


//                                     <p> <strong>About <br /></strong>
//                                         Cryptosporidium spp.. are microscopic parasites that cause a gastrointestinal infection known as
//                                         cryptosporidiosis. These parasites are typically transmitted through contaminated water, food, or
//                                         surfaces, and they can be found in both recreational and drinking water. Infection with
//                                         Cryptosporidium can lead to symptoms such as watery diarrhea, abdominal cramps, nausea,
//                                         vomiting, and sometimes fever. Symptoms can vary in severity and may last from a few days to
//                                         several weeks, particularly in immunocompromised individuals, where the infection can be more
//                                         severe and prolonged. </p>

//                                     <p><strong>Advice<br /></strong>
//                                         <ol>
//                                             <li><strong>  Stay Hydrated:</strong>  Hydration is essential, especially since diarrhea can lead to significant fluid
//                                                 loss. Drink plenty of fluids such as water, clear broths, and oral rehydration solutions containing
//                                                 electrolytes to prevent dehydration.</li>
//                                             <li> <strong> Rest:</strong>  Give your body time to recover by getting sufficient rest. Avoid strenuous activities and
//                                                 take care of yourself.</li>


//                                             <li> <strong>  Follow a Bland Diet: </strong> : When you feel able to eat, start with bland, easily digestible foods such as
//                                                 bananas, rice, applesauce, and toast (the BRAT diet). Avoid dairy products, greasy or spicy
//                                                 foods, and high-fiber foods, as they may irritate the digestive system.</li>

//                                             <li> <strong>   Good Hygiene:</strong>   To prevent spreading the infection, wash your hands thoroughly with soap and
//                                                 water after using the bathroom and before preparing or eating food. Ensure that any surfaces
//                                                 that may be contaminated are properly disinfected</li>


//                                             <li> <strong>   Seek Medical Attention if Needed: </strong> If symptoms persist for more than a few days, worsen, or if
//                                                 you experience signs of severe dehydration (such as extreme thirst, dry mouth, or significantly
//                                                 reduced urination), consult a healthcare provider. In some cases, especially in
//                                                 immunocompromised individuals, medication may be required to manage the infection
//                                                 effectively.
//                                             </li>
//                                         </ol>

//                                     </p>
//                                     <p>
//                                         Taking preventive measures, such as ensuring good hygiene and avoiding drinking untreated
//                                         water, can help reduce the risk of contracting Cryptosporidium spp.. infections.

//                                     </p>




//                                     <p>Our treatment and advice suggestions have been devised by Nutritional Therapists and
//                                         Functional Medicine Practitioners. Any treatment protocol should only be undertaken under the
//                                         supervision of a Healthcare Practitioner.<br />
//                                         For persistent and/or serious symptoms, it is recommended to speak to your Doctor.
//                                     </p>


//                                 </div>
//                                 <div style={{ display: 'flex', justifyContent: 'center' }}>
//                                     <img style={{ marginTop: '5mm' }} src='/imgggg.pngg' alt="" />
//                                 </div>

//                             </div>




//                             <div className="secenddivend">

//                                 {/* <img src="/lower.png" alt="" /> */}
//                                 {reportStyle.logo === yourGutMap.logo ? <img src="/lower.png" alt="" /> : null}
//                             </div>

//                         </div>
//                     </>}




//                     {/* Entamoeba histolytica* */}
//                     {kit.result.find(item => item['Entamoeba histolytica'])?.["Entamoeba histolytica"] === "detected" && <>
//                         <div className="lastdiv">
//                             <div className="firstdivhead">
//                                 {reportStyle.logo === yourGutMap.logo ? <img src="/logo2.png" alt="" style={{ marginTop: '10px' }} /> : null}
//                                 {/* <img src="/uper.png" alt="" /> */}
//                                 {reportStyle.logo === yourGutMap.logo ? <img src="/uper.png" alt="" /> : null}


//                             </div>
//                             <div className="lastdivcenter">
//                                 <h1 style={{ color: "red" }}>Detected</h1>
//                                 <div className="texthead">

//                                     <h2>Cryptosporidium spp.</h2>


//                                 </div>

//                                 <div className="lastdivtext">

//                                     <p style={{ color: 'red' }}>
//                                         Caution- in a small percentage of cases, Entamoeba histolytica can cause severe symptoms
//                                         and lead to serious complications. If this has been identified in your stool test you should seek
//                                         the advice of your Doctor or Healthcare Practitioner.
//                                     </p>
//                                     <p> <strong>About <br /></strong>
//                                         Entamoeba histolytica is a parasitic amoeba that causes an intestinal infection known as
//                                         amoebiasis. It is primarily transmitted through the fecal-oral route, often via contaminated food
//                                         or water, and is more prevalent in areas with poor sanitation. Symptoms of amoebiasis can
//                                         range from mild to severe and may include watery diarrhea, abdominal pain, cramping, and, in
//                                         some cases, dysentery, which is characterized by bloody diarrhea and mucus in the stool. In
//                                         severe cases, the infection can lead to complications such as abscesses in the liver. </p>

//                                     <p><strong>Advice<br /></strong>
//                                         <ol>
//                                             <li><strong>  Stay Hydrated:</strong>   Hydration is critical, especially if you are experiencing diarrhea. Drink plenty of
//                                                 fluids, such as water, clear broths, and oral rehydration solutions that contain electrolytes to
//                                                 prevent dehydration.</li>
//                                             <li> <strong> Rest:</strong>   Make sure to get sufficient rest to allow your body to recover. Avoid strenuous activities
//                                                 until you feel better.</li>


//                                             <li> <strong>  Follow a Bland Diet: </strong> : When you feel ready to eat, start with bland, easily digestible foods like
//                                                 bananas, rice, applesauce, and toast (the BRAT diet). Avoid fatty, spicy, and high-fiber foods
//                                                 that can irritate your digestive system.</li>



//                                             <li> <strong>   Seek Medical Attention: </strong>  If symptoms persist for more than a couple of days, worsen, or if you
//                                                 experience severe symptoms such as bloody diarrhea or signs of dehydration (such as extreme
//                                                 thirst, dry mouth, or decreased urination), consult a healthcare provider. Diagnosis may require
//                                                 stool tests, and treatment typically involves specific antibiotics or antiparasitic medications.
//                                             </li>


//                                             <li> <strong>   Good Hygiene:</strong>  To prevent the spread of Entamoeba histolytica, wash your hands thoroughly
//                                                 with soap and water after using the bathroom and before preparing or consuming food. Ensure
//                                                 that food is cooked properly and water is treated or boiled if the source is uncertain.</li>
//                                         </ol>

//                                     </p>
//                                     <p>
//                                         Taking these precautions can help manage symptoms and prevent the spread of the infection

//                                     </p>




//                                     <p>Our treatment and advice suggestions have been devised by Nutritional Therapists and
//                                         Functional Medicine Practitioners. Any treatment protocol should only be undertaken under the
//                                         supervision of a Healthcare Practitioner.<br />
//                                         For persistent and/or serious symptoms, it is recommended to speak to your Doctor.
//                                     </p>


//                                 </div>
//                                 <div style={{ display: 'flex', justifyContent: 'center' }}>
//                                     <img style={{ marginTop: '5mm' }} src='/imgggg.pngg' alt="" />
//                                 </div>

//                             </div>




//                             <div className="secenddivend">

//                                 {/* <img src="/lower.png" alt="" /> */}
//                                 {reportStyle.logo === yourGutMap.logo ? <img src="/lower.png" alt="" /> : null}
//                             </div>

//                         </div>
//                     </>}




//                     {/* Giardia lamblia* */}
//                     {kit.result.find(item => item['Giardia lamblia'])?.["Giardia lamblia"] === "detected" && <>
//                         <div className="lastdiv">
//                             <div className="firstdivhead">
//                                 {reportStyle.logo === yourGutMap.logo ? <img src="/logo2.png" alt="" style={{ marginTop: '10px' }} /> : null}
//                                 {/* <img src="/uper.png" alt="" /> */}
//                                 {reportStyle.logo === yourGutMap.logo ? <img src="/uper.png" alt="" /> : null}


//                             </div>
//                             <div className="lastdivcenter">
//                                 <h1 style={{ color: "red" }}>Detected</h1>
//                                 <div className="texthead">

//                                     <h2>Giardia lamblia</h2>


//                                 </div>

//                                 <div className="lastdivtext">


//                                     <p> <strong>About <br /></strong>
//                                         Giardia lamblia is a microscopic parasite that causes a gastrointestinal infection known as
//                                         giardiasis. It is commonly transmitted through contaminated water, particularly in areas with poor
//                                         sanitation, and can also spread through food or person-to-person contact. Symptoms of
//                                         giardiasis typically include diarrhea (which may be foul-smelling and greasy), abdominal
//                                         cramps, bloating, nausea, fatigue, and weight loss. Symptoms may appear one to three weeks
//                                         after exposure and can last for several weeks to months if left untreated.</p>

//                                     <p><strong>Advice<br /></strong>
//                                         <ol>
//                                             <li><strong>  Stay Hydrated:</strong>  Maintaining hydration is crucial, especially if you are experiencing diarrhea.
//                                                 Drink plenty of fluids such as water, clear broths, and oral rehydration solutions that contain
//                                                 electrolytes to prevent dehydration.</li>
//                                             <li> <strong> Rest:</strong>  Ensure you get enough rest to allow your body to recover. Avoid strenuous activities until
//                                                 you feel better</li>


//                                             <li> <strong>  Follow a Bland Diet: </strong> When you feel ready to eat, start with bland, easy-to-digest foods such as
//                                                 bananas, rice, applesauce, and toast (the BRAT diet). Avoid fatty, spicy, or high-fibre foods, as
//                                                 they can aggravate gastrointestinal symptoms.</li>




//                                             <li> <strong>   Seek Medical Attention if Needed: </strong>  If symptoms persist for more than a few days, worsen, or if you
//                                                 experience severe symptoms such as prolonged diarrhoea or signs of dehydration (such as
//                                                 extreme thirst, dry mouth, or significantly reduced urination), consult a healthcare provider.
//                                                 Diagnosis may require stool tests, and treatment typically involves antibiotics or antiparasitic
//                                                 medications to clear the infection.
//                                             </li>

//                                             <li> <strong>   Good Hygiene:</strong>    To reduce the risk of spreading the infection, wash your hands thoroughly with
//                                                 soap and water after using the bathroom and before preparing or eating food. Be cautious with
//                                                 drinking water, particularly when travelling; avoid drinking untreated water or ice made from it.</li>
//                                         </ol>

//                                     </p>
//                                     <p>
//                                         Taking these measures can help manage symptoms and prevent the spread of Giardia lamblia
//                                         infections.

//                                     </p>




//                                     <p>Our treatment and advice suggestions have been devised by Nutritional Therapists and
//                                         Functional Medicine Practitioners. Any treatment protocol should only be undertaken under the
//                                         supervision of a Healthcare Practitioner.<br />
//                                         For persistent and/or serious symptoms, it is recommended to speak to your Doctor.
//                                     </p>


//                                 </div>
//                                 <div style={{ display: 'flex', justifyContent: 'center' }}>
//                                     <img style={{ marginTop: '5mm' }} src='/imgggg.pngg' alt="" />
//                                 </div>

//                             </div>




//                             <div className="secenddivend">
//                             {reportStyle.logo === yourGutMap.logo ? <img src="/lower.png" alt="" /> : null}
//                                 {/* <img src="/lower.png" alt="" /> */}
//                             </div>

//                         </div>
//                     </>}








//                 </>)}
//             </div >
//         </div>

//     </>)
// }

// export default Pararesults






import React, { useEffect, useRef, useState } from 'react'
import "./pararesult.css"
import html2pdf from 'html2pdf.js';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { message } from 'antd';
function Pararesults({ myReportStyle }) {
    // const [styleName,setStyleName] = useState('TestMe')
    const { id } = useParams();
    // const  id  = "66977549a7be420015bff77e"
    const YourGutMap = {
        "logo": "/paralogo.jpg",
        "primaryColor": "#724e9e",
        "secondaryColor": "#4180b8",
    }
    const feelGut = {
        "logo": "/logofg.png",
        "primaryColor": "#724e9e",
        "secondaryColor": "#4180b8",
    }
    const Testme = {
        "logo": "/logotestme.png",
        "primaryColor": "#04BACF",
        "secondaryColor": "#BOBOBO",
    }

    const [reportStyle, setReportStyle] = useState(YourGutMap)

    const [isPdfMode, setIsPdfMode] = useState(false);
    const [kit, setkit] = useState({
        "kitid": "loading...",
        "patientName": "loading...",
        "receiveddate": "loading...",
        "resultDate": "loading...",
        "result": [
            { "Helicobacter pylori": "loading..." },
            { "Plesiomonas shigelloides": "loading..." },
            { "Clostridium difficile": "loading..." },
            { "Enteroinvasive E. coli (EIEC)": "loading..." },
            { "Yersinia enterocolitica": "loading..." },
            { "Adenovirus": "loading..." },
            { "Salmonella": "loading..." },
            { "Astrovirus": "loading..." },
            { "Campylobacter jejuni/coli": "loading..." },
            { "Norovirus GI/GII": "loading..." },
            { "Vibrio cholerae": "loading..." },
            { "Rotavirus A": "loading..." },
            { "E. coli O157": "loading..." },
            { "Sapovirus (I,II,IV and V)": "loading..." },
            { "Enteroaggregative E. coli (EAEC)": "loading..." },
            { "Cryptosporidium spp.": "loading..." },
            { "Enteropathogenic E. coli (EPEC)": "loading..." },
            { "Cyclospora cayetanensis": "loading..." },
            { "Enterotoxigenic E. coli (ETEC)": "loading..." },
            { "Entamoeba histolytica": "loading..." },
            { "Shigatoxin-producing E. coli (STEC)": "loading..." },
            { "Giardia lamblia": "loading..." }
        ],
    });

    const contentRef = useRef();

    const getdata = async () => {


        let data = JSON.stringify({
            "_id": id
        });

        let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: 'https://YourGutMap-food-sensitivity-423a2af84621.herokuapp.com/viewreportdata',
            headers: {
                'Content-Type': 'application/json'
            },
            data: data
        };

        axios.request(config)
            .then(async (response) => {
                await setkit(response.data);
                if (response.data.result.find(item => item['Helicobacter pylori'])) {
                    await setIsPdfMode(false)
                }
                else {
                    await setIsPdfMode(true)
                }
            })
            .catch((error) => {
                console.log(error);
            });


    }



    useEffect(() => {


        getdata()


    }, [])


    // useEffect( () => {
    //     if (kit.kitid !== "loading..." && isPdfMode === false) {
    //          kit.reportstyle === 'YourGutMap Report Style' ? setReportStyle(YourGutMap) :  kit.reportstyle === 'TestMe Report Style' ? setReportStyle(Testme)  :  setReportStyle(feelGut) }
    //         }, [kit])

    // useEffect(() => {
    //     if (kit.kitid !== "loading..." && isPdfMode === false) {
    //         if (myReportStyle) {
    //             handleDownloadPDF();
    //         }
    //     }
    // }, [reportStyle])
    
useEffect(() => {
    console.log(myReportStyle.styleName)
    setStyleName(myReportStyle.styleName)
}, [reportStyle])

useEffect(() => {
    if (kit.kitid !== "loading..." && reportStyle.logo!="/blank.png" && isPdfMode === false) {
        if (myReportStyle) {
            setTimeout(() => {
                console.log( " logo"+ reportStyle.logo)
                handleDownloadPDF();
                
            }, 1000);
        }
    }
}, [reportStyle,reportStyle.logo,kit])



    const [primaryColor, setPrimaryColor] = useState("#724e9e");
    const [mainColor, setMainColor] = useState("#724e9e");
    const [secondaryColor, setSecondaryColor] = useState("#4180b8");
    //   const [logo,setLogo] = useState("/logo.jpg");
    const [logo, setLogo] = useState("/blank.png");
    const [styleName, setStyleName] = useState("YourGutMap");
    const [header, setHeader] = useState()
    const [footer, setFooter] = useState()
    const [isUpdated, setIsUpdated] = useState(false)

    //   YourGutMap = {
    //     "header": styleName === 'YourGutMap' ? "/design4.png" : "blank.png",
    //     "footer": styleName === 'YourGutMap' ? "/design3.png" : "blank.png",
    //     "logo":logo,
    //     "primaryColor":primaryColor,
    //     "secondaryColor":secondaryColor,
    //     "fontColor":primaryColor,
    // }

    // const lightenColor = (color, percent) => {
    //     const num = parseInt(color.replace("#", ""), 16);
    //     const amt = Math.round(2.55 * percent);
    //     const R = (num >> 16) + amt;
    //     const G = ((num >> 8) & 0x00ff) + amt;
    //     const B = (num & 0x0000ff) + amt;

    //     return (
    //       "#" +
    //       (
    //         0x1000000 +
    //         (R < 255 ? (R < 1 ? 0 : R) : 255) * 0x10000 +
    //         (G < 255 ? (G < 1 ? 0 : G) : 255) * 0x100 +
    //         (B < 255 ? (B < 1 ? 0 : B) : 255)
    //       )
    //         .toString(16)
    //         .slice(1)
    //     );
    //   };


    // useEffect(() => {
    //     const lightColor = lightenColor(primaryColor, 40); // 40% lighter

    //   const updatedMap = {
    //     header: header || "/blank.png",
    //     footer: footer || "/blank.png",
    //     logo: logo,
    //     primaryColor: lightColor,
    //     mainColor:primaryColor,
    //     secondaryColor: secondaryColor,
    //     fontColor: primaryColor,
    //     header:header,
    //     footer:footer,
    //   };

    //   setReportStyle(updatedMap);
    // }, [styleName, logo, primaryColor, secondaryColor]);


    useEffect(() => {
        console.log(myReportStyle)
        setReportStyle(myReportStyle)
    }, [myReportStyle])

    // useEffect(() => {
    //     const fetchReportStyle = async () => {
    //       try {
    //         // const response = await fetch("http://localhost:1337/getReportStyleByKit", {
    //         const response = await fetch("https://yourgutmap-food-sensitivity-423a2af84621.herokuapp.com/getReportStyleByKit", {
    //         // const response = await fetch("http://192.168.100.48:1338/getReportStyleByKit", {
    //           method: "POST",
    //           headers: {
    //             "Content-Type": "application/json",
    //           },
    //           body: JSON.stringify({ kitId: id }), // Send the kit ID
    //         });

    //         const result = await response.json();

    //         if (response.ok && result.style) {
    //           // Update colors and logo if style data exists
    //           setPrimaryColor(result.style.primaryColor);
    //           setSecondaryColor(result.style.secondaryColor);
    //           setLogo(result.style.imageBase64);
    //           setStyleName(result.style.styleName);
    //           setHeader(result.style.header);
    //           setFooter(result.style.footer);
    //           setIsUpdated(true)
    //           // setStyleUpdated(true);
    //           // console.log(primaryColor)
    //         //   alert(reportStyle.styleName)
    //         }
    //       } catch (error) {
    //         console.error("Error fetching report style:", error);
    //       }
    //     };

    //     fetchReportStyle();
    //   }, [id]); // Runs when the component mounts










    const handleDownloadPDF = async () => {
        const button = document.getElementById("downloadButton");
        if (button) button.classList.add("hide-for-pdf");
        const namekit = document.querySelector('.namekit')
        if (namekit && reportStyle.logo === YourGutMap.logo) {
            namekit.classList.add('download-margin')
        }
        const hide = message.loading("Your report is downloading...", 0);
        const content = await document.getElementById('ali'); // Replace with the ID of the content you want to export
        console.log(content)

        const opt = {
            margin: 0,
            filename: "YourGutMap - Parasitology result " + kit.kitid + ".pdf",
            image: { type: 'jpeg', quality: 1 },
            html2canvas: { scale: 2 },
            jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
        };

        const seee = html2pdf().from(content).set(opt).outputPdf();



        seee.save("YourGutMap - Parasitology result " + kit.kitid + ".pdf")


        await setTimeout(() => {
            hide(); // Call hide to stop the loading message
            message.success("Report has been downloaded Successfully!");
        }, 0);
        if (namekit && reportStyle.logo === YourGutMap.logo) {
            namekit?.classList.remove('download-margin')
        }
        button?.classList?.remove("hide-for-pdf");

    };






    return (<>


        <div
            className="mainnnnnnnnn"
            style={{
                display: !isPdfMode ? "flex" : "block",
                fontFamily: 'poppins'
            }}
        >
            {!isPdfMode && <>


                {styleName !== 'TestMe' ? <button style={{ top: "170mm", zIndex: 100, marginTop: "140px", background: reportStyle.mainColor }} className='downloadbuttonviewreport' onClick={handleDownloadPDF}>Download</button> : null}

            </>}
            <div style={{ fontFamily: 'poppins' }} id='ali'>

                {isPdfMode ? (<>

                    <iframe
                        // src={kit.result[1].url}
                        src={kit.result.find(item => item['url']).url}
                        style={{ width: "95%", height: "98vh" }}
                    />
                    {/* {alert(kit.result)} */}
                    {/* {console.log(kit.result)} */}
                </>) : (<>

                    {styleName === 'TestMe' ? <> <div className="page1"
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "space-between",
                            height: "297mm",
                            width: "210mm",
                        }}
                    >
                        <div style={{ position: "relative", height: "100%", width: "100%" }}>
                            {/* Background Image */}
                            <img
                                src="/bgtestme.jpg"
                                alt="background"
                                style={{
                                    position: "absolute",
                                    top: 0,
                                    left: 0,
                                    width: "100%",
                                    height: "100%",
                                    objectFit: "cover", // Or use "contain" depending on your needs
                                    zIndex: 0,
                                }}
                            />

                            {/* Logo on top */}
                            <img
                                src="/testmelogo2.png"
                                alt="logo"
                                style={{
                                    position: "absolute",
                                    top: "4rem", // Adjust position as needed
                                    left: "2rem",
                                    width: "350px",
                                    zIndex: 1,
                                }}
                            />
                            <h1 style={{
                                position: "absolute",
                                top: "31rem", // Adjust position as needed
                                left: "3rem",
                                // width: "650px",
                                fontSize: "53px",
                                zIndex: 2,
                                color: "yellow"
                            }}>Parasitology</h1>
                            <h1 style={{
                                position: "absolute",
                                top: "35rem", // Adjust position as needed
                                left: "3rem",
                                // width: "650px",
                                fontSize: "44px",
                                zIndex: 2,
                                color: "white"
                            }}>Test Report</h1>
                            <button
                                style={{
                                    position: "absolute",
                                    top: "45rem", // Adjust position as needed
                                    left: "14rem",
                                    width: "350px",
                                    height: "50px",
                                    border: "none",
                                    borderRadius: "10px",
                                    background: "white",
                                    fontSize: "25px",
                                    // color: `${reportStyle["primaryColor"]}`,
                                    color: "black"
                                }}
                                className=""
                                id="downloadButton"
                                onClick={handleDownloadPDF}
                            >
                                Download
                            </button>
                            <div className="" style={{
                                position: "absolute",
                                top: "60rem", // Adjust position as needed
                                right: "2rem",
                                // width: "50px",
                                zIndex: 1,
                                display: "flex",
                                justifyContent: "space-between",
                                width: "90%",
                                height: "80px",
                            }}>
                                <div className="">
                                    <div className="" style={{ height: "35px", width: "350px", background: "white", borderRadius: "20px", display: "flex", justifyContent: "start", paddingLeft: "20px", alignItems: "center", marginBottom: "10px" }}>Name : {kit.patientName}</div>
                                    <div className="" style={{ height: "35px", width: "350px", background: "white", borderRadius: "20px", display: "flex", justifyContent: "start", paddingLeft: "20px", alignItems: "center" }}>Kit ID : {kit.kitid}</div>
                                </div>
                                <img
                                    src="/testmeend2.png"
                                    alt="logo"
                                    style={{
                                        // width:"250px"
                                    }}
                                />

                            </div>
                        </div>
                    </div>
                    </> : null}
                    {styleName !== 'TestMe' ? <><div className="firstdiv" style={{ position: "relative" }}>
                        <div className="firstdiv" style={{ height: "500px" }}>
                            <div className="firstdivhead" style={{ marginLeft: "0px" }}>


                                {<img src={reportStyle.header || '/blank.png'} alt="" style={{ width: "800px", height: "160px", marginLeft: "0px" }} />}
                            </div>
                            <div className="firstdivcenter" style={{ display: "flex", flexDirection: "column", marginTop: reportStyle.logo === feelGut.logo ? '290px' : "265px" }}>

                                <img src={reportStyle.logo} width={reportStyle.logo === feelGut.logo ? '400px' : '280px'} style={{ marginBottom: reportStyle.logo === YourGutMap.logo ? "120px" : "50px" }} alt='' />
                                {reportStyle.logo === feelGut.logo ? <h4 style={{ color: "#003074", fontSize: "17", fontWeight: "bold", marginBottom: "80px" }}>Advanced Parasitology Test</h4> : null}
                            </div>

                            {/* <h1 className='testreport_heading' style={{background:reportStyle.mainColor,width:"405px",padding:"10px",paddingLeft:"70px",paddingRight:"70px"}}>Parasitology Test Report</h1> */}
                            <h1
                                className='testreport_heading'
                                style={{
                                    background: reportStyle.mainColor,
                                    width: "405px",
                                    padding: "10px 70px",
                                    margin: "0 auto", // ✅ This will center it
                                    textAlign: "center", // optional: ensure text is centered too
                                    marginBottom: "20px",
                                    paddingBottom: "20px"
                                }}
                            >
                                Parasitology Test Report
                            </h1>

                            <div className='' style={{ color: '#6E4E9F', marginBottom: "190px" }}>
                                <div className='' style={{ display: "flex", flexDirection: "column", alignItems: "center", height: "80px", marginBottom: "20px", padding: "0px" }}>
                                    <h2 style={{ color: reportStyle.mainColor, margin: "0px" }}>Name   :  {kit.patientName}</h2>
                                    <h2 style={{ color: reportStyle.mainColor, margin: "0px" }}>Kit ID :  {kit.kitid}</h2>
                                </div>
                                <div className="firstdivend" style={{ marginTop: "15px", overflow: "hidden", position: "absolute", bottom: styleName === "BlueHorizon" ? "-7px" : "0px", left: "0px" }}>


                                    {<img src={reportStyle.footer || '/blank.png'} alt="" style={{ width: "800px", height: "120px" }} />}
                                </div>
                            </div>

                        </div>



                    </div></> : null}

                    <div className="secenddiv">
                        <div className="firstdivhead" style={{ overflow: "hidden", marginTop: "0px" }}>
                            {styleName === 'YourGutMap' ? <img src={reportStyle.header || '/blank.png'} alt="" style={{ width: "800px", height: "160px" }} /> : null}
                        </div>



                        <div className="secenddivcenter" style={{ marginTop: reportStyle.logo === feelGut.logo ? "40px" : styleName === 'TestMe' ? "40px" : "0px" }}>
                            {styleName === 'TestMe' ? <><img
                                src="/testmemainlogo.png"
                                alt="logo"
                                style={{
                                    width: "200px",
                                    marginTop: "10px",
                                    marginBottom: "10px",
                                    marginLeft: '500px'
                                }}
                            /></> : null}
                            <div className="report" style={{ paddingBottom: "20px", background: `linear-gradient(90deg, ${reportStyle.primaryColor}, #dfe3fc, ${reportStyle.primaryColor})` }}>
                                <h2>Gastrointestinal Test Report</h2>
                            </div>
                            <div className="reporttext">
                                <div className="reportleft">
                                    <span>
                                        <h4>sample ID:</h4>
                                        <h5>{kit.kitid}</h5>
                                        <h4> Specimen:</h4>
                                        <h5 style={{ borderTop: "1px solid #fff" }}>Fecal - Native</h5>
                                    </span>
                                    <span>

                                        <h4>Received Date:</h4>
                                        <h5>{kit.receiveddate}</h5>
                                        <h4> Completed Date:</h4>
                                        <h5>{kit.resultDate}</h5>
                                    </span>

                                    {/* <span>

                                <h4>Received Date:</h4>
                                <h5>2024-10-07 10:45:00</h5>
                                <h4> Completed Date:</h4>
                            </span> */}

                                </div>
                                {/* <div className="reportright">
                            <h4>Fecal - Native</h4>
                            <h4>2024-10-10 13:09:39</h4>
                        </div> */}


                            </div>

                            <div className="maindivvvv">


                                <div className="maindivvvvleft" >
                                    <div className="result" style={{ background: `linear-gradient(90deg, ${reportStyle.primaryColor}, #dfe3fc, ${reportStyle.primaryColor})` }}><h2>Test Result</h2></div>
                                    <div className="boxhead" style={{ background: reportStyle.mainColor }}>
                                        <h4>Pathogenic Bacteria
                                        </h4>

                                    </div>
                                    <div className="box">


                                        <table>
                                            <tbody>
                                                <tr style={{ background: "#dfe3fc" }} className={kit.result.find(item => item['Helicobacter pylori'])?.["Helicobacter pylori"] === "detected" ? 'colorchange' : ""}>
                                                    <td style={{ background: `linear-gradient(90deg, ${reportStyle.primaryColor}, #dfe3fc, ${reportStyle.primaryColor})` }}>Helicobacter pylori</td>
                                                    <td  >{kit.result.find(item => item['Helicobacter pylori'])?.["Helicobacter pylori"]}</td>
                                                </tr>

                                                <tr className={kit.result.find(item => item['Clostridium difficile'])?.["Clostridium difficile"] === "detected" ? 'colorchange' : ""}>

                                                    <td style={{ background: `linear-gradient(90deg, ${reportStyle.primaryColor}, #dfe3fc, ${reportStyle.primaryColor})` }}>Clostridium difficile</td>
                                                    <td   >{kit.result.find(item => item['Clostridium difficile'])?.["Clostridium difficile"]}</td>
                                                </tr>

                                                <tr className={kit.result.find(item => item['Plesiomonas shigelloides'])?.["Plesiomonas shigelloides"] === "detected" ? 'colorchange' : ""}>
                                                    <td style={{ background: `linear-gradient(90deg, ${reportStyle.primaryColor}, #dfe3fc, ${reportStyle.primaryColor})` }}>plesiomonas shigelloides</td>
                                                    <td>{kit.result.find(item => item['Plesiomonas shigelloides'])?.["Plesiomonas shigelloides"]}</td>
                                                </tr>


                                                <tr className={kit.result.find(item => item['Salmonella'])?.["Salmonella"] === "detected" ? 'colorchange' : ""}>
                                                    <td style={{ background: `linear-gradient(90deg, ${reportStyle.primaryColor}, #dfe3fc, ${reportStyle.primaryColor})` }}>Salmonella</td>
                                                    <td>{kit.result.find(item => item['Salmonella'])?.["Salmonella"]}</td>
                                                </tr>


                                            </tbody>


                                            <tbody>



                                                <tr className={kit.result.find(item => item['Yersinia enterocolitica'])?.["Yersinia enterocolitica"] === "detected" ? 'colorchange' : ""}>

                                                    <td style={{ background: `linear-gradient(90deg, ${reportStyle.primaryColor}, #dfe3fc, ${reportStyle.primaryColor})` }}>Yersinia enterocolitica</td>
                                                    <td>{kit.result.find(item => item['Yersinia enterocolitica'])?.["Yersinia enterocolitica"]}</td>
                                                </tr>
                                                <tr className={kit.result.find(item => item['Campylobacter jejuni/coli'])?.["Campylobacter jejuni/coli"] === "detected" ? 'colorchange' : ""}>
                                                    <td style={{ background: `linear-gradient(90deg, ${reportStyle.primaryColor}, #dfe3fc, ${reportStyle.primaryColor})` }}>Campylobacter jejuni/coli</td>
                                                    <td>{kit.result.find(item => item['Campylobacter jejuni/coli'])?.["Campylobacter jejuni/coli"]}</td>
                                                </tr>

                                                <tr className={kit.result.find(item => item['Vibrio cholerae'])?.["Vibrio cholerae"] === "detected" ? 'colorchange' : ""}>

                                                    <td style={{ background: `linear-gradient(90deg, ${reportStyle.primaryColor}, #dfe3fc, ${reportStyle.primaryColor})` }}>Vibrio cholerae</td>
                                                    <td>{kit.result.find(item => item['Vibrio cholerae'])?.["Vibrio cholerae"]}</td>
                                                </tr>


                                                <tr className={kit.result.find(item => item['E. coli O157'])?.["E. coli O157"] === "detected" ? 'colorchange' : ""}>
                                                    <td style={{ background: `linear-gradient(90deg, ${reportStyle.primaryColor}, #dfe3fc, ${reportStyle.primaryColor})` }}>E. coli O157</td>
                                                    <td>{kit.result.find(item => item['E. coli O157'])?.["E. coli O157"]}</td>
                                                </tr>

                                            </tbody>


                                            <tbody>




                                                <tr className={kit.result.find(item => item['Enteroaggregative E. coli (EAEC)'])?.["Enteroaggregative E. coli (EAEC)"] === "detected" ? 'colorchange' : ""}>

                                                    <td style={{ background: `linear-gradient(90deg, ${reportStyle.primaryColor}, #dfe3fc, ${reportStyle.primaryColor})` }}>Enteroaggregative E. coli (EAEC) </td>
                                                    <td > {kit.result.find(item => item['Enteroaggregative E. coli (EAEC)'])?.["Enteroaggregative E. coli (EAEC)"]}</td>
                                                </tr>
                                                <tr className={kit.result.find(item => item['Enteropathogenic E. coli (EPEC)'])?.["Enteropathogenic E. coli (EPEC)"] === "detected" ? 'colorchange' : ""}>
                                                    <td style={{ background: `linear-gradient(90deg, ${reportStyle.primaryColor}, #dfe3fc, ${reportStyle.primaryColor})` }}>Enteropathogenic E. coli (EPEC) </td>
                                                    <td>{kit.result.find(item => item['Enteropathogenic E. coli (EPEC)'])?.["Enteropathogenic E. coli (EPEC)"]}</td>
                                                </tr>

                                                <tr className={kit.result.find(item => item['Enterotoxigenic E. coli (ETEC)'])?.["Enterotoxigenic E. coli (ETEC)"] === "detected" ? 'colorchange' : ""}>

                                                    <td style={{ background: `linear-gradient(90deg, ${reportStyle.primaryColor}, #dfe3fc, ${reportStyle.primaryColor})` }}>Enterotoxigenic E. coli (ETEC) LT</td>
                                                    <td>{kit.result.find(item => item['Enterotoxigenic E. coli (ETEC)'])?.["Enterotoxigenic E. coli (ETEC)"]}</td>
                                                </tr>

                                                <tr className={kit.result.find(item => item['Shigatoxin-producing E. coli (STEC)'])?.["Shigatoxin-producing E. coli (STEC)"] === "detected" ? 'colorchange' : ""}>
                                                    <td style={{ background: `linear-gradient(90deg, ${reportStyle.primaryColor}, #dfe3fc, ${reportStyle.primaryColor})` }}>Shiga-Toxin-producing E. coli (STEC) </td>
                                                    <td>{kit.result.find(item => item['Shigatoxin-producing E. coli (STEC)'])?.["Shigatoxin-producing E. coli (STEC)"]}</td>
                                                </tr>

                                            </tbody>



                                            <tbody>


                                                <tr className={kit.result.find(item => item['Enteroinvasive E. coli (EIEC)'])?.["Enteroinvasive E. coli (EIEC)"] === "detected" ? 'colorchange' : ""}>
                                                    <td style={{ background: `linear-gradient(90deg, ${reportStyle.primaryColor}, #dfe3fc, ${reportStyle.primaryColor})` }}>Enteroinvasive E. coli (EIEC) </td>
                                                    <td>{kit.result.find(item => item['Enteroinvasive E. coli (EIEC)'])?.["Enteroinvasive E. coli (EIEC)"]}</td>
                                                </tr>



                                            </tbody>



                                        </table>


                                    </div>





                                    <div className="boxhead" style={{ background: reportStyle.mainColor }}>
                                        <h4 > Viruses                                    </h4>

                                    </div>
                                    <div className="box">


                                        <table>



                                            <tbody>





                                                <tr className={kit.result.find(item => item['Adenovirus'])?.["Adenovirus"] === "detected" ? 'colorchange' : ""}>
                                                    <td style={{ background: `linear-gradient(90deg, ${reportStyle.primaryColor}, #dfe3fc, ${reportStyle.primaryColor})` }}>Adenovirus </td>
                                                    <td>{kit.result.find(item => item['Adenovirus'])?.["Adenovirus"]}</td>
                                                </tr>

                                                <tr className={kit.result.find(item => item['Astrovirus'])?.["Astrovirus"] === "detected" ? 'colorchange' : ""}>
                                                    <td style={{ background: `linear-gradient(90deg, ${reportStyle.primaryColor}, #dfe3fc, ${reportStyle.primaryColor})` }}>Astrovirus</td>
                                                    <td >{kit.result.find(item => item['Astrovirus'])?.["Astrovirus"]}</td>
                                                </tr>
                                                <tr className={kit.result.find(item => item['Norovirus GI/GII'])?.["Norovirus GI/GII"] === "detected" ? 'colorchange' : ""}>
                                                    <td style={{ background: `linear-gradient(90deg, ${reportStyle.primaryColor}, #dfe3fc, ${reportStyle.primaryColor})` }}>Norovirus GI/GII</td>
                                                    <td>{kit.result.find(item => item['Norovirus GI/GII'])?.["Norovirus GI/GII"]}</td>
                                                </tr>
                                                <tr className={kit.result.find(item => item['Rotavirus A'])?.["Rotavirus A"] === "detected" ? 'colorchange' : ""}>
                                                    <td style={{ background: `linear-gradient(90deg, ${reportStyle.primaryColor}, #dfe3fc, ${reportStyle.primaryColor})` }}>Rotavirus A</td>
                                                    <td>{kit.result.find(item => item['Rotavirus A'])?.["Rotavirus A"]}</td>
                                                </tr>

                                            </tbody>

                                            <tbody>






                                                <tr className={kit.result.find(item => item['Sapovirus (I,II,IV and V)'])?.["Sapovirus (I,II,IV and V)"] === "detected" ? 'colorchange' : ""}>
                                                    <td style={{ background: `linear-gradient(90deg, ${reportStyle.primaryColor}, #dfe3fc, ${reportStyle.primaryColor})` }}>Sapovirus (I, II, IV, and V)</td>
                                                    <td>{kit.result.find(item => item['Sapovirus (I,II,IV and V)'])?.["Sapovirus (I,II,IV and V)"]}</td>
                                                </tr>

                                            </tbody>



                                        </table>


                                    </div>



                                    <div className="boxhead" style={{ background: reportStyle.mainColor }}>
                                        <h4 >Parasites</h4>

                                    </div>
                                    <div className="box">


                                        <table>



                                            <tbody>







                                                <tr className={kit.result.find(item => item['Cryptosporidium spp.'])?.["Cryptosporidium spp."] === "detected" ? 'colorchange' : ""}>
                                                    <td style={{ background: `linear-gradient(90deg, ${reportStyle.primaryColor}, #dfe3fc, ${reportStyle.primaryColor})` }}>Cryptosporidium spp.</td>
                                                    <td>{kit.result.find(item => item['Cryptosporidium spp.'])?.["Cryptosporidium spp."]}</td>
                                                </tr>
                                                <tr className={kit.result.find(item => item['Cyclospora cayetanensis'])?.["Cyclospora cayetanensis"] === "detected" ? 'colorchange' : ""}>
                                                    <td style={{ background: `linear-gradient(90deg, ${reportStyle.primaryColor}, #dfe3fc, ${reportStyle.primaryColor})` }}>Cyclospora cayetanensis</td>
                                                    <td>{kit.result.find(item => item['Cyclospora cayetanensis'])?.["Cyclospora cayetanensis"]}</td>
                                                </tr>
                                                <tr className={kit.result.find(item => item['Entamoeba histolytica'])?.["Entamoeba histolytica"] === "detected" ? 'colorchange' : ""}>
                                                    <td style={{ background: `linear-gradient(90deg, ${reportStyle.primaryColor}, #dfe3fc, ${reportStyle.primaryColor})` }}>Entamoeba histolytica</td>
                                                    <td>{kit.result.find(item => item['Entamoeba histolytica'])?.["Entamoeba histolytica"]}</td>
                                                </tr>
                                                <tr className={kit.result.find(item => item['Giardia lamblia'])?.["Giardia lamblia"] === "detected" ? 'colorchange' : ""}>
                                                    <td style={{ background: `linear-gradient(90deg, ${reportStyle.primaryColor}, #dfe3fc, ${reportStyle.primaryColor})` }}>Giardia lamblia</td>
                                                    <td>{kit.result.find(item => item['Giardia lamblia'])?.["Giardia lamblia"]}</td>
                                                </tr>
                                            </tbody>



                                        </table>


                                    </div>


                                </div>














                            </div>

                            <div className="information">
                                <div className="report" >
                                    <h3 style={{ background: `linear-gradient(90deg, ${reportStyle.primaryColor}, #dfe3fc, ${reportStyle.primaryColor})`, borderRadius: '50px' }}>Test Information</h3>

                                </div>
                                <div className="informationtext">
                                    <p> <strong>Methodology: </strong>Laboratory specimens associated with this report were analyzed using molecular techniques. Total nucleic
                                        acids were extracted from the submitted sample and analyzed by PCR amplification using real-time qPCR. Endogenous and
                                        exogenous controls run simultaneously with patient samples ensure the correct operation of the extraction and PCR steps of
                                        this assay</p>
                                    <p><strong>Disclaimer: </strong> Results should be used in conjunction with clinical findings, and should not form the sole basis for a diagnosis or
                                        treatment decision. Negative results do not preclude pathogenic infection and should not be used as the sole basis for
                                        patient management decisions. Negative results must be combined with clinical observations, patient history, and
                                        epidemiological information.</p>
                                </div>
                            </div>



                            {styleName === 'TestMe' ? <><img
                                src="/testmeend.png"
                                alt="logo"
                                style={{
                                    width: "200px",
                                    marginTop: "10px",
                                    marginBottom: "30px",
                                    marginLeft: '550px'
                                }}
                            /></> : null}
                        </div>


                        <div className="secenddivend" style={{ overflow: "hidden", width: "100%" }}>

                            {/* <img src="/lower.png" alt="" /> */}
                            {/* {reportStyle.logo === YourGutMap.logo ? <img src="/lower.png" alt="" /> : null} */}
                            {styleName === 'YourGutMap' ? <img src={reportStyle.footer || '/blank.png'} alt="" style={{ width: "800px", height: "200px" }} /> : null}
                        </div>



                    </div>






                    {/* Helicobacter pylori * */}
                    {kit.result.find(item => item['Helicobacter pylori'])?.["Helicobacter pylori"] === "detected" && <>
                        <div className="lastdiv">
                            <div className="firstdivhead" style={{ overflow: "hidden", marginTop: "0px" }}>
                                {/* {reportStyle.logo === YourGutMap.logo ?<> <img src="/logo2.png" alt="" style={{ marginTop: '10px' }} />  <img src="/uper.png" alt="" /> </>: null} */}
                                {styleName === 'YourGutMap' ? <img src={reportStyle.header || '/blank.png'} alt="" style={{ width: "800px", height: "160px" }} /> : null}


                            </div>
                            <div className="lastdivcenter">
                                {styleName === 'TestMe' ? <><img
                                    src="/testmemainlogo.png"
                                    alt="logo"
                                    style={{
                                        width: "200px",
                                        marginTop: "30px",
                                        marginBottom: "30px",
                                        marginLeft: '500px'
                                    }}
                                /></> : null}
                                <h1 style={{ color: "red" }}>Detected</h1>
                                <div className="texthead" style={{ background: reportStyle.primaryColor }}>

                                    <h2 style={{ color: "white" }}>Helicobacter pylori</h2>


                                </div>

                                <div className="lastdivtext">

                                    <p> <strong>About <br /></strong>
                                        H. pylori is a tiny, spiral-shaped bacterium. It has flagella (bacterial tail), which allows it to move
                                        about and attach itself to the stomach lining, where it's able to survive in the acidic environment
                                        of the stomach. Whilst carrying this bacteria often causes no symptoms at all for many people, it
                                        can play a large contribution to stomach pain, ulcers as well as a number of digestive issues (1).
                                        That said, H.pylori is a bacterium that is normal in low numbers and it is when this bacterium
                                        over colonises the stomach is where potential problems can occur.</p>

                                    <p><strong>Advice<br /></strong>
                                        There are also a number of dietary supplements shown to be helpful in the treatment of H.
                                        pylori, including: Berberine, Goldenseal, Oregano oil, Mastic gum, DGL licorice, Zinc carnosine,
                                        propolis, Green tea, Garlic and Probiotics. Using the below treatments has been shown to be
                                        effective in up to 70% of cases (2,3,4,5). One particular study found efficacy with the following
                                        protocol:</p>

                                    <p>
                                        <ul>
                                            <li>Mastic gum 500mg, 3 times daily</li>
                                            <li> ADP oregano 50mg, 3 times daily</li>
                                            <li>  Pepto bismol 4-6 tabs between meals daily</li>
                                            <li>  Broad Spectrum Probiotic 5 billion, twice daily</li>
                                            <li>  Fibre Blend supplement 14g/day (Psyllium Husk, etc)</li>
                                        </ul>
                                    </p>

                                    <p>Our treatment and advice suggestions have been devised by Nutritional Therapists and
                                        Functional Medicine Practitioners. Any treatment protocol should only be undertaken under the
                                        supervision of a Healthcare Practitioner.<br />
                                        For persistent and/or serious symptoms, it is recommended to speak to your Doctor.
                                    </p>


                                </div>
                                <div style={{ display: 'flex', justifyContent: 'center' }}>
                                    <img style={{ marginTop: '5mm' }} src='/imgggg.pngg' alt="" />
                                </div>
                                {styleName === 'TestMe' ? <><img
                                    src="/testmeend.png"
                                    alt="logo"
                                    style={{
                                        width: "200px",
                                        marginTop: "30px",
                                        marginBottom: "30px",
                                        marginLeft: '550px'
                                    }}
                                /></> : null}
                            </div>




                            <div className="secenddivend" style={{ overflow: "hidden" }}>

                                {/* <img src="/lower.png" alt="" /> */}
                                {/* {reportStyle.logo === YourGutMap.logo ? <img src="/lower.png" alt="" /> : null} */}
                                {styleName === 'YourGutMap' ? <img src={reportStyle.footer || '/blank.png'} alt="" style={{ width: "800px", height: "200px" }} /> : null}
                            </div>

                        </div>
                    </>}





                    {/* Clostridium difficile* */}
                    {kit.result.find(item => item['Clostridium difficile'])?.["Clostridium difficile"] === "detected" && <>
                        <div className="lastdiv">
                            <div className="firstdivhead" style={{ overflow: "hidden", marginTop: "10px" }}>
                                {/* {reportStyle.logo === YourGutMap.logo ? <img src="/logo2.png" alt="" style={{ marginTop: '10px' }} /> : null} */}
                                {styleName === 'YourGutMap' ? <img src={reportStyle.header || '/blank.png'} alt="" style={{ width: "800px", height: "160px" }} /> : null}
                                {/* <img src="/uper.png" alt="" /> */}
                                {/* {reportStyle.logo === YourGutMap.logo ? <img src="/uper.png" alt="" /> : null} */}



                            </div>
                            <div className="lastdivcenter">
                                <h1 style={{ color: "red" }}>Detected</h1>
                                <div className="texthead" style={{ background: `linear-gradient(90deg, ${reportStyle.primaryColor}, #dfe3fc, ${reportStyle.primaryColor})`, borderRadius: '50px' }}>

                                    <h2>Clostridium difficile</h2>


                                </div>

                                <div className="lastdivtext">

                                    <p> <strong>About <br /></strong>
                                        Clostridium difficile is an anaerobic, spore-forming, Gram-positive bacterium, the most common
                                        pathogen that can cause antibiotic-associated diarrhoea. Normal gut flora usually resists
                                        colonisation and overgrowth of C. difficile. Subsequent inflammatory activation in addition to the
                                        direct toxin-associated damage resulting in mild diarrheal disease up to extensive intestinal wall
                                        damage. The incidences of C. difficile infection (CDI) in developed countries have become
                                        increasingly high which may be attributed to the emergence of newer epidemic strains,
                                        extensive use of antibiotics, and limited alternative therapies.</p>

                                    <p><strong>Advice<br /></strong>
                                        Virgin coconut oil is found to have an antimicrobial activity. The active fatty acids have been
                                        tested for their antimicrobial potential against C. difficile in vitro trail. The results have shown the
                                        inhibitory effects on growth.</p>

                                    <p>
                                        In a recently published study, researchers have investigated both herbal extracts of Black seed
                                        soil and Myrrh for their antibacterial activity against two strains of C. difficile. The study found
                                        that Black Seed Seed oil (2%) and Myrrh water extract are effective natural antibacterial agents
                                        to inhibit C. difficile (1). One particular case study used black seed oil, bentonite clay, and
                                        Lactobacillus probiotics to eradicate the infection in a 2 year old (2)
                                    </p>

                                    <p>Our treatment and advice suggestions have been devised by Nutritional Therapists and
                                        Functional Medicine Practitioners. Any treatment protocol should only be undertaken under the
                                        supervision of a Healthcare Practitioner.<br />
                                        For persistent and/or serious symptoms, it is recommended to speak to your Doctor.
                                    </p>


                                </div>
                                <div style={{ display: 'flex', justifyContent: 'center' }}>
                                    <img style={{ marginTop: '5mm' }} src='/imgggg.pngg' alt="" />
                                </div>

                            </div>




                            <div className="secenddivend" style={{ overflow: "hidden" }}>

                                {/* <img src="/lower.png" alt="" /> */}
                                {/* {reportStyle.logo === YourGutMap.logo ? <img src="/lower.png" alt="" /> : null} */}
                                {styleName === 'YourGutMap' ? <img src={reportStyle.footer || '/blank.png'} alt="" style={{ width: "800px", height: "200px" }} /> : null}
                            </div>

                        </div>
                    </>}




                    {/* plesiomonas shigelloides* */}
                    {kit.result.find(item => item['Plesiomonas shigelloides'])?.["Plesiomonas shigelloides"] === "detected" && <>
                        <div className="lastdiv">
                            <div className="firstdivhead" style={{ overflow: "hidden", marginTop: "10px" }}>
                                {/* {reportStyle.logo === YourGutMap.logo ? <img src="/logo2.png" alt="" style={{ marginTop: '10px' }} /> : null} */}
                                {/* <img src="/uper.png" alt="" /> */}
                                {styleName === 'YourGutMap' ? <img src={reportStyle.header || '/blank.png'} alt="" style={{ width: "800px", height: "160px" }} /> : null}



                            </div>
                            <div className="lastdivcenter">
                                <h1 style={{ color: "red" }}>Detected</h1>
                                <div className="texthead" style={{ background: `linear-gradient(90deg, ${reportStyle.primaryColor}, #dfe3fc, ${reportStyle.primaryColor})`, borderRadius: '50px' }}>

                                    <h2>Plesiomonas shigelloides</h2>


                                </div>

                                <div className="lastdivtext">

                                    <p> <strong>About <br /></strong>
                                        Recent studies have suggested that Plesiomonas shigelloides is a cause of diarrhea and
                                        abdominal pain. Plesiomonas shigelloides is an anaerobic gram-negative bacillus commonly
                                        found in aquatic environments. It is an important pathogen of fish and has been implicated as a
                                        cause of enteric disease in humans, especially following the consumption of raw seafood. Most
                                        cases are usually obtained through tropical travel but can also be obtained locally from
                                        untreated water and/or seafood consumption. </p>

                                    <p><strong>Advice<br /></strong>
                                        Infection of Plesiomonas shigelloides are often mild and may not always need treatments, apart
                                        from natural fluid & electrolyte support. For more chronic or severe cases, then some
                                        practitioners may recommend antibiotic therapy </p>


                                    <p>Our treatment and advice suggestions have been devised by Nutritional Therapists and
                                        Functional Medicine Practitioners. Any treatment protocol should only be undertaken under the
                                        supervision of a Healthcare Practitioner.<br />
                                        For persistent and/or serious symptoms, it is recommended to speak to your Doctor.
                                    </p>


                                </div>
                                <div style={{ display: 'flex', justifyContent: 'center' }}>
                                    <img style={{ marginTop: '5mm' }} src='/imgggg.pngg' alt="" />
                                </div>

                            </div>




                            <div className="secenddivend" style={{ overflow: "hidden" }}>

                                {/* {reportStyle.logo === YourGutMap.logo ? <img src="/lower.png" alt="" /> : null} */}
                                {styleName === 'YourGutMap' ? <img src={reportStyle.footer || '/blank.png'} alt="" style={{ width: "800px", height: "200px" }} /> : null}
                                {/* <img src="/lower.png" alt="" /> */}
                            </div>

                        </div>
                    </>}




                    {/*Salmonella **/}
                    {kit.result.find(item => item['Salmonella'])?.["Salmonella"] === "detected" && <>
                        <div className="lastdiv">
                            <div className="firstdivhead" style={{ overflow: "hidden", marginTop: "10px" }}>
                                {/* {reportStyle.logo === YourGutMap.logo ? <img src="/logo2.png" alt="" style={{ marginTop: '10px' }} /> : null} */}
                                {/* <img src="/uper.png" alt="" /> */}
                                {/* {reportStyle.logo === YourGutMap.logo ? <img src="/uper.png" alt="" /> : null} */}
                                {styleName === 'YourGutMap' ? <img src={reportStyle.header || '/blank.png'} alt="" style={{ width: "800px", height: "160px" }} /> : null}



                            </div>
                            <div className="lastdivcenter">
                                <h1 style={{ color: "red" }}>Detected</h1>
                                <div className="texthead" style={{ background: `linear-gradient(90deg, ${reportStyle.primaryColor}, #dfe3fc, ${reportStyle.primaryColor})`, borderRadius: '50px' }}>

                                    <h2>Salmonella (Genus Group)</h2>


                                </div>

                                <div className="lastdivtext">

                                    <p> <strong>About <br /></strong>
                                        Salmonella is a type of bacteria commonly found in the intestines of animals and humans,
                                        where it can sometimes cause infections. When introduced into the human digestive tract, often
                                        through contaminated food or water, it can lead to an illness known as salmonellosis. This
                                        infection causes symptoms like diarrhoea, fever, and abdominal cramps as the bacteria invade
                                        and inflame the gut lining. While most cases resolve on their own, severe infections may require
                                        medical treatment, particularly in young children, the elderly, or those with weakened immune
                                        systems. </p>

                                    <p><strong>Advice<br /></strong>
                                        <strong>Hydration:</strong> The primary treatment is rehydration. Since diarrhoea can lead to fluid loss, drinking
                                        plenty of water or oral rehydration solutions is essential to prevent dehydration.
                                        <br />  <strong> Rest:</strong> Resting allows the body to focus its energy on fighting the infection.
                                        <br />   <strong> Diet:</strong> Eating light, bland foods (like bananas, rice, applesauce, and toast) can help ease
                                        symptoms and prevent irritation of the gut.
                                        <br />  <strong>Medication:</strong>  In severe cases, especially when the infection spreads beyond the intestines or in
                                        vulnerable groups (infants, elderly, or immunocompromised), antibiotics may be prescribed.
                                        However, antibiotics are typically avoided in mild cases, as they can prolong the time
                                        Salmonella bacteria stay in the body. </p>

                                    <p>
                                        If symptoms persist for more than a week, are severe, or if there are signs of dehydration (such
                                        as dry mouth, reduced urination, or dizziness), seeking medical attention is advised.
                                    </p>



                                    <p>Our treatment and advice suggestions have been devised by Nutritional Therapists and
                                        Functional Medicine Practitioners. Any treatment protocol should only be undertaken under the
                                        supervision of a Healthcare Practitioner.<br />
                                        For persistent and/or serious symptoms, it is recommended to speak to your Doctor.
                                    </p>


                                </div>
                                <div style={{ display: 'flex', justifyContent: 'center' }}>
                                    <img style={{ marginTop: '5mm' }} src='/imgggg.pngg' alt="" />
                                </div>

                            </div>




                            <div className="secenddivend" style={{ overflow: "hidden" }}>

                                {/* <img src="/lower.png" alt="" /> */}
                                {/* {reportStyle.logo === YourGutMap.logo ? <img src="/lower.png" alt="" /> : null} */}
                                {styleName === 'YourGutMap' ? <img src={reportStyle.footer || '/blank.png'} alt="" style={{ width: "800px", height: "200px" }} /> : null}
                            </div>

                        </div>
                    </>}





                    {/* Yersinia enterocolitica* */}
                    {kit.result.find(item => item['Yersinia enterocolitica'])?.["Yersinia enterocolitica"] === "detected" && <>
                        <div className="lastdiv">
                            <div className="firstdivhead" style={{ overflow: "hidden", marginTop: "0px" }}>
                                {/* {reportStyle.logo === YourGutMap.logo ? <img src="/logo2.png" alt="" style={{ marginTop: '10px' }} /> : null} */}
                                {/* <img src="/uper.png" alt="" /> */}
                                {/* {reportStyle.logo === YourGutMap.logo ? <img src="/uper.png" alt="" /> : null} */}
                                {styleName === 'YourGutMap' ? <img src={reportStyle.header || '/blank.png'} alt="" style={{ width: "800px", height: "160px" }} /> : null}



                            </div>
                            <div className="lastdivcenter">
                                <h1 style={{ color: "red" }}>Detected</h1>
                                <div className="texthead" style={{ background: `linear-gradient(90deg, ${reportStyle.primaryColor}, #dfe3fc, ${reportStyle.primaryColor})`, borderRadius: '50px' }}>

                                    <h2>Yersinia Enterocolitica</h2>


                                </div>

                                <div className="lastdivtext">

                                    <p> <strong>About <br /></strong>
                                        Yersinia enterocolitica is a gram-negative bacteria that causes yersiniosis usually caused by
                                        drinking contaminated milk or water or eating raw or undercooked meat, usually pork (chitlins).
                                        Human-to-human infection is possible or from a blood transfusion.Yersinia enterocolitica is
                                        primarily known to cause acute inflammation in the gut. This bacteria infects the intestines
                                        causing diarrhoea (usually watery or bloody), vomiting, abdominal pain, and fever which lasts
                                        about 4-7 days but can last up to three weeks. Many infected individuals will suspect having
                                        food poisoning and usually symptoms disappear within a few days and if not, medical attention
                                        may be required. </p>

                                    <p><strong>Advice<br /></strong>
                                        <strong>Hydration:</strong> The primary treatment is rehydration. Since  The microbiome rebalancing foods will help to rebalance the microbiome, making it more
                                        resilient against pathogenic parasites. If symptoms last longer than 1 week then an antimicrobial
                                        such as berberine or herbs high in chlorogenic acid (Green tea, elderflower,
                                        rosemary).<a href='https://www.ncbi.nlm.nih.gov/pmc/articles/PMC9117966/'>https://www.ncbi.nlm.nih.gov/pmc/articles/PMC9117966/</a>
                                        If symptoms are severe and persist after 8 weeks, then referral to a Doctor may be necessary. </p>

                                    <p>
                                        If symptoms persist for more than a week, are severe, or if there are signs of dehydration (such
                                        as dry mouth, reduced urination, or dizziness), seeking medical attention is advised.
                                    </p>



                                    <p>Our treatment and advice suggestions have been devised by Nutritional Therapists and
                                        Functional Medicine Practitioners. Any treatment protocol should only be undertaken under the
                                        supervision of a Healthcare Practitioner.<br />
                                        For persistent and/or serious symptoms, it is recommended to speak to your Doctor.
                                    </p>


                                </div>
                                <div style={{ display: 'flex', justifyContent: 'center' }}>
                                    <img style={{ marginTop: '5mm' }} src='/imgggg.pngg' alt="" />
                                </div>

                            </div>




                            <div className="secenddivend" style={{ overflow: "hidden" }}>

                                {/* <img src="/lower.png" alt="" /> */}
                                {/* {reportStyle.logo === YourGutMap.logo ? <img src="/lower.png" alt="" /> : null} */}
                                {styleName === 'YourGutMap' ? <img src={reportStyle.footer || '/blank.png'} alt="" style={{ width: "800px", height: "200px" }} /> : null}
                            </div>

                        </div>
                    </>}





                    {/* Campylobacter jejuni/coli* */}
                    {kit.result.find(item => item['Campylobacter jejuni/coli'])?.["Campylobacter jejuni/coli"] === "detected" && <>
                        <div className="lastdiv" style={{ marginTop: "150px", overflow: "hidden" }}>
                            <div className="firstdivhead" style={{ overflow: "hidden", marginTop: "10px" }}>
                                {styleName === 'YourGutMap' ? <img src={reportStyle.header || '/blank.png'} alt="" style={{ width: "800px", height: "160px" }} /> : null}
                            </div>
                            <div className="lastdivcenter">
                                <h1 style={{ color: "red" }}>Detected</h1>
                                <div className="texthead" style={{ background: `linear-gradient(90deg, ${reportStyle.primaryColor}, #dfe3fc, ${reportStyle.primaryColor})`, borderRadius: '50px' }}>

                                    <h2>Campylobacter jejuni/coli</h2>


                                </div>

                                <div className="lastdivtext">

                                    <p> <strong>About <br /></strong>
                                        <strong> Campylobacter jejuni</strong> and <strong>Campylobacter coli</strong> are bacterial species that are among the most
                                        common causes of foodborne illnesses in humans worldwide. Both belong to the genus
                                        <strong> Campylobacter,</strong> which includes several species known to cause <strong>gastroenteritis</strong>, or
                                        inflammation of the stomach and intestines, leading to symptoms like diarrhoea, abdominal
                                        pain, and fever. </p>

                                    <p><strong>Advice<br /></strong>
                                        <strong>  Consume Anti-inflammatory Foods</strong>
                                        <ul style={{ margin: "0" }}>
                                            <li> <strong> Ginger:</strong>  Known for its anti-inflammatory and antimicrobial properties, ginger tea can help
                                                soothe an irritated gut and alleviate nausea.</li>
                                            <li>  <strong> Turmeric:</strong>  This spice has anti-inflammatory and antioxidant properties. Adding a small
                                                amount to food or taking it as a supplement may help reduce inflammation.</li>
                                            <li>  <strong> Garlic:</strong>  With natural antibacterial properties, garlic can support the immune system;
                                                however, it should be eaten in small amounts as it can be irritating to some people’s
                                                stomachs.</li>

                                        </ul>




                                        <strong>   Eat Easily Digestible Foods</strong>
                                        <ul style={{ margin: "0" }}>
                                            <li> Stick to a<strong>  BRAT diet</strong>   (bananas, rice, applesauce, and toast) to avoid irritating the
                                                digestive tract.</li>
                                            <li>  Include  <strong>  plain boiled potatoes, bone broth, and oatmeal, </strong>  which are gentle on the
                                                stomach and provide essential nutrients.</li>


                                        </ul>

                                        <strong>    Rest</strong>
                                        <ul style={{ margin: "0" }}>
                                            <li>  Rest is crucial because the body needs energy to fight the infection. Avoid strenuous
                                                activities, and prioritise sleep.</li>


                                        </ul>


                                    </p>

                                    <p>
                                        Most Campylobacter infections resolve within a week without antibiotics, but in severe cases,
                                        medical treatment may be necessary. If symptoms are severe (high fever, blood in stool, or
                                        prolonged dehydration), it’s best to consult a Doctor.
                                    </p>



                                    <p>Our treatment and advice suggestions have been devised by Nutritional Therapists and
                                        Functional Medicine Practitioners. Any treatment protocol should only be undertaken under the
                                        supervision of a Healthcare Practitioner.<br />
                                        For persistent and/or serious symptoms, it is recommended to speak to your Doctor.
                                    </p>


                                </div>
                                <div style={{ display: 'flex', justifyContent: 'center' }}>
                                    <img style={{ marginTop: '5mm' }} src='/imgggg.pngg' alt="" />
                                </div>

                            </div>




                            <div className="secenddivend" style={{ overflow: "hidden" }}>

                                {/* <img src="/lower.png" alt="" /> */}
                                {styleName === 'YourGutMap' ? <img src={reportStyle.footer || '/blank.png'} alt="" style={{ width: "800px", height: "200px" }} /> : null}
                                {/* {reportStyle.logo === YourGutMap.logo ? <img src="/lower.png" alt="" /> : null} */}
                            </div>

                        </div>
                    </>}




                    {/* Vibrio cholerae* */}
                    {kit.result.find(item => item['Vibrio cholerae'])?.["Vibrio cholerae"] === "detected" && <>
                        <div className="lastdiv">
                            <div className="firstdivhead" style={{ overflow: "hidden", marginTop: "10px" }}>
                                {/* {reportStyle.logo === YourGutMap.logo ? <img src="/logo2.png" alt="" style={{ marginTop: '10px' }} /> : null} */}
                                {/* <img src="/uper.png" alt="" /> */}
                                {styleName === 'YourGutMap' ? <img src={reportStyle.header || '/blank.png'} alt="" style={{ width: "800px", height: "160px" }} /> : null}



                            </div>
                            <div className="lastdivcenter">
                                <h1 style={{ color: "red" }}>Detected</h1>
                                <div className="texthead" style={{ background: `linear-gradient(90deg, ${reportStyle.primaryColor}, #dfe3fc, ${reportStyle.primaryColor})`, borderRadius: '50px' }}>

                                    <h2>Vibrio cholerae</h2>


                                </div>

                                <div className="lastdivtext">

                                    <p> <strong>About <br /></strong>
                                        Vibrio cholerae is a gram-negative bacterium that causes cholera, an acute gastrointestinal
                                        infection characterised by severe diarrhoea and dehydration. It is primarily transmitted through
                                        contaminated water or food, particularly in areas with inadequate sanitation and hygiene
                                        practices. Symptoms of cholera can develop suddenly and may include profuse watery
                                        diarrhoea (often described as "rice-water" stools), vomiting, abdominal cramps, and leg cramps.
                                        If left untreated, cholera can lead to rapid dehydration, electrolyte imbalances, and can be
                                        life-threatening. </p>

                                    <p><strong>Advice<br /></strong>
                                        <ol>
                                            <li><strong>   Seek Immediate Medical Attention:</strong> Cholera can lead to severe dehydration very quickly, so
                                                it's crucial to seek medical help right away if you suspect you have cholera. Medical
                                                professionals can provide rehydration therapy and necessary medications.</li>
                                            <li> <strong>  Stay Hydrated</strong>   If you are unable to reach medical care immediately, begin rehydrating as soon
                                                as possible. Drink oral rehydration solutions (ORS) that contain electrolytes and sugars to help
                                                replace lost fluids and salts. You can also make a homemade ORS with clean water, salt, and
                                                sugar.</li>


                                            <li> <strong>   Avoid Solid Foods Initially: </strong> When you first start to recover, focus on rehydrating before
                                                gradually reintroducing bland foods like rice, bananas, and toast. Avoid spicy, fatty, or high-fiber
                                                foods until you are feeling better.</li>




                                            <li> <strong>    Good Hygiene:  </strong>  To prevent the spread of cholera, wash your hands thoroughly with soap and
                                                water after using the bathroom and before preparing or eating food. Ensure that food is cooked
                                                properly and water is treated (boiled or purified) if its source is questionable.
                                            </li>

                                            <li> <strong>   Follow Up with Healthcare Providers:</strong>   After initial treatment, follow up with your healthcare
                                                provider to ensure recovery and to address any lingering symptoms or concerns. Antibiotics
                                                may be prescribed in some cases to reduce the duration of the illness.</li>
                                        </ol>

                                    </p>

                                    <p>
                                        Taking these precautions and acting quickly is crucial for managing cholera and preventing
                                        serious complications.
                                    </p>



                                    <p>Our treatment and advice suggestions have been devised by Nutritional Therapists and
                                        Functional Medicine Practitioners. Any treatment protocol should only be undertaken under the
                                        supervision of a Healthcare Practitioner.<br />
                                        For persistent and/or serious symptoms, it is recommended to speak to your Doctor.
                                    </p>


                                </div>
                                <div style={{ display: 'flex', justifyContent: 'center' }}>
                                    <img style={{ marginTop: '5mm' }} src='/imgggg.pngg' alt="" />
                                </div>

                            </div>




                            <div className="secenddivend" style={{ overflow: "hidden" }}>

                                {/* <img src="/lower.png" alt="" /> */}
                                {styleName === 'YourGutMap' ? <img src={reportStyle.footer || '/blank.png'} alt="" style={{ width: "800px", height: "200px" }} /> : null}
                                {/* {reportStyle.logo === YourGutMap.logo ? <img src="/lower.png" alt="" /> : null} */}
                            </div>

                        </div>
                    </>}




                    {/* E. coli O157* */}
                    {kit.result.find(item => item['E. coli O157'])?.["E. coli O157"] === "detected" && <>
                        <div className="lastdiv">
                            <div className="firstdivhead" style={{ overflow: "hidden", marginTop: "10px" }}>
                                {/* {reportStyle.logo === YourGutMap.logo ? <img src="/logo2.png" alt="" style={{ marginTop: '10px' }} /> : null} */}
                                {/* <img src="/uper.png" alt="" /> */}
                                {/* {reportStyle.logo === YourGutMap.logo ? <img src="/uper.png" alt="" /> : null} */}
                                {styleName === 'YourGutMap' ? <img src={reportStyle.header || '/blank.png'} alt="" style={{ width: "800px", height: "160px" }} /> : null}



                            </div>
                            <div className="lastdivcenter">
                                <h1 style={{ color: "red" }}>Detected</h1>
                                <div className="texthead" style={{ background: `linear-gradient(90deg, ${reportStyle.primaryColor}, #dfe3fc, ${reportStyle.primaryColor})`, borderRadius: '50px' }}>

                                    <h2>E. coli O157</h2>


                                </div>

                                <div className="lastdivtext">

                                    <p style={{ color: 'red' }}>
                                        Caution- in a small percentage of cases, E. coli O157 can cause severe symptoms and
                                        lead to serious complications. If this has been identified in your stool test you should seek the
                                        advice of your Doctor or Healthcare Practitioner.
                                    </p>
                                    <p> <strong>About <br /></strong>
                                        <strong> E. coli O157</strong> is a strain of the bacterium Escherichia coli that can cause severe gastrointestinal
                                        illness. It is classified as a shiga-toxin-producing E. coli (STEC) and is primarily transmitted
                                        through contaminated food or water, particularly undercooked ground beef, unpasteurized milk,
                                        and contaminated fruits and vegetables. Symptoms of infection typically begin 3 to 10 days after
                                        exposure and can include severe abdominal cramps, diarrhea (which may be bloody), nausea,
                                        and vomiting. In some cases, it can lead to serious complications such as hemolytic uremic
                                        syndrome (HUS), which can cause kidney failure. </p>

                                    <p><strong>Advice<br /></strong>
                                        <strong>  Stay Hydrated:</strong> It is essential to maintain hydration, especially if you are experiencing
                                        diarrhoea. Drink plenty of fluids such as water, clear broths, and oral rehydration solutions to
                                        prevent dehydration. </p>

                                    <p>
                                        <strong>  Avoid Certain Medications:  </strong>  Do not take over-the-counter anti-diarrheal medications, as they
                                        can prolong the illness and increase the risk of complications.
                                    </p>

                                    <p>
                                        <strong>   Rest:  </strong>  Ensure you get sufficient rest to allow your body to recover. Avoid strenuous activities until
                                        you feel better.
                                    </p>

                                    <p>
                                        <strong>   Seek Medical Attention:   </strong>   If you experience severe symptoms, such as bloody diarrhoea, high
                                        fever, or signs of dehydration (such as extreme thirst, dry mouth, or reduced urination), seek
                                        medical help immediately. HUS is a serious complication that requires prompt treatment.
                                    </p>

                                    <p>
                                        <strong>   Follow Up:  </strong>  After your initial recovery, follow up with your healthcare provider if you continue to
                                        have symptoms or if new symptoms develop. They may recommend further testing or
                                        monitoring.
                                    </p>

                                    <p>
                                        <strong>   Good Hygiene:  </strong> To prevent the spread of E. coli O157, wash your hands thoroughly with soap
                                        and water after using the bathroom and before preparing or eating food. Ensure that meat is
                                        cooked to a safe temperature, and wash fruits and vegetables thoroughly before consumption.
                                    </p>

                                    <p>
                                        Taking these measures can help manage symptoms and reduce the risk of complications from
                                        an E. coli O157 infection.
                                    </p>



                                    <p>Our treatment and advice suggestions have been devised by Nutritional Therapists and
                                        Functional Medicine Practitioners. Any treatment protocol should only be undertaken under the
                                        supervision of a Healthcare Practitioner.<br />
                                        For persistent and/or serious symptoms, it is recommended to speak to your Doctor.
                                    </p>


                                </div>
                                <div style={{ display: 'flex', justifyContent: 'center' }}>
                                    <img style={{ marginTop: '5mm' }} src='/imgggg.pngg' alt="" />
                                </div>

                            </div>




                            <div className="secenddivend" style={{ overflow: "hidden" }}>

                                {/* <img src="/lower.png" alt="" /> */}
                                {/* {reportStyle.logo === YourGutMap.logo ? <img src="/lower.png" alt="" /> : null} */}
                                {styleName === 'YourGutMap' ? <img src={reportStyle.footer || '/blank.png'} alt="" style={{ width: "800px", height: "200px" }} /> : null}
                            </div>

                        </div>
                    </>}




                    {/* Enteroaggregative E. coli (EAEC) */}
                    {kit.result.find(item => item['Enteroaggregative E. coli (EAEC)'])?.["Enteroaggregative E. coli (EAEC)"] === "detected" && <>
                        <div className="lastdiv">
                            <div className="firstdivhead" style={{ overflow: "hidden", marginTop: "10px" }}>
                                {/* {reportStyle.logo === YourGutMap.logo ? <img src="/logo2.png" alt="" style={{ marginTop: '10px' }} /> : null} */}
                                {/* <img src="/uper.png" alt="" /> */}
                                {/* {reportStyle.logo === YourGutMap.logo ? <img src="/uper.png" alt="" /> : null} */}
                                {styleName === 'YourGutMap' ? <img src={reportStyle.header || '/blank.png'} alt="" style={{ width: "800px", height: "160px" }} /> : null}



                            </div>
                            <div className="lastdivcenter">
                                <h1 style={{ color: "red" }}>Detected</h1>
                                <div className="texthead" style={{ background: `linear-gradient(90deg, ${reportStyle.primaryColor}, #dfe3fc, ${reportStyle.primaryColor})`, borderRadius: '50px' }}>

                                    <h2>Enteroaggregative E. coli (EAEC)</h2>


                                </div>

                                <div className="lastdivtext">


                                    <p> <strong>About <br /></strong>
                                        <strong> Enteroaggregative E. coli (EAEC) </strong>  is a pathotype of Escherichia coli known to cause
                                        gastrointestinal infections, particularly in young children and individuals in developing countries.
                                        It is characterised by its ability to adhere to the intestinal mucosa in a stacked-brick
                                        arrangement, which disrupts normal intestinal function. EAEC is often transmitted through
                                        contaminated food and water. Symptoms of EAEC infection can include persistent watery
                                        diarrhea, abdominal cramps, nausea, vomiting, and sometimes low-grade fever. The diarrhea
                                        can last for several days to weeks, leading to dehydration and malnutrition, particularly in
                                        vulnerable populations. </p>

                                    <p><strong>Advice<br /></strong>
                                        <strong>  Stay Hydrated:</strong>: Hydration is crucial when dealing with diarrhea. Drink plenty of fluids, such as
                                        water, clear broths, and oral rehydration solutions (ORS) that contain electrolytes to prevent
                                        dehydration. </p>



                                    <p>
                                        <strong>   Rest:  </strong>   Ensure you get adequate rest to help your body recover. Avoid strenuous activities and
                                        give your body time to heal.
                                    </p>

                                    <p>
                                        <strong>   Follow a Bland Diet:   </strong>    When you feel ready to eat, start with bland, easily digestible foods like
                                        bananas, rice, applesauce, and toast (the BRAT diet). Avoid fatty, spicy, or high-fiber foods, as
                                        these can irritate the digestive system.
                                    </p>

                                    <p>
                                        <strong>    Seek Medical Attention:   </strong>   If symptoms persist for more than a few days, worsen, or if you
                                        experience severe symptoms such as prolonged diarrhea or signs of dehydration (like extreme
                                        thirst, dry mouth, dizziness, or significantly reduced urination), consult a healthcare provider.
                                        Diagnosis may require stool tests, and in some cases, antibiotics may be necessary.
                                    </p>

                                    <p>
                                        <strong>   Good Hygiene:  </strong> To prevent spreading the infection, wash your hands thoroughly with soap and
                                        water after using the bathroom and before preparing or eating food. Ensure that food is cooked
                                        properly and avoid drinking untreated water.
                                    </p>

                                    <p>
                                        By taking these precautions and seeking appropriate care, you can help manage symptoms and
                                        prevent complications associated with an EAEC infection.

                                    </p>



                                    <p>Our treatment and advice suggestions have been devised by Nutritional Therapists and
                                        Functional Medicine Practitioners. Any treatment protocol should only be undertaken under the
                                        supervision of a Healthcare Practitioner.<br />
                                        For persistent and/or serious symptoms, it is recommended to speak to your Doctor.
                                    </p>


                                </div>
                                <div style={{ display: 'flex', justifyContent: 'center' }}>
                                    <img style={{ marginTop: '5mm' }} src='/imgggg.pngg' alt="" />
                                </div>

                            </div>




                            <div className="secenddivend" style={{ overflow: "hidden" }}>

                                {/* <img src="/lower.png" alt="" /> */}
                                {/* {reportStyle.logo === YourGutMap.logo ? <img src="/lower.png" alt="" /> : null} */}
                                {styleName === 'YourGutMap' ? <img src={reportStyle.footer || '/blank.png'} alt="" style={{ width: "800px", height: "200px" }} /> : null}
                            </div>

                        </div>
                    </>}




                    {/* Enteropathogenic E. coli (EPEC)* */}
                    {kit.result.find(item => item['Enteropathogenic E. coli (EPEC)'])?.["Enteropathogenic E. coli (EPEC)"] === "detected" && <>
                        <div className="lastdiv">
                            <div className="firstdivhead" style={{ overflow: "hidden", marginTop: "10px" }}>
                                {/* {reportStyle.logo === YourGutMap.logo ? <img src="/logo2.png" alt="" style={{ marginTop: '10px' }} /> : null} */}
                                {/* <img src="/uper.png" alt="" /> */}
                                {/* {reportStyle.logo === YourGutMap.logo ? <img src="/uper.png" alt="" /> : null} */}
                                {styleName === 'YourGutMap' ? <img src={reportStyle.header || '/blank.png'} alt="" style={{ width: "800px", height: "200px" }} /> : null}



                            </div>
                            <div className="lastdivcenter">
                                <h1 style={{ color: "red" }}>Detected</h1>
                                <div className="texthead" style={{ background: `linear-gradient(90deg, ${reportStyle.primaryColor}, #dfe3fc, ${reportStyle.primaryColor})`, borderRadius: '50px' }}>

                                    <h2>Enteropathogenic E. coli (EPEC)</h2>


                                </div>

                                <div className="lastdivtext">


                                    <p> <strong>About <br /></strong>
                                        Enteropathogenic Escherichia coli (EPEC) is a leading cause of infantile diarrhoea in developing
                                        countries. In industrialised countries, the frequency of these organisms has decreased, but they
                                        continue to be an important cause of diarrhoea. The presence of beneficial E. coli strains helps
                                        to prevent intestinal infections by competitively excluding pathogenic agents from binding to
                                        epithelial binding sites. </p>

                                    <p><strong>Advice<br /></strong>
                                        The intake of prebiotics (FOS, GOS, inulin, and lactulose) and probiotics (fermented foods and
                                        dietary supplements) has been shown to beneficially modulate the gut microbiome composition
                                        so that it favours beneficial Lactobacillus and Bifidobacteria and reduces E. coli. We recommend
                                        following the microbiome rebalancing foods to help rebalance the microbiome which will make
                                        the gut environment unfavourable to this parasite. Antimicrobials may be something to consider
                                        later down the line as it could also disrupt beneficial bacteria. Berberine 400mg seems to be a
                                        promising antimicrobial for this particular parasite<a href='https://pubmed.ncbi.nlm.nih.gov/3549923/'>(https://pubmed.ncbi.nlm.nih.gov/3549923/).</a>
                                        In the meantime, you could suggest activated charcoal to minimise any toxins produced from
                                        the parasite <a href='(https://pubmed.ncbi.nlm.nih.gov/11307928/)'>(https://pubmed.ncbi.nlm.nih.gov/11307928/). </a></p>






                                    <p>Our treatment and advice suggestions have been devised by Nutritional Therapists and
                                        Functional Medicine Practitioners. Any treatment protocol should only be undertaken under the
                                        supervision of a Healthcare Practitioner.<br />
                                        For persistent and/or serious symptoms, it is recommended to speak to your Doctor.
                                    </p>


                                </div>
                                <div style={{ display: 'flex', justifyContent: 'center' }}>
                                    <img style={{ marginTop: '5mm' }} src='/imgggg.pngg' alt="" />
                                </div>

                            </div>




                            <div className="secenddivend" style={{ overflow: "hidden", display: "flex", alignItems: "end" }}>

                                {/* <img src="/lower.png" alt="" /> */}
                                {/* {reportStyle.logo === YourGutMap.logo ? <img src="/lower.png" alt="" /> : null} */}
                                {styleName === 'YourGutMap' ? <img src={reportStyle.footer || '/blank.png'} alt="" style={{ width: "800px", height: "200px" }} /> : null}
                            </div>

                        </div>
                    </>}




                    {/* Enterotoxigenic E. coli (ETEC) LT* */}
                    {kit.result.find(item => item['Enterotoxigenic E. coli (ETEC)'])?.["Enterotoxigenic E. coli (ETEC)"] === "detected" && <>
                        <div className="lastdiv">
                            <div className="firstdivhead" style={{ overflow: "hidden", marginTop: "10px" }}>
                                {/* {reportStyle.logo === YourGutMap.logo ? <img src="/logo2.png" alt="" style={{ marginTop: '10px' }} /> : null} */}
                                {/* <img src="/uper.png" alt="" /> */}
                                {/* {reportStyle.logo === YourGutMap.logo ? <img src="/uper.png" alt="" /> : null} */}
                                {styleName === 'YourGutMap' ? <img src={reportStyle.header || '/blank.png'} alt="" style={{ width: "800px", height: "160px" }} /> : null}




                            </div>
                            <div className="lastdivcenter">
                                <h1 style={{ color: "red" }}>Detected</h1>
                                <div className="texthead" style={{ background: `linear-gradient(90deg, ${reportStyle.primaryColor}, #dfe3fc, ${reportStyle.primaryColor})`, borderRadius: '50px' }}>

                                    <h2>Enterotoxigenic E. coli (ETEC) LT</h2>


                                </div>

                                <div className="lastdivtext">


                                    <p> <strong>About <br /></strong>
                                        Enterotoxigenic Escherichia coli (ETEC) is a type of E. coli bacteria known to cause traveler's
                                        diarrhoea, especially in areas with limited access to clean water and sanitation. ETEC produces
                                        two types of toxins: heat-labile toxin (LT) and heat-stable toxin (ST), both of which lead to
                                        excessive water and electrolyte loss in the intestines. The LT toxin works similarly to cholera
                                        toxin, disrupting the gut lining and leading to symptoms such as watery diarrhea, stomach
                                        cramps, nausea, and sometimes low-grade fever. ETEC infections are generally self-limiting but
                                        can cause severe dehydration, particularly in young children and travelers. </p>

                                    <p><strong>Advice<br /></strong>
                                        <strong> Hydration</strong>  Staying hydrated is essential since ETEC causes watery diarrhea, which can lead to
                                        dehydration. Drink plenty of fluids, and consider oral rehydration solutions to replace lost
                                        electrolytes. These can be found in pharmacies or made at home by mixing clean water, salt,
                                        and sugar.</p>

                                    <p>
                                        <strong>  Rest:</strong> Give your body time to fight the infection by resting as much as possible, as activity can
                                        worsen dehydration and fatigue.
                                    </p>

                                    <p>
                                        <strong>   Eat a Bland Diet:</strong> Stick to easily digestible foods like bananas, rice, applesauce, and toast
                                        (BRAT diet), which can help ease digestive symptoms. Avoid fatty, spicy, and high-fibre foods
                                        that can irritate the gut.
                                    </p>

                                    <p>
                                        If symptoms persist beyond a few days, become severe, or include high fever or blood in stools,
                                        seek medical attention. In some cases, antibiotics may be prescribed to help shorten the illness,
                                        particularly for vulnerable groups like young children, the elderly, or immunocompromised
                                        individuals.

                                    </p>






                                    <p>Our treatment and advice suggestions have been devised by Nutritional Therapists and
                                        Functional Medicine Practitioners. Any treatment protocol should only be undertaken under the
                                        supervision of a Healthcare Practitioner.<br />
                                        For persistent and/or serious symptoms, it is recommended to speak to your Doctor.
                                    </p>


                                </div>
                                <div style={{ display: 'flex', justifyContent: 'center' }}>
                                    <img style={{ marginTop: '5mm' }} src='/imgggg.pngg' alt="" />
                                </div>

                            </div>




                            <div className="secenddivend" style={{ overflow: "hidden" }}>

                                {/* <img src="/lower.png" alt="" /> */}
                                {/* {reportStyle.logo === YourGutMap.logo ? <img src="/lower.png" alt="" /> : null} */}
                                {styleName === 'YourGutMap' ? <img src={reportStyle.footer || '/blank.png'} alt="" style={{ width: "800px", height: "200px" }} /> : null}
                            </div>

                        </div>
                    </>}




                    {/* Shiga-Toxin-producing E. coli (STEC)* */}
                    {kit.result.find(item => item['Shigatoxin-producing E. coli (STEC)'])?.["Shigatoxin-producing E. coli (STEC)"] === "detected" && <>
                        <div className="lastdiv">
                            <div className="firstdivhead" style={{ overflow: "hidden", marginTop: "10px" }}>
                                {/* {reportStyle.logo === YourGutMap.logo ? <img src="/logo2.png" alt="" style={{ marginTop: '10px' }} /> : null} */}
                                {/* <img src="/uper.png" alt="" /> */}
                                {/* {reportStyle.logo === YourGutMap.logo ? <img src="/uper.png" alt="" /> : null} */}
                                {styleName === 'YourGutMap' ? <img src={reportStyle.header || '/blank.png'} alt="" style={{ width: "800px", height: "160px" }} /> : null}




                            </div>
                            <div className="lastdivcenter">
                                <h1 style={{ color: "red" }}>Detected</h1>
                                <div className="texthead" style={{ background: `linear-gradient(90deg, ${reportStyle.primaryColor}, #dfe3fc, ${reportStyle.primaryColor})`, borderRadius: '50px' }}>

                                    <h2>Shiga-Toxin-producing E. coli (STEC)</h2>


                                </div>

                                <div className="lastdivtext">

                                    <p style={{ color: 'red' }}>
                                        Caution- in a small percentage of cases, Shiga-toxin-producing Escherichia coli can cause
                                        severe symptoms and lead to serious complications. If this has been identified in your stool test
                                        you should seek the advice of your Doctor or Healthcare Practitioner.
                                    </p>
                                    <p> <strong>About <br /></strong>
                                        Shiga-toxin-producing Escherichia coli (STEC) is a type of E. coli bacteria that produces Shiga
                                        toxin, a potent toxin that can damage the lining of the intestines and other organs. This strain is
                                        commonly associated with foodborne illnesses, often contracted by consuming undercooked
                                        meats, unpasteurized dairy, or contaminated produce. The symptoms of STEC infection typically
                                        include severe abdominal cramps, diarrhoea (often bloody), vomiting, and sometimes fever. In
                                        some cases, particularly in young children and the elderly, STEC can lead to a serious
                                        complication known as hemolytic uremic syndrome (HUS), which can cause kidney failure and
                                        requires immediate medical attention. </p>

                                    <p><strong>Advice<br /></strong>
                                        Consult with your Doctor or Healthcare Practitioner</p>


                                    <p>Our treatment and advice suggestions have been devised by Nutritional Therapists and
                                        Functional Medicine Practitioners. Any treatment protocol should only be undertaken under the
                                        supervision of a Healthcare Practitioner.<br />
                                        For persistent and/or serious symptoms, it is recommended to speak to your Doctor.
                                    </p>


                                </div>
                                <div style={{ display: 'flex', justifyContent: 'center' }}>
                                    <img style={{ marginTop: '5mm' }} src='/imgggg.pngg' alt="" />
                                </div>

                            </div>




                            <div className="secenddivend" style={{ overflow: "hidden" }}>

                                {/* <img src="/lower.png" alt="" /> */}
                                {/* {reportStyle.logo === YourGutMap.logo ? <img src="/lower.png" alt="" /> : null} */}
                                {styleName === 'YourGutMap' ? <img src={reportStyle.footer || '/blank.png'} alt="" style={{ width: "800px", height: "200px" }} /> : null}
                            </div>

                        </div>
                    </>}



                    {/* Enteroinvasive E. coli (EIEC)* */}
                    {kit.result.find(item => item['Enteroinvasive E. coli (EIEC)'])?.["Enteroinvasive E. coli (EIEC)"] === "detected" && <>
                        <div className="lastdiv">
                            <div className="firstdivhead" style={{ overflow: "hidden", marginTop: "10px" }}>
                                {/* {reportStyle.logo === YourGutMap.logo ? <img src="/logo2.png" alt="" style={{ marginTop: '10px' }} /> : null} */}
                                {/* <img src="/uper.png" alt="" /> */}
                                {/* {reportStyle.logo === YourGutMap.logo ? <img src="/uper.png" alt="" /> : null} */}
                                {styleName === 'YourGutMap' ? <img src={reportStyle.header || '/blank.png'} alt="" style={{ width: "800px", height: "160px" }} /> : null}


                            </div>
                            <div className="lastdivcenter">
                                <h1 style={{ color: "red" }}>Detected</h1>
                                <div className="texthead" style={{ background: `linear-gradient(90deg, ${reportStyle.primaryColor}, #dfe3fc, ${reportStyle.primaryColor})`, borderRadius: '50px' }}>

                                    <h2>Enteroinvasive E. coli (EIEC)</h2>


                                </div>

                                <div className="lastdivtext">


                                    <p> <strong>About <br /></strong>
                                        Enteroinvasive Escherichia coli (EIEC) is a type of E. coli bacteria that invades and multiplies
                                        within the cells lining the intestines, causing an illness similar to dysentery. EIEC infections are
                                        typically acquired through contaminated food or water, and they closely mimic the symptoms
                                        caused by Shigella bacteria. Symptoms often include watery diarrhoea that can become bloody
                                        or mucus-filled, abdominal pain, fever, and cramping. The infection disrupts the intestinal wall,
                                        leading to inflammation and discomfort. While most cases resolve on their own, severe
                                        symptoms may require medical attention to prevent dehydration and manage discomfort.</p>

                                    <p><strong>Advice<br /></strong>
                                        Due to disruption in the intestinal wall, it is recommended to speak with your Health Practitioner
                                        about rebalancing the gut microbiome after a EIEC infection. Taking a gut microbiome test and
                                        following the food scores will help this process

                                        <ol>
                                            <li><strong>   Hydrate Well:</strong>   Since diarrhea is a common symptom of EIEC, staying hydrated is crucial. Drink
                                                plenty of water and consider oral rehydration solutions (available at pharmacies or homemade
                                                with water, salt, and sugar) to restore lost fluids and electrolytes.</li>
                                            <li> <strong> Rest:</strong>   Give your body time to recover by resting. Physical exertion can worsen dehydration and
                                                delay recovery.</li>


                                            <li> <strong>   Stick to a Bland Diet:  </strong> Eat simple, easily digestible foods like bananas, rice, applesauce, and
                                                toast (BRAT diet) to avoid irritating the digestive system. Avoid spicy, fatty, and high-fiber foods,
                                                as they can make symptoms worse.</li>




                                            <li> <strong>   Avoid Anti-diarrheal Medications: </strong>  Over-the-counter anti-diarrheal medications are generally
                                                not recommended for EIEC, as they can slow down the body’s ability to expel the bacteria.
                                            </li>


                                        </ol>

                                    </p>


                                    <p>Our treatment and advice suggestions have been devised by Nutritional Therapists and
                                        Functional Medicine Practitioners. Any treatment protocol should only be undertaken under the
                                        supervision of a Healthcare Practitioner.<br />
                                        For persistent and/or serious symptoms, it is recommended to speak to your Doctor.
                                    </p>


                                </div>
                                <div style={{ display: 'flex', justifyContent: 'center' }}>
                                    <img style={{ marginTop: '5mm' }} src='/imgggg.pngg' alt="" />
                                </div>

                            </div>




                            <div className="secenddivend" style={{ overflow: "hidden" }}>

                                {/* <img src="/lower.png" alt="" /> */}
                                {/* {reportStyle.logo === YourGutMap.logo ? <img src="/lower.png" alt="" /> : null} */}
                                {styleName === 'YourGutMap' ? <img src={reportStyle.footer || '/blank.png'} alt="" style={{ width: "800px", height: "200px" }} /> : null}
                            </div>

                        </div>
                    </>}




                    {/* Adenovirus* */}
                    {kit.result.find(item => item['Adenovirus'])?.["Adenovirus"] === "detected" && <>
                        <div className="lastdiv">
                            <div className="firstdivhead" style={{ overflow: "hidden", marginTop: "10px" }}>
                                {/* {reportStyle.logo === YourGutMap.logo ? <img src="/logo2.png" alt="" style={{ marginTop: '10px' }} /> : null} */}
                                {/* <img src="/uper.png" alt="" /> */}
                                {/* {reportStyle.logo === YourGutMap.logo ? <img src="/uper.png" alt="" /> : null} */}
                                {styleName === 'YourGutMap' ? <img src={reportStyle.header || '/blank.png'} alt="" style={{ width: "800px", height: "160px" }} /> : null}

                            </div>
                            <div className="lastdivcenter">
                                <h1 style={{ color: "red" }}>Detected</h1>
                                <div className="texthead" style={{ background: `linear-gradient(90deg, ${reportStyle.primaryColor}, #dfe3fc, ${reportStyle.primaryColor})`, borderRadius: '50px' }}>

                                    <h2>Adenovirus</h2>


                                </div>

                                <div className="lastdivtext">


                                    <p> <strong>About <br /></strong>
                                        Adenovirus is a type of virus that can cause gastrointestinal infections, particularly in children. It
                                        is easily spread through contaminated food or water, and person-to-person contact. When it
                                        affects the gastrointestinal tract, symptoms can include diarrhoea, vomiting, abdominal pain,
                                        and fever. Adenovirus gastroenteritis is usually mild and self-limiting, often resolving within a few
                                        days. However, it can lead to dehydration, especially in young children and those with
                                        weakened immune systems, necessitating prompt attention to hydration and electrolyte
                                        balance. </p>

                                    <p><strong>Advice<br /></strong>
                                        <ol>
                                            <li><strong>  Stay Hydrated:</strong> Hydration is crucial, especially if you are experiencing diarrhea and
                                                vomiting. Drink plenty of fluids, including water, clear broths, and oral rehydration
                                                solutions to replace lost electrolytes.</li>
                                            <li> <strong> Rest:</strong> Allow your body to recover by getting plenty of rest. Avoid strenuous activities that
                                                could worsen your condition.</li>
                                            <li> <strong> Eat Bland Foods: </strong>When you feel ready to eat, start with bland, easy-to-digest foods
                                                such as bananas, rice, applesauce, and toast (BRAT diet). Avoid spicy, fatty, or high-fiber
                                                foods that may irritate your digestive system.</li>
                                            <li> <strong>   Monitor Symptoms:</strong> Keep track of your symptoms. If they worsen, or if you experience
                                                severe dehydration (indicated by symptoms like extreme thirst, dry mouth, decreased
                                                urination, or dizziness), seek medical attention.</li>
                                            <li> <strong>  Avoid Anti-diarrheal Medications: </strong>Over-the-counter medications that slow down
                                                diarrhea are generally not recommended for viral infections like adenovirus, as they can
                                                prolong the illness.</li>
                                        </ol>

                                    </p>

                                    <p>
                                        If symptoms persist for more than a few days, worsen, or if you have underlying health
                                        conditions, it’s advisable to consult a healthcare provider for further evaluation and
                                        management.

                                    </p>


                                    <p>Our treatment and advice suggestions have been devised by Nutritional Therapists and
                                        Functional Medicine Practitioners. Any treatment protocol should only be undertaken under the
                                        supervision of a Healthcare Practitioner.<br />
                                        For persistent and/or serious symptoms, it is recommended to speak to your Doctor.
                                    </p>


                                </div>
                                <div style={{ display: 'flex', justifyContent: 'center' }}>
                                    <img style={{ marginTop: '5mm' }} src='/imgggg.pngg' alt="" />
                                </div>

                            </div>




                            <div className="secenddivend" style={{ overflow: "hidden" }}>

                                {/* <img src="/lower.png" alt="" /> */}
                                {/* {reportStyle.logo === YourGutMap.logo ? <img src="/lower.png" alt="" /> : null} */}
                                {styleName === 'YourGutMap' ? <img src={reportStyle.header || '/blank.png'} alt="" style={{ width: "800px", height: "160px" }} /> : null}

                            </div>

                        </div>
                    </>}




                    {/* Astrovirus* */}
                    {kit.result.find(item => item['Astrovirus'])?.["Astrovirus"] === "detected" && <>
                        <div className="lastdiv">
                            <div className="firstdivhead" style={{ overflow: "hidden", marginTop: "10px" }}>
                                {/* {reportStyle.logo === YourGutMap.logo ? <img src="/logo2.png" alt="" style={{ marginTop: '10px' }} /> : null} */}
                                {/* <img src="/uper.png" alt="" /> */}
                                {/* {reportStyle.logo === YourGutMap.logo ? <img src="/uper.png" alt="" /> : null} */}
                                {styleName === 'YourGutMap' ? <img src={reportStyle.header || '/blank.png'} alt="" style={{ width: "800px", height: "160px" }} /> : null}



                            </div>
                            <div className="lastdivcenter">
                                <h1 style={{ color: "red" }}>Detected</h1>
                                <div className="texthead" style={{ background: `linear-gradient(90deg, ${reportStyle.primaryColor}, #dfe3fc, ${reportStyle.primaryColor})`, borderRadius: '50px' }}>

                                    <h2>Astrovirus</h2>


                                </div>

                                <div className="lastdivtext">


                                    <p> <strong>About <br /></strong>
                                        Astrovirus is a viral pathogen that primarily affects the gastrointestinal tract, leading to
                                        gastroenteritis, especially in young children, the elderly, and immunocompromised individuals. It
                                        is transmitted through contaminated food or water and is highly contagious. Symptoms of an
                                        astrovirus infection typically include diarrhoea, vomiting, abdominal pain, and mild fever. While
                                        the illness is generally mild and self-limiting, it can lead to dehydration, particularly in vulnerable
                                        populations. </p>

                                    <p><strong>Advice<br /></strong>
                                        <ol>
                                            <li><strong>  Stay Hydrated:</strong>  Drink plenty of fluids, such as water, clear broths, and oral rehydration
                                                solutions to replenish lost electrolytes. This is crucial to prevent dehydration from
                                                diarrhea and vomiting.</li>
                                            <li> <strong> Rest:</strong>  Allow your body to recover by getting sufficient rest. Avoid strenuous activities to
                                                conserve energy.</li>


                                            <li> <strong>  Follow a Bland Diet: </strong>When you feel ready to eat, stick to bland foods that are easy on
                                                the stomach, such as bananas, rice, applesauce, and toast (the BRAT diet). Avoid spicy,
                                                fatty, and dairy-rich foods until you recover.</li>

                                            <li> <strong>   Monitor Symptoms:</strong> Keep an eye on your symptoms. If you experience severe
                                                dehydration (indicated by extreme thirst, dry mouth, dizziness, or significantly reduced
                                                urination), seek medical attention promptly.</li>


                                            <li> <strong>  Avoid Anti-diarrheal Medications: </strong> Over-the-counter medications that slow down
                                                diarrhea are typically not recommended for viral infections like astrovirus, as they can
                                                prolong the illness.</li>
                                        </ol>

                                    </p>

                                    <p>
                                        If symptoms persist for more than a few days or worsen, it's important to consult a healthcare
                                        provider for further evaluation and management.


                                    </p>


                                    <p>Our treatment and advice suggestions have been devised by Nutritional Therapists and
                                        Functional Medicine Practitioners. Any treatment protocol should only be undertaken under the
                                        supervision of a Healthcare Practitioner.<br />
                                        For persistent and/or serious symptoms, it is recommended to speak to your Doctor.
                                    </p>


                                </div>
                                <div style={{ display: 'flex', justifyContent: 'center' }}>
                                    <img style={{ marginTop: '5mm' }} src='/imgggg.pngg' alt="" />
                                </div>

                            </div>




                            <div className="secenddivend" style={{ overflow: "hidden" }}>

                                {/* <img src="/lower.png" alt="" /> */}
                                {/* {reportStyle.logo === YourGutMap.logo ? <img src="/lower.png" alt="" /> : null} */}
                                {styleName === 'YourGutMap' ? <img src={reportStyle.header || '/blank.png'} alt="" style={{ width: "800px", height: "160px" }} /> : null}

                            </div>

                        </div>
                    </>}




                    {/* Norovirus GI/GII* */}
                    {kit.result.find(item => item['Norovirus GI/GII'])?.["Norovirus GI/GII"] === "detected" && <>
                        <div className="lastdiv">
                            <div className="firstdivhead" style={{ overflow: "hidden", marginTop: "10px" }}>
                                {/* {reportStyle.logo === YourGutMap.logo ? <img src="/logo2.png" alt="" style={{ marginTop: '10px' }} /> : null} */}
                                {/* <img src="/uper.png" alt="" /> */}
                                {/* {reportStyle.logo === YourGutMap.logo ? <img src="/uper.png" alt="" /> : null} */}
                                {styleName === 'YourGutMap' ? <img src={reportStyle.header || '/blank.png'} alt="" style={{ width: "800px", height: "160px" }} /> : null}



                            </div>
                            <div className="lastdivcenter">
                                <h1 style={{ color: "red" }}>Detected</h1>
                                <div className="texthead" style={{ background: `linear-gradient(90deg, ${reportStyle.primaryColor}, #dfe3fc, ${reportStyle.primaryColor})`, borderRadius: '50px' }}>

                                    <h2>Norovirus GI/GII</h2>


                                </div>

                                <div className="lastdivtext">


                                    <p> <strong>About <br /></strong>
                                        Norovirus, particularly the GII strain, is a highly contagious virus that causes acute
                                        gastroenteritis, leading to inflammation of the stomach and intestines. It is commonly spread
                                        through contaminated food or water, as well as from person to person, often in crowded
                                        environments such as cruise ships, schools, and nursing homes. Symptoms of norovirus
                                        infection typically include sudden onset of diarrhea, vomiting, abdominal cramps, nausea, and
                                        sometimes low-grade fever. The illness is usually self-limiting but can lead to dehydration,
                                        especially in vulnerable populations like young children and the elderly. </p>

                                    <p><strong>Advice<br /></strong>
                                        <ol>
                                            <li><strong>  Stay Hydrated:</strong>  It’s crucial to maintain hydration since diarrhea and vomiting can lead to
                                                significant fluid loss. Drink plenty of fluids such as water, clear broth, or oral rehydration
                                                solutions to replenish lost electrolytes.</li>
                                            <li> <strong> Rest:</strong>   Resting helps your body recover from the infection. Avoid strenuous activities and give
                                                yourself time to heal.</li>


                                            <li> <strong>  Follow a Bland Diet: </strong> Once you feel able to eat, start with bland, easy-to-digest foods such as
                                                bananas, rice, applesauce, and toast (the BRAT diet). Avoid spicy, fatty, or rich foods until you
                                                recover.</li>

                                            <li> <strong>   Good Hygiene:</strong> Since norovirus is highly contagious, wash your hands thoroughly with soap
                                                and water, especially after using the bathroom and before eating or preparing food. Disinfect
                                                surfaces that may be contaminated.</li>


                                            <li> <strong>  Avoid Anti-diarrheal Medications: </strong> Over-the-counter medications that slow down diarrhea are
                                                generally not recommended for norovirus infections, as they may prolong the illness.</li>
                                        </ol>

                                    </p>

                                    <p>
                                        If symptoms persist for more than a few days, worsen, or if you experience severe dehydration
                                        (indicated by symptoms like extreme thirst, dry mouth, or decreased urination), seek medical
                                        attention promptly


                                    </p>


                                    <p>Our treatment and advice suggestions have been devised by Nutritional Therapists and
                                        Functional Medicine Practitioners. Any treatment protocol should only be undertaken under the
                                        supervision of a Healthcare Practitioner.<br />
                                        For persistent and/or serious symptoms, it is recommended to speak to your Doctor.
                                    </p>


                                </div>
                                <div style={{ display: 'flex', justifyContent: 'center' }}>
                                    <img style={{ marginTop: '5mm' }} src='/imgggg.pngg' alt="" />
                                </div>

                            </div>




                            <div className="secenddivend" style={{ overflow: "hidden" }}>

                                {/* <img src="/lower.png" alt="" /> */}
                                {/* {reportStyle.logo === YourGutMap.logo ? <img src="/lower.png" alt="" /> : null} */}
                                {styleName === 'YourGutMap' ? <img src={reportStyle.footer || '/blank.png'} alt="" style={{ width: "800px", height: "200px" }} /> : null}
                            </div>

                        </div>
                    </>}




                    {/* Rotavirus A* */}
                    {kit.result.find(item => item['Rotavirus A'])?.["Rotavirus A"] === "detected" && <>
                        <div className="lastdiv">
                            <div className="firstdivhead" style={{ overflow: "hidden", marginTop: "10px" }}>
                                {/* {reportStyle.logo === YourGutMap.logo ? <img src="/logo2.png" alt="" style={{ marginTop: '10px' }} /> : null} */}
                                {/* <img src="/uper.png" alt="" /> */}
                                {/* {reportStyle.logo === YourGutMap.logo ? <img src="/uper.png" alt="" /> : null} */}
                                {styleName === 'YourGutMap' ? <img src={reportStyle.header || '/blank.png'} alt="" style={{ width: "800px", height: "160px" }} /> : null}



                            </div>
                            <div className="lastdivcenter">
                                <h1 style={{ color: "red" }}>Detected</h1>
                                <div className="texthead" style={{ background: `linear-gradient(90deg, ${reportStyle.primaryColor}, #dfe3fc, ${reportStyle.primaryColor})`, borderRadius: '50px' }}>

                                    <h2>Norovirus GI/GII</h2>


                                </div>

                                <div className="lastdivtext">


                                    <p> <strong>About <br /></strong>
                                        Rotavirus A is a highly contagious virus that primarily affects the gastrointestinal tract, leading to
                                        acute gastroenteritis, particularly in infants and young children. It is transmitted through the
                                        fecal-oral route, often through contaminated hands, surfaces, or food and water. Symptoms of
                                        rotavirus infection typically include severe diarrhea, vomiting, abdominal cramps, fever, and
                                        dehydration. The diarrhea can be particularly profuse, leading to rapid fluid loss, which can be
                                        dangerous, especially in young children and infants. </p>

                                    <p><strong>Advice<br /></strong>
                                        <ol>
                                            <li><strong>  Stay Hydrated:</strong>  Maintaining hydration is crucial. Drink plenty of fluids such as water, clear
                                                broths, or oral rehydration solutions that contain electrolytes. This helps replenish lost fluids and
                                                prevents dehydration.</li>
                                            <li> <strong> Rest:</strong>  Ensure you get enough rest to help your body recover. Limit physical activity until you feel
                                                better.</li>


                                            <li> <strong>  Follow a Bland Diet: </strong> When you feel ready to eat, opt for bland, easily digestible foods such as
                                                bananas, rice, applesauce, and toast (the BRAT diet). Avoid dairy products, fatty foods, and
                                                sugary drinks, as they can worsen diarrhoea.</li>

                                            <li> <strong>   Good Hygiene:</strong>  To prevent spreading the virus, wash your hands thoroughly with soap and
                                                water after using the bathroom and before eating or preparing food. Disinfect surfaces that may
                                                be contaminated.</li>


                                            <li> <strong> Seek Medical Attention if Needed: </strong> If symptoms persist for more than a couple of days,
                                                worsen, or if you or your child show signs of severe dehydration (such as dry mouth, reduced
                                                urination, extreme thirst, or lethargy), seek medical help promptly.
                                            </li>
                                        </ol>

                                    </p>




                                    <p>Our treatment and advice suggestions have been devised by Nutritional Therapists and
                                        Functional Medicine Practitioners. Any treatment protocol should only be undertaken under the
                                        supervision of a Healthcare Practitioner.<br />
                                        For persistent and/or serious symptoms, it is recommended to speak to your Doctor.
                                    </p>


                                </div>
                                <div style={{ display: 'flex', justifyContent: 'center' }}>
                                    <img style={{ marginTop: '5mm' }} src='/imgggg.pngg' alt="" />
                                </div>

                            </div>




                            <div className="secenddivend" style={{ overflow: "hidden" }}>

                                {/* <img src="/lower.png" alt="" /> */}
                                {/* {reportStyle.logo === YourGutMap.logo ? <img src="/lower.png" alt="" /> : null} */}
                                {styleName === 'YourGutMap' ? <img src={reportStyle.footer || '/blank.png'} alt="" style={{ width: "800px", height: "200px" }} /> : null}
                            </div>

                        </div>
                    </>}


                    {/* Sapovirus (I, II, IV, and V)* */}
                    {kit.result.find(item => item['Sapovirus (I,II,IV and V)'])?.["Sapovirus (I,II,IV and V)"] === "detected" && <>
                        <div className="lastdiv">
                            <div className="firstdivhead" style={{ overflow: "hidden", marginTop: "10px" }}>
                                {/* {reportStyle.logo === YourGutMap.logo ? <img src="/logo2.png" alt="" style={{ marginTop: '10px' }} /> : null} */}
                                {/* <img src="/uper.png" alt="" /> */}
                                {/* {reportStyle.logo === YourGutMap.logo ? <img src="/uper.png" alt="" /> : null} */}
                                {styleName === 'YourGutMap' ? <img src={reportStyle.header || '/blank.png'} alt="" style={{ width: "800px", height: "160px" }} /> : null}



                            </div>
                            <div className="lastdivcenter">
                                <h1 style={{ color: "red" }}>Detected</h1>
                                <div className="texthead" style={{ background: `linear-gradient(90deg, ${reportStyle.primaryColor}, #dfe3fc, ${reportStyle.primaryColor})`, borderRadius: '50px' }}>

                                    <h2>Sapovirus (I,II, IV, and V)</h2>


                                </div>

                                <div className="lastdivtext">


                                    <p> <strong>About <br /></strong>
                                        Sapovirus, which includes several genotypes (I, II, IV, and V), is a type of virus that primarily
                                        causes gastroenteritis, particularly in children and occasionally in adults. It is transmitted via the
                                        fecal-oral route, often through contaminated food, water, or surfaces, and is known to cause
                                        outbreaks in settings such as schools, nursing homes, and cruise ships. Symptoms of sapovirus
                                        infection typically include diarrhea, vomiting, abdominal cramps, nausea, and low-grade fever.
                                        While the illness is usually mild and self-limiting, it can lead to dehydration, especially in young
                                        children and vulnerable populations. </p>

                                    <p><strong>Advice<br /></strong>
                                        <ol>
                                            <li><strong>  Stay Hydrated:</strong>  Hydration is crucial, especially if you are experiencing diarrhea and vomiting.
                                                Drink plenty of fluids, such as water, clear broths, and oral rehydration solutions that contain
                                                electrolytes to replenish lost fluids.</li>
                                            <li> <strong> Rest:</strong>   Ensure you get enough rest to support your body’s recovery. Avoid strenuous activities
                                                and prioritize sleep.</li>


                                            <li> <strong>  Follow a Bland Diet: </strong>  When you feel ready to eat, stick to bland foods that are easy on the
                                                stomach, such as bananas, rice, applesauce, and toast (the BRAT diet). Avoid dairy products,
                                                greasy foods, and sugary drinks, which can aggravate symptoms.</li>

                                            <li> <strong>   Good Hygiene:</strong>   Since sapovirus is highly contagious, wash your hands thoroughly with soap
                                                and water after using the bathroom and before eating or preparing food. Disinfect surfaces that
                                                may be contaminated to prevent further spread.</li>


                                            <li> <strong>  Avoid Anti-diarrheal Medications: </strong> Over-the-counter medications that slow down diarrhea are
                                                generally not recommended for viral gastroenteritis, as they can prolong the illness.
                                            </li>
                                        </ol>

                                    </p>
                                    <p>
                                        If symptoms persist for more than a few days, worsen, or if you experience signs of severe
                                        dehydration (such as extreme thirst, dry mouth, decreased urination, or dizziness), seek medical
                                        attention promptly
                                    </p>




                                    <p>Our treatment and advice suggestions have been devised by Nutritional Therapists and
                                        Functional Medicine Practitioners. Any treatment protocol should only be undertaken under the
                                        supervision of a Healthcare Practitioner.<br />
                                        For persistent and/or serious symptoms, it is recommended to speak to your Doctor.
                                    </p>


                                </div>
                                <div style={{ display: 'flex', justifyContent: 'center' }}>
                                    <img style={{ marginTop: '5mm' }} src='/imgggg.pngg' alt="" />
                                </div>

                            </div>




                            <div className="secenddivend" style={{ overflow: "hidden" }}>

                                {/* <img src="/lower.png" alt="" /> */}
                                {/* {reportStyle.logo === YourGutMap.logo ? <img src="/lower.png" alt="" /> : null} */}
                                {styleName === 'YourGutMap' ? <img src={reportStyle.footer || '/blank.png'} alt="" style={{ width: "800px", height: "200px" }} /> : null}
                            </div>

                        </div>
                    </>}


                    {/* Cryptosporidium spp.* */}
                    {kit.result.find(item => item['Cryptosporidium spp.'])?.["Cryptosporidium spp."] === "detected" && <>
                        <div className="lastdiv">
                            <div className="firstdivhead" style={{ overflow: "hidden", marginTop: "10px" }}>
                                {/* {reportStyle.logo === YourGutMap.logo ? <img src="/logo2.png" alt="" style={{ marginTop: '10px' }} /> : null} */}
                                {/* <img src="/uper.png" alt="" /> */}
                                {/* {reportStyle.logo === YourGutMap.logo ? <img src="/uper.png" alt="" /> : null} */}
                                {styleName === 'YourGutMap' ? <img src={reportStyle.header || '/blank.png'} alt="" style={{ width: "800px", height: "160px" }} /> : null}



                            </div>
                            <div className="lastdivcenter">
                                <h1 style={{ color: "red" }}>Detected</h1>
                                <div className="texthead" style={{ background: `linear-gradient(90deg, ${reportStyle.primaryColor}, #dfe3fc, ${reportStyle.primaryColor})`, borderRadius: '50px' }}>

                                    <h2>Cryptosporidium spp.</h2>


                                </div>

                                <div className="lastdivtext">


                                    <p> <strong>About <br /></strong>
                                        Cryptosporidium spp.. are microscopic parasites that cause a gastrointestinal infection known as
                                        cryptosporidiosis. These parasites are typically transmitted through contaminated water, food, or
                                        surfaces, and they can be found in both recreational and drinking water. Infection with
                                        Cryptosporidium can lead to symptoms such as watery diarrhea, abdominal cramps, nausea,
                                        vomiting, and sometimes fever. Symptoms can vary in severity and may last from a few days to
                                        several weeks, particularly in immunocompromised individuals, where the infection can be more
                                        severe and prolonged. </p>

                                    <p><strong>Advice<br /></strong>
                                        <ol>
                                            <li><strong>  Stay Hydrated:</strong>  Hydration is essential, especially since diarrhea can lead to significant fluid
                                                loss. Drink plenty of fluids such as water, clear broths, and oral rehydration solutions containing
                                                electrolytes to prevent dehydration.</li>
                                            <li> <strong> Rest:</strong>  Give your body time to recover by getting sufficient rest. Avoid strenuous activities and
                                                take care of yourself.</li>


                                            <li> <strong>  Follow a Bland Diet: </strong> : When you feel able to eat, start with bland, easily digestible foods such as
                                                bananas, rice, applesauce, and toast (the BRAT diet). Avoid dairy products, greasy or spicy
                                                foods, and high-fiber foods, as they may irritate the digestive system.</li>

                                            <li> <strong>   Good Hygiene:</strong>   To prevent spreading the infection, wash your hands thoroughly with soap and
                                                water after using the bathroom and before preparing or eating food. Ensure that any surfaces
                                                that may be contaminated are properly disinfected</li>


                                            <li> <strong>   Seek Medical Attention if Needed: </strong> If symptoms persist for more than a few days, worsen, or if
                                                you experience signs of severe dehydration (such as extreme thirst, dry mouth, or significantly
                                                reduced urination), consult a healthcare provider. In some cases, especially in
                                                immunocompromised individuals, medication may be required to manage the infection
                                                effectively.
                                            </li>
                                        </ol>

                                    </p>
                                    <p>
                                        Taking preventive measures, such as ensuring good hygiene and avoiding drinking untreated
                                        water, can help reduce the risk of contracting Cryptosporidium spp.. infections.

                                    </p>




                                    <p>Our treatment and advice suggestions have been devised by Nutritional Therapists and
                                        Functional Medicine Practitioners. Any treatment protocol should only be undertaken under the
                                        supervision of a Healthcare Practitioner.<br />
                                        For persistent and/or serious symptoms, it is recommended to speak to your Doctor.
                                    </p>


                                </div>
                                <div style={{ display: 'flex', justifyContent: 'center' }}>
                                    <img style={{ marginTop: '5mm' }} src='/imgggg.pngg' alt="" />
                                </div>

                            </div>




                            <div className="secenddivend" style={{ overflow: "hidden" }}>

                                {/* <img src="/lower.png" alt="" /> */}
                                {/* {reportStyle.logo === YourGutMap.logo ? <img src="/lower.png" alt="" /> : null} */}
                                {styleName === 'YourGutMap' ? <img src={reportStyle.footer || '/blank.png'} alt="" style={{ width: "800px", height: "200px" }} /> : null}
                            </div>

                        </div>
                    </>}




                    {/* Cyclospora cayetanensis* */}
                    {kit.result.find(item => item['Cyclospora cayetanensis'])?.["Cyclospora cayetanensis"] === "detected" && <>
                        <div className="lastdiv">
                            <div className="firstdivhead" style={{ overflow: "hidden", marginTop: "10px" }}>
                                {/* {reportStyle.logo === YourGutMap.logo ? <img src="/logo2.png" alt="" style={{ marginTop: '10px' }} /> : null} */}
                                {/* <img src="/uper.png" alt="" /> */}
                                {styleName === 'YourGutMap' ? <img src={reportStyle.header || '/blank.png'} alt="" style={{ width: "800px", height: "160px" }} /> : null}



                            </div>
                            <div className="lastdivcenter">
                                <h1 style={{ color: "red" }}>Detected</h1>
                                <div className="texthead" style={{ background: `linear-gradient(90deg, ${reportStyle.primaryColor}, #dfe3fc, ${reportStyle.primaryColor})`, borderRadius: '50px' }}>

                                    <h2>Cryptosporidium spp.</h2>


                                </div>

                                <div className="lastdivtext">


                                    <p> <strong>About <br /></strong>
                                        Cryptosporidium spp.. are microscopic parasites that cause a gastrointestinal infection known as
                                        cryptosporidiosis. These parasites are typically transmitted through contaminated water, food, or
                                        surfaces, and they can be found in both recreational and drinking water. Infection with
                                        Cryptosporidium can lead to symptoms such as watery diarrhea, abdominal cramps, nausea,
                                        vomiting, and sometimes fever. Symptoms can vary in severity and may last from a few days to
                                        several weeks, particularly in immunocompromised individuals, where the infection can be more
                                        severe and prolonged. </p>

                                    <p><strong>Advice<br /></strong>
                                        <ol>
                                            <li><strong>  Stay Hydrated:</strong>  Hydration is essential, especially since diarrhea can lead to significant fluid
                                                loss. Drink plenty of fluids such as water, clear broths, and oral rehydration solutions containing
                                                electrolytes to prevent dehydration.</li>
                                            <li> <strong> Rest:</strong>  Give your body time to recover by getting sufficient rest. Avoid strenuous activities and
                                                take care of yourself.</li>


                                            <li> <strong>  Follow a Bland Diet: </strong> : When you feel able to eat, start with bland, easily digestible foods such as
                                                bananas, rice, applesauce, and toast (the BRAT diet). Avoid dairy products, greasy or spicy
                                                foods, and high-fiber foods, as they may irritate the digestive system.</li>

                                            <li> <strong>   Good Hygiene:</strong>   To prevent spreading the infection, wash your hands thoroughly with soap and
                                                water after using the bathroom and before preparing or eating food. Ensure that any surfaces
                                                that may be contaminated are properly disinfected</li>


                                            <li> <strong>   Seek Medical Attention if Needed: </strong> If symptoms persist for more than a few days, worsen, or if
                                                you experience signs of severe dehydration (such as extreme thirst, dry mouth, or significantly
                                                reduced urination), consult a healthcare provider. In some cases, especially in
                                                immunocompromised individuals, medication may be required to manage the infection
                                                effectively.
                                            </li>
                                        </ol>

                                    </p>
                                    <p>
                                        Taking preventive measures, such as ensuring good hygiene and avoiding drinking untreated
                                        water, can help reduce the risk of contracting Cryptosporidium spp.. infections.

                                    </p>




                                    <p>Our treatment and advice suggestions have been devised by Nutritional Therapists and
                                        Functional Medicine Practitioners. Any treatment protocol should only be undertaken under the
                                        supervision of a Healthcare Practitioner.<br />
                                        For persistent and/or serious symptoms, it is recommended to speak to your Doctor.
                                    </p>


                                </div>
                                <div style={{ display: 'flex', justifyContent: 'center' }}>
                                    <img style={{ marginTop: '5mm' }} src='/imgggg.pngg' alt="" />
                                </div>

                            </div>




                            <div className="secenddivend" style={{ overflow: "hidden" }}>

                                {/* <img src="/lower.png" alt="" /> */}
                                {styleName === 'YourGutMap' ? <img src={reportStyle.header || '/blank.png'} alt="" style={{ width: "800px", height: "160px" }} /> : null}

                                {/* {reportStyle.logo === YourGutMap.logo ? <img src="/lower.png" alt="" /> : null} */}
                            </div>

                        </div>
                    </>}




                    {/* Entamoeba histolytica* */}
                    {kit.result.find(item => item['Entamoeba histolytica'])?.["Entamoeba histolytica"] === "detected" && <>
                        <div className="lastdiv">
                            <div className="firstdivhead" style={{ overflow: "hidden", marginTop: "10px" }}>
                                {/* {reportStyle.logo === YourGutMap.logo ? <img src="/logo2.png" alt="" style={{ marginTop: '10px' }} /> : null} */}
                                {/* <img src="/uper.png" alt="" /> */}
                                {/* {reportStyle.logo === YourGutMap.logo ? <img src="/uper.png" alt="" /> : null} */}
                                {styleName === 'YourGutMap' ? <img src={reportStyle.header || '/blank.png'} alt="" style={{ width: "800px", height: "160px" }} /> : null}

                            </div>
                            <div className="lastdivcenter">
                                <h1 style={{ color: "red" }}>Detected</h1>
                                <div className="texthead" style={{ background: `linear-gradient(90deg, ${reportStyle.primaryColor}, #dfe3fc, ${reportStyle.primaryColor})`, borderRadius: '50px' }}>

                                    <h2>Cryptosporidium spp.</h2>


                                </div>

                                <div className="lastdivtext">

                                    <p style={{ color: 'red' }}>
                                        Caution- in a small percentage of cases, Entamoeba histolytica can cause severe symptoms
                                        and lead to serious complications. If this has been identified in your stool test you should seek
                                        the advice of your Doctor or Healthcare Practitioner.
                                    </p>
                                    <p> <strong>About <br /></strong>
                                        Entamoeba histolytica is a parasitic amoeba that causes an intestinal infection known as
                                        amoebiasis. It is primarily transmitted through the fecal-oral route, often via contaminated food
                                        or water, and is more prevalent in areas with poor sanitation. Symptoms of amoebiasis can
                                        range from mild to severe and may include watery diarrhea, abdominal pain, cramping, and, in
                                        some cases, dysentery, which is characterized by bloody diarrhea and mucus in the stool. In
                                        severe cases, the infection can lead to complications such as abscesses in the liver. </p>

                                    <p><strong>Advice<br /></strong>
                                        <ol>
                                            <li><strong>  Stay Hydrated:</strong>   Hydration is critical, especially if you are experiencing diarrhea. Drink plenty of
                                                fluids, such as water, clear broths, and oral rehydration solutions that contain electrolytes to
                                                prevent dehydration.</li>
                                            <li> <strong> Rest:</strong>   Make sure to get sufficient rest to allow your body to recover. Avoid strenuous activities
                                                until you feel better.</li>


                                            <li> <strong>  Follow a Bland Diet: </strong> : When you feel ready to eat, start with bland, easily digestible foods like
                                                bananas, rice, applesauce, and toast (the BRAT diet). Avoid fatty, spicy, and high-fiber foods
                                                that can irritate your digestive system.</li>



                                            <li> <strong>   Seek Medical Attention: </strong>  If symptoms persist for more than a couple of days, worsen, or if you
                                                experience severe symptoms such as bloody diarrhea or signs of dehydration (such as extreme
                                                thirst, dry mouth, or decreased urination), consult a healthcare provider. Diagnosis may require
                                                stool tests, and treatment typically involves specific antibiotics or antiparasitic medications.
                                            </li>


                                            <li> <strong>   Good Hygiene:</strong>  To prevent the spread of Entamoeba histolytica, wash your hands thoroughly
                                                with soap and water after using the bathroom and before preparing or consuming food. Ensure
                                                that food is cooked properly and water is treated or boiled if the source is uncertain.</li>
                                        </ol>

                                    </p>
                                    <p>
                                        Taking these precautions can help manage symptoms and prevent the spread of the infection

                                    </p>




                                    <p>Our treatment and advice suggestions have been devised by Nutritional Therapists and
                                        Functional Medicine Practitioners. Any treatment protocol should only be undertaken under the
                                        supervision of a Healthcare Practitioner.<br />
                                        For persistent and/or serious symptoms, it is recommended to speak to your Doctor.
                                    </p>


                                </div>
                                <div style={{ display: 'flex', justifyContent: 'center' }}>
                                    <img style={{ marginTop: '5mm' }} src='/imgggg.pngg' alt="" />
                                </div>

                            </div>




                            <div className="secenddivend" style={{ overflow: "hidden" }}>

                                {/* <img src="/lower.png" alt="" /> */}
                                {/* {reportStyle.logo === YourGutMap.logo ? <img src="/lower.png" alt="" /> : null} */}
                                {styleName === 'YourGutMap' ? <img src={reportStyle.footer || '/blank.png'} alt="" style={{ width: "800px", height: "200px" }} /> : null}
                            </div>

                        </div>
                    </>}




                    {/* Giardia lamblia* */}
                    {kit.result.find(item => item['Giardia lamblia'])?.["Giardia lamblia"] === "detected" && <>
                        <div className="lastdiv">
                            <div className="firstdivhead" style={{ overflow: "hidden", marginTop: "10px" }}>
                                {/* {reportStyle.logo === YourGutMap.logo ? <img src="/logo2.png" alt="" style={{ marginTop: '10px' }} /> : null} */}
                                {/* <img src="/uper.png" alt="" /> */}
                                {/* {reportStyle.logo === YourGutMap.logo ? <img src="/uper.png" alt="" /> : null} */}
                                {styleName === 'YourGutMap' ? <img src={reportStyle.header || '/blank.png'} alt="" style={{ width: "800px", height: "160px" }} /> : null}


                            </div>
                            <div className="lastdivcenter">
                                <h1 style={{ color: "red" }}>Detected</h1>
                                <div className="texthead" style={{ background: `linear-gradient(90deg, ${reportStyle.primaryColor}, #dfe3fc, ${reportStyle.primaryColor})`, borderRadius: '50px' }}>

                                    <h2>Giardia lamblia</h2>


                                </div>

                                <div className="lastdivtext">


                                    <p> <strong>About <br /></strong>
                                        Giardia lamblia is a microscopic parasite that causes a gastrointestinal infection known as
                                        giardiasis. It is commonly transmitted through contaminated water, particularly in areas with poor
                                        sanitation, and can also spread through food or person-to-person contact. Symptoms of
                                        giardiasis typically include diarrhea (which may be foul-smelling and greasy), abdominal
                                        cramps, bloating, nausea, fatigue, and weight loss. Symptoms may appear one to three weeks
                                        after exposure and can last for several weeks to months if left untreated.</p>

                                    <p><strong>Advice<br /></strong>
                                        <ol>
                                            <li><strong>  Stay Hydrated:</strong>  Maintaining hydration is crucial, especially if you are experiencing diarrhea.
                                                Drink plenty of fluids such as water, clear broths, and oral rehydration solutions that contain
                                                electrolytes to prevent dehydration.</li>
                                            <li> <strong> Rest:</strong>  Ensure you get enough rest to allow your body to recover. Avoid strenuous activities until
                                                you feel better</li>


                                            <li> <strong>  Follow a Bland Diet: </strong> When you feel ready to eat, start with bland, easy-to-digest foods such as
                                                bananas, rice, applesauce, and toast (the BRAT diet). Avoid fatty, spicy, or high-fibre foods, as
                                                they can aggravate gastrointestinal symptoms.</li>




                                            <li> <strong>   Seek Medical Attention if Needed: </strong>  If symptoms persist for more than a few days, worsen, or if you
                                                experience severe symptoms such as prolonged diarrhoea or signs of dehydration (such as
                                                extreme thirst, dry mouth, or significantly reduced urination), consult a healthcare provider.
                                                Diagnosis may require stool tests, and treatment typically involves antibiotics or antiparasitic
                                                medications to clear the infection.
                                            </li>

                                            <li> <strong>   Good Hygiene:</strong>    To reduce the risk of spreading the infection, wash your hands thoroughly with
                                                soap and water after using the bathroom and before preparing or eating food. Be cautious with
                                                drinking water, particularly when travelling; avoid drinking untreated water or ice made from it.</li>
                                        </ol>

                                    </p>
                                    <p>
                                        Taking these measures can help manage symptoms and prevent the spread of Giardia lamblia
                                        infections.

                                    </p>




                                    <p>Our treatment and advice suggestions have been devised by Nutritional Therapists and
                                        Functional Medicine Practitioners. Any treatment protocol should only be undertaken under the
                                        supervision of a Healthcare Practitioner.<br />
                                        For persistent and/or serious symptoms, it is recommended to speak to your Doctor.
                                    </p>


                                </div>
                                <div style={{ display: 'flex', justifyContent: 'center' }}>
                                    <img style={{ marginTop: '5mm' }} src='/imgggg.pngg' alt="" />
                                </div>

                            </div>




                            <div className="secenddivend" style={{ overflow: "hidden" }}>
                                {/* {reportStyle.logo === YourGutMap.logo ? <img src="/lower.png" alt="" /> : null} */}
                                {styleName === 'YourGutMap' ? <img src={reportStyle.header || '/blank.png'} alt="" style={{ width: "800px", height: "160px" }} /> : null}

                                {/* <img src="/lower.png" alt="" /> */}
                            </div>

                        </div>
                    </>}








                </>)}
            </div >
        </div>

    </>)
}

export default Pararesults
